{
  "common": {
    "loading": "טוען...",
    "error": "שגיאה",
    "retry": "נסה שוב",
    "cancel": "ביטול",
    "save": "שמור",
    "saving": "שומר...",
    "close": "סגור",
    "back": "חזור",
    "next": "הבא",
    "search": "חיפוש",
    "watchNow": "צפה עכשיו",
    "playNow": "נגן עכשיו",
    "play": "נגן",
    "moreInfo": "מידע נוסף",
    "seeAll": "הכל",
    "new": "חדש",
    "live": "שידור חי",
    "recommended": "מומלץ",
    "edit": "ערוך",
    "delete": "מחק",
    "add": "הוסף",
    "enabled": "מופעל",
    "disabled": "כבוי",
    "invalidDate": "תאריך לא תקין",
    "appName": "🏠 בית+",
    "appVersion": "🏠 בית+ v1.0.0",
    "slogan": "הבית שלך. בכל מקום.",
    "ok": "אישור",
    "success": "הצליח",
    "warning": "אזהרה",
    "confirm": "אישור",
    "yes": "כן",
    "no": "לא",
    "apply": "החל",
    "errors": {
      "unexpected": "אירעה שגיאה בלתי צפויה"
    },
    "send": "שלח",
    "done": "סיום",
    "all": "הכל",
    "reset": "אפס",
    "deleting": "מוחק...",
    "noResults": "לא נמצאו תוצאות",
    "tryDifferentSearch": "נסה מונח חיפוש אחר",
    "previous": "הקודם",
    "actions": "פעולות",
    "pageOf": "עמוד {{page}} מתוך {{total}}",
    "noData": "אין נתונים זמינים",
    "filters": "מסננים",
    "clear": "נקה",
    "clearSelection": "נקה",
    "expand": "הרחב",
    "collapse": "כווץ",
    "upgrade": "שדרג לפרימיום",
    "skip": "דלג",
    "thisContent": "תוכן זה",
    "backToHome": "חזרה לדף הבית",
    "dismiss": "סגור",
    "goBack": "חזרה",
    "pause": "השהה",
    "tryAgain": "נסה שוב",
    "refresh": "רענון"
  },
  "culturalContext": {
    "loading": "טוען הסבר...",
    "loadError": "טעינת ההסבר נכשלה",
    "related": "הפניות קשורות"
  },
  "demo": {
    "banner": "מצב הדמו",
    "bannerSubtext": "שימוש בנתונים מדומים - ללא קריאות API",
    "days": {
      "sunday": "יום ראשון",
      "monday": "יום שני",
      "tuesday": "יום שלישי",
      "wednesday": "יום רביעי",
      "thursday": "יום חמישי",
      "friday": "יום שישי",
      "saturday": "שבת"
    },
    "shabbat": "שבת",
    "until_shabbat": "עד שבת",
    "search_interpretation": "חיפוש עבור \"{{query}}\"",
    "suggestions": {
      "0": "פאודה",
      "1": "שטיסל",
      "2": "טהרן",
      "3": "הבורר",
      "4": "עבודה ערבית"
    },
    "premium_plan": "פרימיום",
    "assistant_response": "אני ממליץ על פאודה - סדרת מתח מעולה!",
    "morning_greeting": "בוקר טוב! היום מזג האוויר נעים, יש כמה חדשות חשובות מישראל, ובחרתי לך תוכן שיתאים לך במיוחד."
  },
  "hero": {
    "watch": "צפייה",
    "moreInfo": "מידע נוסף",
    "addToList": "הוסף לרשימה"
  },
  "login": {
    "title": "ברוך שובך",
    "subtitle": "התחבר כדי להמשיך ל-Bayit+",
    "tagline": "הבית שלך בארה״ב",
    "email": "אימייל",
    "emailPlaceholder": "הזן את האימייל שלך",
    "password": "סיסמה",
    "passwordPlaceholder": "הזן את הסיסמה שלך",
    "submit": "התחברות",
    "loggingIn": "מתחבר...",
    "or": "או",
    "forgotPassword": "שכחת סיסמה?",
    "continueWithGoogle": "המשך עם Google",
    "noAccount": "אין לך חשבון?",
    "signUp": "הרשמה",
    "register": "הרשמה",
    "name": "שם",
    "termsNotice": "בהתחברות, אתה מסכים לתנאי השימוש ומדיניות הפרטיות שלנו",
    "errors": {
      "emailRequired": "דואר אלקטרוני נדרש",
      "passwordRequired": "סיסמה נדרשת",
      "loginFailed": "שגיאה בהתחברות. נסה שוב.",
      "googleFailed": "כניסה עם Google נכשלה. אנא נסה שוב.",
      "fillAllFields": "נא למלא את כל השדות"
    },
    "qrInstructions": "סרוק את הקוד עם הטלפון להתחברות מהירה",
    "methodQR": "קוד QR",
    "methodVoice": "קולי",
    "methodTraditional": "אימייל",
    "qrTitle": "סרוק להתחברות",
    "qrDescription": "סרוק את קוד ה-QR עם הטלפון להתחברות בלי להקליד",
    "expiresIn": "תוקף 5 דקות",
    "companionConnected": "הטלפון התחבר!",
    "authenticating": "מתחבר...",
    "sessionExpired": "פג תוקף",
    "refreshQR": "צור קוד חדש",
    "generatingQR": "יוצר קוד QR...",
    "howItWorks": "איך זה עובד:",
    "step1": "פתח מצלמה בטלפון",
    "step2": "סרוק את הקוד למעלה",
    "step3": "התחבר בטלפון",
    "step4": "הטלוויזיה מתחברת אוטומטית!",
    "voicePlaceholder": "הקלד את תשובתך...",
    "send": "שלח",
    "createAccount": "צור חשבון",
    "bayitThinking": "בית חושב...",
    "unexpectedError": "אירעה שגיאה בלתי צפויה"
  },
  "tvLogin": {
    "invalidQR": "קוד QR לא תקין. סרוק שוב מהטלוויזיה.",
    "sessionInvalid": "פג תוקף קוד ה-QR. צור קוד חדש בטלוויזיה.",
    "verificationFailed": "שגיאה באימות. נסה שוב.",
    "fillAllFields": "נא למלא את כל השדות",
    "loginFailed": "שגיאה בהתחברות. בדוק את הפרטים.",
    "notLoggedIn": "אינך מחובר במכשיר זה.",
    "enterCredentials": "הזן את פרטי ההתחברות לאישור הטלוויזיה.",
    "authFailed": "שגיאה באישור.",
    "verifying": "מאמת...",
    "verifyingDescription": "מתחבר לטלוויזיה...",
    "loginTitle": "התחבר לטלוויזיה",
    "loginDescription": "הזן פרטים לאישור הטלוויזיה",
    "authorizing": "מאשר...",
    "authorizingDescription": "מחבר אותך לטלוויזיה...",
    "authorizeTV": "אשר טלוויזיה",
    "success": "הצלחה!",
    "successDescription": "הטלוויזיה מחוברת. אפשר לסגור את העמוד.",
    "goToHome": "לדף הבית",
    "error": "משהו השתבש",
    "tryAgain": "נסה שוב",
    "securityNote": "הפרטים נשלחים בצורה מאובטחת ואינם נשמרים בטלוויזיה.",
    "footer": "יש בעיה? וודא שסרקת קוד QR חדש מהטלוויזיה.",
    "almostThere": "כמעט שם!",
    "authenticating": "מאמת...",
    "connected": "מחובר",
    "expired": "הקוד פג תוקף",
    "expiredMessage": "קוד ההתחברות פג תוקף. בקש קוד חדש.",
    "header": "התחבר לטלוויזיה",
    "pleaseSignIn": "התחבר בטלפון או במחשב שלך",
    "signInButton": "התחבר",
    "signInToTV": "התחבר לטלוויזיה",
    "subtitle": "הזן את הקוד המוצג על מסך הטלוויזיה",
    "tvSignedIn": "הטלוויזיה חוברה בהצלחה"
  },
  "googleLogin": {
    "cancelledError": "ההתחברות עם Google בוטלה",
    "missingCode": "קוד אימות חסר",
    "loginError": "שגיאה בהתחברות עם Google",
    "redirecting": "מעביר לדף ההתחברות...",
    "connecting": "מתחבר עם Google..."
  },
  "register": {
    "title": "יצירת חשבון",
    "subtitle": "הצטרף ל-Bayit+ כדי לצפות בתוכן המועדף עליך",
    "name": "שם מלא",
    "namePlaceholder": "דוד כהן",
    "email": "אימייל",
    "emailPlaceholder": "your@email.com",
    "password": "סיסמה",
    "passwordPlaceholder": "לפחות 8 תווים",
    "confirmPassword": "אימות סיסמה",
    "confirmPasswordPlaceholder": "הזן שוב את הסיסמה",
    "submit": "הרשמה",
    "registering": "מתבצעת הרשמה...",
    "acceptTerms": "אני מסכים ל",
    "termsOfService": "תנאי השימוש",
    "and": "ו",
    "privacyPolicy": "מדיניות הפרטיות",
    "continueWithGoogle": "הרשם עם Google",
    "haveAccount": "כבר יש לך חשבון?",
    "signIn": "התחבר",
    "fullName": "שם מלא",
    "loginLink": "התחברות",
    "placeholders": {
      "fullName": "דוד כהן",
      "email": "your@email.com",
      "password": "לפחות 8 תווים",
      "confirmPassword": "הזן שוב את הסיסמה"
    },
    "errors": {
      "nameRequired": "שם נדרש",
      "emailRequired": "אימייל נדרש",
      "passwordRequired": "סיסמה נדרשת",
      "passwordTooShort": "הסיסמה חייבת להכיל לפחות 8 תווים",
      "passwordMismatch": "הסיסמאות אינן תואמות",
      "acceptTerms": "עליך לקבל את תנאי השימוש ומדיניות הפרטיות",
      "fillAllFields": "נא למלא את כל השדות",
      "registrationFailed": "ההרשמה נכשלה. נסה שוב.",
      "googleFailed": "ההרשמה עם Google נכשלה. נסה שוב."
    }
  },
  "nav": {
    "home": "ראשי",
    "vod": "VOD",
    "liveTV": "שידור חי",
    "epg": "מדריך תוכניות",
    "radio": "רדיו",
    "podcasts": "פודקאסטים",
    "flows": "רצפים",
    "judaism": "יהדות",
    "children": "ילדים",
    "profile": "פרופיל",
    "search": "חיפוש",
    "settings": "הגדרות",
    "favorites": "מועדפים",
    "watchlist": "רשימת צפייה",
    "downloads": "הורדות",
    "recordings": "ההקלטות שלי",
    "widgets": "וידג'טים",
    "help": "עזרה ותמיכה",
    "discover": "גילוי",
    "account": "חשבון",
    "subscribe": "הרשמה למנוי",
    "plans": "מסלולים",
    "admin": "ניהול",
    "games": "משחקים",
    "friends": "חברים",
    "glossary": "מילון מונחים",
    "missions": "משימות",
    "audiobooks": "ספרי שמע",
    "playlist": "רשימת השמעה",
    "zehAniHub": "זה אני",
    "support": "תמיכה",
    "discoverHub": "גלה AI",
    "listen": "האזנה",
    "byoc": "המקורות שלי",
    "household": "משק בית",
    "messages": "הודעות",
    "myContent": "התוכן שלי",
    "social": "חברתי"
  },
  "epg": {
    "title": "מדריך תוכניות",
    "subtitle": "דפדף בלוח השידורים של הטלוויזיה",
    "gridView": "תצוגת רשת",
    "listView": "תצוגת רשימה",
    "israelTime": "שעון ישראל",
    "localTime": "שעון מקומי",
    "il": "IL",
    "local": "מקומי",
    "jumpToNow": "קפיצה לעכשיו",
    "goBack": "← {{hours}} שעות",
    "goForward": "{{hours}} שעות →",
    "toggleTimezone": "החלף אזור זמן",
    "errorTitle": "נכשל בטעינת מדריך התוכניות",
    "errorLoading": "לא ניתן לטעון את נתוני מדריך התוכניות",
    "noPrograms": "לא נמצאו תוכניות",
    "noChannels": "אין ערוצים זמינים",
    "recordProgram": "הקלט תוכנית",
    "channel": "ערוץ",
    "enableSubtitles": "הפעל כתוביות",
    "subtitleLanguage": "שפת כתוביות",
    "storageEstimate": "הערכת נפח אחסון",
    "availableSpace": "שטח פנוי",
    "lowStorage": "אזהרת אחסון נמוך",
    "lowStorageMessage": "שטח האחסון שלך מתמעט. שקול למחוק הקלטות ישנות.",
    "scheduleRecording": "קבע הקלטה",
    "scheduledRecordingNotSupported": "הקלטות מתוזמנות עדיין לא נתמכות. רק הקלטות מיידיות זמינות.",
    "recordingFailed": "נכשל בהפעלה/קביעת הקלטה",
    "smartSearch": "חיפוש חכם",
    "smartSearchSubtitle": "שאל שאלות בשפה טבעית",
    "smartSearchPlaceholder": "למשל: הצג לי את כל התוכניות עם השחקנית טלי שרון הערב",
    "searchPlaceholder": "חפש תוכניות, ערוצים, שחקנים...",
    "premiumRequired": "תכונה פרימיום",
    "premiumRequiredMessage": "חיפוש חכם משתמש בבינה מלאכותית כדי להבין את השאלות שלך. שדרג לפרימיום כדי לגשת לתכונה זו.",
    "searchWithAI": "חפש עם AI",
    "searching": "מחפש...",
    "tryThese": "נסה את הדוגמאות האלה",
    "exampleQuery1": "הצג לי את כל התוכניות עם השחקנית טלי שרון הערב",
    "exampleQuery2": "אילו תוכניות קומדיה משודרות השבוע?",
    "exampleQuery3": "מצא דוקומנטריות על היסטוריה בערוץ 11",
    "exampleQuery4": "הצג לי את כל תוכניות החדשות מחר בבוקר",
    "aiDisclaimer": "מופעל על ידי Claude AI. התוצאות עשויות להשתנות בהתאם לזמינות נתוני התוכניות.",
    "interpretationTitle": "מה הבנתי",
    "noResultsFound": "לא נמצאו תוכניות התואמות לשאילתה שלך"
  },
  "home": {
    "continueWatching": "המשך צפייה",
    "featuredContent": "מומלצים",
    "liveTV": "שידור חי",
    "allChannels": "לכל הערוצים",
    "liveChannels": "ערוצים בשידור חי",
    "showOnlyWithSubtitles": "הצג רק עם כתוביות",
    "israeliMovies": "סרטים ישראליים",
    "israeli-movies": "סרטים ישראליים",
    "israeli-series": "סדרות ישראליות",
    "action": "אקשן ומתח",
    "comedy": "קומדיה",
    "drama": "דרמה",
    "documentaries": "דוקומנטרים",
    "loadingContent": "טוען תוכן...",
    "liveNow": "עכשיו בשידור",
    "trendingInIsrael": "פופולרי בישראל",
    "jerusalemConnection": "חיבור ירושלים",
    "telAvivConnection": "חיבור תל אביב",
    "categories": "קטגוריות",
    "nearYou": "ישראלים בקרבתך",
    "betaExclusive": "בלעדי לבטא",
    "carousel": {
      "fauda": {
        "title": "פאודה",
        "subtitle": "עונה 4 - עכשיו בשידור",
        "description": "הסדרה הישראלית המצליחה חוזרת לעונה רביעית מלאת מתח ואקשן"
      },
      "shtisel": {
        "title": "שטיסל",
        "subtitle": "כל העונות זמינות",
        "description": "עקבו אחר משפחת שטיסל בשכונה החרדית בירושלים"
      },
      "tehran": {
        "title": "טהרן",
        "subtitle": "עונה 2",
        "description": "סוכנת מוסד בלב איראן במשימה מסוכנת"
      },
      "live": {
        "title": "שידור חי - כאן 11",
        "subtitle": "צפו עכשיו",
        "description": "חדשות, תוכניות אקטואליה ותוכן איכותי"
      }
    },
    "enableLocation": "הפעל מיקום",
    "locationPermissionDeniedDescription": "גישה למיקום נדחתה. הפעל בהגדרות כדי לראות תוכן קרוב אליך.",
    "locationPermissionDescription": "אפשר גישה למיקום כדי לגלות תוכן קרוב אליך.",
    "openSettings": "פתח הגדרות"
  },
  "search": {
    "title": "חיפוש",
    "subtitle": "מצא סרטים, סדרות, ערוצים, תחנות רדיו ופודקאסטים",
    "placeholder": "חפש תוכן...",
    "voicePlaceholder": "דבר עכשיו...",
    "searching": "מחפש...",
    "listening": "מאזין...",
    "noResults": "לא נמצאו תוצאות",
    "noResultsHint": "נסה מילים אחרות או שנה את הסינון",
    "tryDifferent": "נסה מילות חיפוש אחרות",
    "resultsFor": "תוצאות עבור",
    "resultsFound": "נמצאו {{count}} תוצאות עבור \"{{query}}\"",
    "recentSearches": "חיפושים אחרונים",
    "clearAll": "נקה הכל",
    "trending": "חיפושים פופולריים",
    "promptTitle": "מה אתה מחפש?",
    "promptDescription": "חפש את התוכן האהוב עליך או השתמש בחיפוש קולי",
    "filters": {
      "all": "הכל",
      "vod": "סרטים וסדרות",
      "live": "ערוצים",
      "radio": "רדיו",
      "podcast": "פודקאסטים",
      "moviesAndSeries": "סרטים וסדרות",
      "channels": "ערוצים",
      "podcasts": "פודקאסטים"
    },
    "suggestions": {
      "movies": "סרטים",
      "series": "סדרות",
      "liveTV": "טלוויזיה חיה",
      "news": "חדשות",
      "sports": "ספורט",
      "kids": "ילדים"
    }
  },
  "liveTV": {
    "title": "טלוויזיה חיה",
    "channels": "ערוצים",
    "nowPlaying": "עכשיו בשידור",
    "loadError": "שגיאה בטעינת הערוצים",
    "categories": {
      "all": "הכל",
      "news": "חדשות",
      "sports": "ספורט",
      "entertainment": "בידור",
      "kids": "ילדים",
      "documentary": "דוקומנטרי"
    }
  },
  "listen": {
    "title": "האזנה",
    "subtitle": "רדיו, פודקאסטים וספרי שמע",
    "tab": {
      "radio": "רדיו",
      "podcasts": "פודקאסטים",
      "audiobooks": "ספרי שמע"
    }
  },
  "radio": {
    "title": "תחנות רדיו",
    "categories": {
      "all": "הכל",
      "music": "מוזיקה",
      "news": "חדשות",
      "talk": "שיחה",
      "jewish": "יהודי"
    },
    "noStations": "אין תחנות רדיו זמינות",
    "tryLater": "נסה שוב מאוחר יותר",
    "playing": "מתנגן",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "פודקאסטים",
    "episodes": "פרקים",
    "categories": {
      "all": "הכל",
      "general": "כללי",
      "news": "חדשות",
      "politics": "פוליטיקה",
      "tech": "טכנולוגיה",
      "business": "עסקים",
      "jewish": "יהדות",
      "entertainment": "בידור",
      "sports": "ספורט",
      "history": "היסטוריה",
      "educational": "חינוכי"
    },
    "noPodcasts": "אין פודקאסטים זמינים",
    "tryLater": "נסה שוב מאוחר יותר",
    "playLatest": "נגן אחרון"
  },
  "vod": {
    "title": "סרטים וסדרות",
    "movies": "סרטים",
    "series": "סדרות",
    "searchPlaceholder": "חפש סרטים וסדרות...",
    "noMovies": "לא נמצאו סרטים",
    "noSeries": "לא נמצאו סדרות",
    "loadError": "שגיאה בטעינת התוכן",
    "showOnlyWithSubtitles": "הצג רק עם כתוביות",
    "categories": {
      "all": "הכל",
      "drama": "דרמה",
      "comedy": "קומדיה",
      "action": "אקשן",
      "documentary": "דוקומנטרי",
      "kids": "ילדים"
    },
    "allCategories": "הכל",
    "emptyTitle": "אין תוכן זמין",
    "emptyDescription": "נסה לבחור קטגוריה אחרת",
    "allContent": "כל התוכן",
    "noContent": "אין תוכן זמין",
    "noContentInCategory": "לא נמצא תוכן בקטגוריה זו"
  },
  "account": {
    "title": "החשבון שלי",
    "profile": "פרופיל",
    "settings": "הגדרות",
    "subscription": "מנוי",
    "manageSubscription": "נהל מנוי",
    "personalDetails": "פרטים אישיים",
    "billing": "חיוב ותשלום",
    "logout": "התנתק",
    "login": "התחבר",
    "register": "הרשמה",
    "email": "אימייל",
    "password": "סיסמה",
    "name": "שם",
    "guest": "אורח",
    "premium": "פרימיום",
    "basic": "בסיסי"
  },
  "flows": {
    "title": "רצפים",
    "subtitle": "חוויות תוכן מותאמות אישית לכל רגע",
    "activeNow": "פעיל עכשיו",
    "start": "התחל",
    "skipToday": "דלג היום",
    "systemFlows": "רצפים מוכנים",
    "customFlows": "הרצפים שלי",
    "system": "מערכת",
    "noCustomFlows": "אין עדיין רצפים מותאמים",
    "createHint": "צור את הרצף האישי הראשון שלך",
    "createCustom": "צור רצף מותאם",
    "createFlow": "צור רצף",
    "editFlow": "ערוך רצף",
    "type": "סוג",
    "systemFlow": "רצף מערכת",
    "customFlow": "רצף מותאם",
    "schedule": "לוח זמנים",
    "content": "תוכן",
    "items": "פריטים",
    "aiGenerated": "נוצר ע״י AI",
    "autoPlay": "ניגון אוטומטי",
    "aiEnabled": "אוצרות AI",
    "shabbatTrigger": "ליל שבת",
    "manual": "ידני",
    "flowName": "שם הרצף",
    "flowNamePlaceholder": "לדוגמה: שגרת הבוקר שלי",
    "description": "תיאור",
    "descriptionPlaceholder": "למה מיועד הרצף הזה?",
    "startTime": "שעת התחלה",
    "endTime": "שעת סיום",
    "actions": "פעולות",
    "details": "פרטים",
    "createFlowDesc": "עצב את חוויית התוכן המותאמת שלך",
    "editFlowDesc": "עדכן את הגדרות הרצף והתוכן",
    "basicInfo": "מידע בסיסי",
    "options": "אפשרויות",
    "autoPlayDesc": "נגן אוטומטית את הפריט הבא כשהנוכחי מסתיים",
    "aiEnabledDesc": "תן ל-AI לאצור תוכן לפי ההעדפות שלך",
    "startFlow": "התחל רצף",
    "deleteFlow": "מחק רצף",
    "custom": "מותאם אישית",
    "morning": "בוקר",
    "evening": "ערב",
    "shabbat": "שבת",
    "addContent": "הוסף תוכן",
    "contentPicker": {
      "title": "הוסף תוכן לרצף",
      "tabs": {
        "live": "טלוויזיה חיה",
        "radio": "רדיו",
        "vod": "לפי דרישה",
        "podcast": "פודקאסטים"
      },
      "search": "חפש תוכן...",
      "selected": "{{count}} נבחרו",
      "addSelected": "הוסף נבחרים",
      "noResults": "לא נמצא תוכן",
      "alreadyAdded": "כבר ברצף",
      "loadMore": "טען עוד"
    },
    "flowItems": {
      "title": "תוכן הרצף",
      "empty": "אין עדיין תוכן. לחץ על הוסף תוכן כדי להתחיל.",
      "count": "{{count}} פריטים",
      "remove": "הסר",
      "moveUp": "הזז למעלה",
      "moveDown": "הזז למטה",
      "order": "סדר",
      "confirmRemove": "לחץ שוב לאישור ההסרה",
      "maxReached": "הגעת למקסימום {{max}} פריטים",
      "more": "פריטים נוספים"
    },
    "days": {
      "sunday": "ראשון",
      "monday": "שני",
      "tuesday": "שלישי",
      "wednesday": "רביעי",
      "thursday": "חמישי",
      "friday": "שישי",
      "saturday": "שבת",
      "sundayShort": "א",
      "mondayShort": "ב",
      "tuesdayShort": "ג",
      "wednesdayShort": "ד",
      "thursdayShort": "ה",
      "fridayShort": "ו",
      "saturdayShort": "ש",
      "selectAll": "בחר הכל",
      "deselectAll": "בטל בחירה",
      "title": "ימים פעילים",
      "everyday": "כל יום",
      "everyDay": "כל יום",
      "weekdays": "ימי חול",
      "weekends": "סופי שבוע",
      "noneSelected": "לא נבחרו ימים",
      "selectedCount": "{{count}} ימים נבחרו"
    },
    "trigger": {
      "type": "סוג טריגר",
      "time": "לפי זמן",
      "shabbat": "ליל שבת",
      "holiday": "חג",
      "skipShabbat": "דלג בשבת",
      "skipShabbatDesc": "אל תפעיל רצף זה בערב שבת או בשבת",
      "shabbatOffset": "דקות לפני הדלקת נרות",
      "shabbatOffsetDesc": "כמה דקות לפני השבת הרצף יתחיל?",
      "calculatedTime": "זמן מחושב",
      "thisWeek": "השבוע: {{day}} ב-{{time}}",
      "comingSoon": "טריגרים לחגים בקרוב",
      "locationBased": "זמנים לפי מיקומך"
    },
    "examples": {
      "title": "רצפים לדוגמה",
      "subtitle": "לחץ להשתמש כתבנית",
      "morningRoutine": {
        "name": "שגרת בוקר",
        "desc": "התחל את היום עם חדשות, מזג אוויר ותוכן מעודד"
      },
      "eveningWindDown": {
        "name": "רגיעה ערבית",
        "desc": "נרגע עם מוזיקה רגועה ובידור קליל"
      },
      "shabbatPrep": {
        "name": "הכנות לשבת",
        "desc": "צור אווירה לשבת עם תוכן מיוחד"
      },
      "coffeeBreak": {
        "name": "הפסקת קפה",
        "desc": "בידור מהיר להפסקה קצרה"
      },
      "sunsetVibes": {
        "name": "אווירת שקיעה",
        "desc": "רגיעה בסוף השבוע עם מוזיקה ותוכן אווירתי"
      }
    },
    "aiBrief": "סיכום AI",
    "aiBriefDesc": "קבל סיכום מותאם אישית שנוצר ע״י AI לפני תחילת הרצף",
    "aiBriefEnabled": "סיכום AI מופעל",
    "validation": {
      "nameRequired": "שם הרצף נדרש",
      "startTimeRequired": "שעת התחלה נדרשת לטריגר לפי זמן",
      "endTimeRequired": "שעת סיום נדרשת",
      "timeRange": "שעת הסיום חייבת להיות אחרי שעת ההתחלה",
      "daysRequired": "בחר לפחות יום אחד",
      "contentRequired": "הוסף תוכן או הפעל AI"
    },
    "tv": {
      "useCompanion": "להתאמה מלאה, השתמש באפליקציית Bayit+ בטלפון או בקר ב-bayit.plus במחשב."
    }
  },
  "profile": {
    "title": "הפרופיל שלי",
    "profileDetails": "פרטי פרופיל",
    "name": "שם",
    "notSet": "לא הוגדר",
    "email": "אימייל",
    "editProfile": "ערוך פרופיל",
    "notificationSettings": "הגדרות התראות",
    "security": "אבטחה",
    "changePassword": "שנה סיסמה",
    "updatePassword": "עדכן את הסיסמה שלך",
    "connectedDevices": "מכשירים מחוברים",
    "manageDevices": "נהל את המכשירים המחוברים לחשבון",
    "twoFactorAuth": "אימות דו-שלבי",
    "addExtraSecurity": "הוסף שכבת אבטחה נוספת",
    "address": {
      "line1": "רחוב הראשי 123",
      "line2": "תל אביב, ישראל 6100000"
    },
    "free": "חינם",
    "premiumPrice": "₪29.90/חודש",
    "familyPrice": "₪49.90/חודש",
    "remaining": "נותרו",
    "tabs": {
      "personal": "אישי",
      "overview": "סקירה כללית",
      "subscription": "מנוי",
      "notifications": "התראות",
      "security": "אבטחה",
      "ai": "AI וקול",
      "voice": "קול ונגישות"
    },
    "subscription": {
      "currentPlan": "התוכנית הנוכחית",
      "renewsOn": "מתחדשת בתאריך",
      "manageSubscription": "נהל מנוי",
      "cancelSubscription": "בטל מנוי",
      "noActivePlan": "אין מנוי פעיל",
      "selectPlan": "בחר תוכנית"
    },
    "notifications": "התראות",
    "ai": {
      "title": "בינה מלאכותית והתאמה אישית",
      "description": "הגדר תכונות מונעות בינה מלאכותית",
      "assistant": "עוזר AI",
      "assistantDesc": "המלצות מותאמות אישית ועזרה",
      "chatbot": "עוזר AI",
      "chatbotEnabled": "הפעל עוזר AI",
      "chatbotEnabledDesc": "קבל עזרה בניווט בתוכן",
      "saveHistory": "שמור היסטוריית שיחות",
      "saveHistoryDesc": "זכור שיחות קודמות",
      "recommendations": "המלצות",
      "personalizedRecs": "המלצות מותאמות אישית",
      "personalizedRecsDesc": "הצעות תוכן בהתבסס על היסטוריה",
      "privacy": "פרטיות ונתונים",
      "privacyDesc": "הנתונים שלך מוצפנים ומאובטחים",
      "dataConsent": "ניתוח שימוש",
      "dataConsentDesc": "עזור לשפר תכונות AI",
      "privacyNote": "הנתונים שלך מוצפנים ומאובטחים"
    },
    "voice": {
      "title": "שליטה קולית",
      "description": "ניווט ללא ידיים",
      "enabled": "פקודות קוליות",
      "enabledDesc": "שלוט באפליקציה עם הקול שלך",
      "tts": "טקסט לדיבור",
      "ttsDesc": "תגובות AI מושמעות בקול",
      "wakeWord": "זיהוי מילת הפעלה",
      "wakeWordDesc": "אמור \"בית\" להפעלה",
      "operationMode": "מצב ההפעלה",
      "operationModeDesc": "בחר כיצד תשתמש באפליקציה",
      "voiceSearch": "חיפוש קולי",
      "voiceSearchEnabled": "הפעל חיפוש קולי",
      "voiceSearchEnabledDesc": "חפש תוכן באמצעות הקול שלך",
      "constantListening": "מצב האזנה קבועה",
      "constantListeningDesc": "האזנה רציפה לפקודות קוליות ללא לחיצה על כפתור",
      "constantListeningPrivacy": "אודיו נשלח לשרתים רק כשמזוהה דיבור",
      "holdButtonMode": "לחץ והחזק לדיבור",
      "holdButtonModeDesc": "לחץ והחזק את כפתור המיקרופון במקום האזנה קבועה",
      "sensitivity": "רגישות זיהוי קול",
      "sensitivityDesc": "התאם את רמת התגובה של זיהוי הקול",
      "sensitivityLow": "נמוכה (פחות התרעות שווא)",
      "sensitivityMedium": "בינונית (מאוזן)",
      "sensitivityHigh": "גבוהה (הכי רגיש)",
      "silenceThreshold": "זיהוי שקט",
      "silenceThresholdDesc": "כמה זמן לחכות אחרי דיבור לפני עיבוד",
      "language": "שפת קול",
      "accessibility": "נגישות",
      "autoSubtitle": "הפעל כתוביות אוטומטית",
      "autoSubtitleDesc": "הצג כתוביות אוטומטית בעת השמעת תוכן",
      "highContrast": "מצב ניגודיות גבוהה",
      "highContrastDesc": "הגבר ניגודיות לראות טובה יותר",
      "textSize": "גודל טקסט",
      "textSizeSmall": "קטן",
      "textSizeMedium": "בינוני",
      "textSizeLarge": "גדול",
      "voiceOnlyInfo": "מצב קולי בלבד",
      "voiceOnlyDetails": "אמור \"Hi Bayit\" להפעלה. שלט רחוק מבוטל. ניווט מלא דרך פקודות קוליות.",
      "hybridInfo": "מצב היברידי",
      "hybridDetails": "שימוש בקול או בשלט רחוק. משוב קולי על פעולות ללא קול.",
      "classicInfo": "מצב קלאסי",
      "classicDetails": "כל התכונות הקוליות מבוטלות. שלט רחוק בלבד.",
      "textToSpeech": "תגובות קוליות",
      "ttsEnabled": "אפשר תגובות קוליות",
      "ttsEnabledDesc": "היישום ישתמע תגובות לפקודות הקול שלך",
      "ttsVolume": "עוצמת קול",
      "ttsSpeed": "מהירות דיבור",
      "hybridFeedback": "משוב אינטראקטיבי",
      "voiceFeedback": "משוב קולי על פעולות",
      "voiceFeedbackDesc": "קבל אישור קולי כשאתה משתמש בשלט רחוק או לוחץ על כפתורים",
      "feedbackExample": "דוגמה: לחץ על סרט → היישום אומר \"מנגן [שם הסרט]\""
    },
    "dropdown": {
      "myProfile": "הפרופיל שלי",
      "subscription": "מנוי",
      "favorites": "מועדפים",
      "downloads": "הורדות",
      "signOut": "התנתק"
    },
    "guest": "אורח",
    "morningRitual": "טקס הבוקר",
    "watchlist": "רשימת צפייה",
    "favorites": "מועדפים",
    "downloads": "הורדות",
    "settings": "הגדרות",
    "language": "שפה",
    "admin": "ניהול",
    "watchTime": "זמן צפייה",
    "minutes": "דקות",
    "hours": "שעות",
    "logout": "התנתק",
    "premium": "פרימיום",
    "basic": "בסיסי",
    "upgrade": "שדרג לפרימיום",
    "memberSince": "חבר מאז",
    "aiAssistant": "עוזר AI",
    "voiceSettings": "קול",
    "subscriptionButton": "מנוי",
    "recentActivity": "פעילות אחרונה",
    "justNow": "ממש עכשיו",
    "hoursAgo": "לפני {{hours}} שעות",
    "yesterday": "אתמול",
    "noRecentActivity": "אין פעילות אחרונה",
    "accountInfo": "פרטי חשבון",
    "role": "תפקיד",
    "accountSecurity": "אבטחת חשבון",
    "securityNote": "החשבון שלך מאובטח עם הצפנת אימות",
    "lastLogin": "התחברות אחרונה",
    "dangerZone": "אזור מסוכן",
    "invalidImageType": "אנא בחר קובץ תמונה תקין (JPEG, PNG, WebP או GIF)",
    "imageTooLarge": "התמונה גדולה מדי. גודל מקסימלי הוא 5MB.",
    "uploadSuccess": "התמונה עודכנה בהצלחה!",
    "uploadFailed": "העלאת התמונה נכשלה. אנא נסה שוב.",
    "complimentaryPremium": "גישת פרימיום בחינם",
    "emailVerified": "האימייל אומת",
    "emailUnverified": "האימייל לא אומת",
    "phoneVerified": "הטלפון אומת",
    "phoneUnverified": "הטלפון לא אומת",
    "completeVerification": "השלם אימות כדי לפתוח את כל התכונות",
    "unlockPremium": "פתח תכונות פרימיום",
    "unlockPremiumDescription": "שדרג כדי ליהנות מתוכן ותכונות בלעדיות"
  },
  "voiceMode": {
    "voiceOnly": "קולי בלבד",
    "voiceOnlyDesc": "ללא שלט רחוק - ניווט מלא דרך קול",
    "hybrid": "היברידי",
    "hybridDesc": "קול + שלט רחוק - משוב קולי על פעולות",
    "classic": "קלאסי",
    "classicDesc": "ללא קול - שלט רחוק בלבד"
  },
  "settings": {
    "title": "הגדרות",
    "language": "שפה",
    "appLanguage": "שפת האפליקציה",
    "selectLanguage": "בחר שפה",
    "languages": {
      "en": "אנגלית",
      "he": "עברית",
      "es": "ספרדית",
      "zh": "中文",
      "fr": "צרפתית",
      "it": "איטלקית",
      "hi": "הינדי",
      "ta": "טמילית",
      "bn": "בנגלית",
      "ja": "日本語"
    },
    "chatTranslation": "תרגום צ'אט",
    "autoTranslate": "תרגום אוטומטי של הודעות",
    "autoTranslateDescription": "תרגם אוטומטית הודעות צ'אט לשפה המועדפת עליך",
    "notifications": "התראות",
    "pushNotifications": "התראות פוש",
    "playback": "ניגון",
    "quality": "איכות",
    "subtitles": "כתוביות",
    "autoplay": "ניגון אוטומטי",
    "appearance": "מראה",
    "darkMode": "מצב כהה",
    "privacy": "פרטיות",
    "privacyPolicy": "מדיניות פרטיות",
    "termsOfService": "תנאי שימוש",
    "about": "אודות",
    "display": "תצוגה",
    "homePageSections": "סעיפי דף הבית",
    "configureSections": "הגדר אילו סעיפים יופיעו בדף הבית שלך",
    "visibleSections": "סעיפים גלויים",
    "hiddenSections": "סעיפים מוסתרים",
    "dragToReorder": "גרור לסידור מחדש",
    "tapToHide": "לחץ להסתרה",
    "tapToShow": "לחץ להצגה",
    "resetToDefault": "אפס לברירת מחדל",
    "resetConfirmMessage": "האם אתה בטוח שברצונך לאפס את סעיפי דף הבית לתצורה המקורית?",
    "sectionHidden": "הסעיף הוסתר",
    "sectionShown": "הסעיף מוצג",
    "replayTour": "הצג מחדש את סיור התכונות"
  },
  "help": {
    "subtitle": "איך נוכל לעזור לך?",
    "email": "תמיכה באימייל",
    "phone": "תמיכה טלפונית",
    "chat": "צ'אט חי",
    "chatAvailable": "זמין 24/7",
    "openTooltip": "פתח טיפ עזרה",
    "openHelp": "פתח תפריט עזרה",
    "howTo": "איך להשתמש",
    "relatedArticles": "מאמרים קשורים",
    "stillNeedHelp": "עדיין צריך עזרה?",
    "contactSupport": "צור קשר עם התמיכה",
    "previous": "הקודם",
    "next": "הבא",
    "getStarted": "התחל",
    "skipTutorial": "דלג על ההדרכה",
    "actions": {
      "search": "חיפוש",
      "docs": "תיעוד",
      "faq": "שאלות נפוצות",
      "support": "תמיכה",
      "tutorial": "הדרכה"
    },
    "search": {
      "placeholder": "חפש בעזרה...",
      "noResults": "לא נמצאו תוצאות עבור \"{{query}}\"",
      "noResultsHint": "נסה מילות מפתח אחרות או עיין בקטגוריות",
      "recent": "חיפושים אחרונים",
      "popular": "חיפושים פופולריים"
    },
    "categories": {
      "getting-started": "התחלה",
      "features": "תכונות",
      "judaism": "יהדות",
      "platform-guides": "מדריכי פלטפורמה",
      "account": "חשבון",
      "troubleshooting": "פתרון בעיות",
      "parents": "להורים",
      "admin": "מנהלים",
      "developer": "מפתחים"
    },
    "faq": {
      "title": "שאלות נפוצות",
      "q1": "איך משנים תוכנית מנוי?",
      "a1": "עברו להגדרות > מנוי כדי לצפות ולשנות את התוכנית הנוכחית. אפשר לשדרג או להוריד דרגה בכל עת.",
      "q2": "איך מורידים תוכן לצפייה אופליין?",
      "a2": "לחצו על אייקון ההורדה בכל תוכן כדי לשמור אותו לצפייה אופליין. ההורדות זמינות במכשירים ניידים בלבד.",
      "q3": "למה הסרטון לא מתנגן?",
      "a3": "בדקו את חיבור האינטרנט. אם הבעיה נמשכת, נסו לנקות את מטמון האפליקציה או להפעיל מחדש.",
      "q4": "איך מבטלים מנוי?",
      "a4": "אפשר לבטל את המנוי בכל עת דרך הגדרות > מנוי > ביטול תוכנית. הגישה תישמר עד סוף תקופת החיוב."
    },
    "onboarding": {
      "welcome": {
        "title": "ברוכים הבאים ל-Bayit+",
        "description": "הפלטפורמה המקיפה שלך לבידור יהודי וסטרימינג משפחתי."
      },
      "liveTv": {
        "title": "צפו בטלוויזיה חיה",
        "description": "התכוונו למאות ערוצים חיים עם מדריך תוכניות אלקטרוני אינטראקטיבי."
      },
      "vod": {
        "title": "תוכן לפי דרישה",
        "description": "דפדפו באלפי סרטים, סדרות ותוכניות לפי הזמן שלכם."
      },
      "voice": {
        "title": "שליטה קולית",
        "description": "אמרו \"היי ג'רוויס\" או לחצו על כפתור המיקרופון לשליטה ללא ידיים."
      },
      "profiles": {
        "title": "פרופילים משפחתיים",
        "description": "צרו פרופילים מותאמים אישית לכל בן משפחה עם בקרת הורים."
      }
    }
  },
  "voice": {
    "panelTitle": "עוזר קולי",
    "typeCommand": "הקלד פקודה...",
    "controlExecuted": "בוצע: {{action}}",
    "timerSet": "טיימר הוגדר ל-{{amount}} {{unit}}",
    "chatPending": "מעבד את ההודעה שלך...",
    "suggestion": {
      "watchLive": "צפה בטלוויזיה חיה",
      "search": "חפש תוכן",
      "listenRadio": "האזן לרדיו"
    },
    "error": {
      "micDenied": "הגישה למיקרופון נדחתה",
      "notSupported": "פקודות קוליות אינן נתמכות בדפדפן זה",
      "recognitionFailed": "לא הצלחתי להבין. נסה שוב."
    }
  },
  "errors": {
    "networkError": "שגיאת רשת",
    "loadingFailed": "טעינה נכשלה",
    "tryAgain": "נסה שוב",
    "offline": {
      "title": "אין חיבור לאינטרנט",
      "message": "אתה במצב לא מקוון כרגע. חלק מהתכונות עשויות שלא להיות זמינות.",
      "ttsMessage": "אין חיבור לאינטרנט. אתה כעת במצב לא מקוון."
    },
    "online": {
      "title": "החיבור שוחזר",
      "message": "אתה מחובר מחדש.",
      "ttsMessage": "חיבור האינטרנט שוחזר."
    },
    "api": {
      "badRequest": "משהו השתבש. אנא נסה שוב.",
      "unauthorized": "אנא התחבר כדי להמשיך.",
      "forbidden": "אין לך הרשאה לגשת לתוכן זה.",
      "notFound": "התוכן שאתה מחפש אינו זמין.",
      "rateLimit": "אתה מבצע יותר מדי בקשות. אנא המתן רגע.",
      "serverError": "השרתים שלנו נתקלים בבעיות. אנא נסה שוב מאוחר יותר.",
      "unknown": "משהו השתבש. אנא נסה שוב.",
      "networkTimeout": "לא ניתן להתחבר לשרתים שלנו. אנא בדוק את החיבור שלך.",
      "offlineMessage": "אתה במצב לא מקוון. אנא בדוק את חיבור האינטרנט שלך.",
      "requestFailed": "משהו השתבש. אנא נסה שוב."
    },
    "voice": {
      "permissionDenied": "נדרשת גישה למיקרופון לפקודות קוליות. אנא הפעל אותה בהגדרות.",
      "recognitionFailed": "לא הבנתי את זה. אנא נסה שוב.",
      "commandFailed": "הפקודה הקולית נכשלה. אנא נסה שוב."
    },
    "widget": {
      "loadFailed": "לא ניתן לטעון את הווידג'ט. אנא נסה שוב."
    },
    "buttons": {
      "ok": "אישור",
      "retry": "נסה שוב",
      "cancel": "ביטול"
    },
    "title": "שגיאה",
    "networkUnavailable": "הרשת אינה זמינה",
    "no_audio_url": "כתובת אודיו לא זמינה",
    "connection_failed": "החיבור נכשל",
    "quota_exceeded": "המכסה הושגה",
    "server_error": "שגיאת שרת"
  },
  "player": {
    "loading": "טוען...",
    "retry": "נסה שוב",
    "error": "שגיאה בהפעלת הווידאו",
    "back": "← חזור",
    "liveBadge": "שידור חי",
    "noStream": "הזרם אינו זמין",
    "loadError": "שגיאה בטעינת הזרם",
    "settings": "הגדרות",
    "subtitles": "כתוביות",
    "playbackSpeed": "מהירות ניגון",
    "quality": "איכות",
    "auto": "אוטומטי",
    "previousChapter": "פרק קודם",
    "nextChapter": "פרק הבא",
    "skipBackward": "קפוץ 30 שניות אחורה",
    "skipForward": "קפוץ 30 שניות קדימה",
    "restart": "התחל מההתחלה",
    "subtitlesOff": "כבוי",
    "speed": "מהירות",
    "subscription": {
      "requiredTitle": "נדרשת הנתקה",
      "requiredMessage": "דורש מנוי בתשלום",
      "upgradeInfo": "שדרג את המנוי שלך כדי לגשת לתוכן פרימיום",
      "upgrade": "שדרג כעת"
    },
    "ai": {
      "dub": "דיבוב",
      "dubbing": "דיבוב",
      "featuresTitle": "תכונות AI",
      "languagePrimary": "ראשית",
      "languageSecondary": "משנית (אופציונלי)",
      "languageTitle": "שפת AI",
      "liveTranslate": "תרגום חי",
      "selectLanguage": "בחר שפה",
      "split": "מפוצל",
      "togglePanel": "הצג/הסתר לוח AI",
      "translate": "תרגם",
      "trivia": "טריוויה",
      "triviaToggle": "טריוויה"
    },
    "catchup": {
      "description": "פספסת את ההתחלה? קבל סיכום מבוסס AI של מה שקרה עד כה.",
      "generateSummary": "צור סיכום",
      "summaryTitle": "סיכום",
      "title": "השלמה",
      "keyPoints": "נקודות מפתח",
      "transcript": "תמליל"
    },
    "chat": {
      "title": "צ'אט חי",
      "messagePlaceholder": "כתוב הודעה..."
    },
    "companion": {
      "noContext": "אין הקשר תרבותי זמין לתוכן זה עדיין.",
      "quizComplete": "החידון הסתיים",
      "quizRetry": "נסה שוב",
      "quizStart": "התחל חידון",
      "quizTitle": "מוכן לבדוק את הידע שלך?",
      "quizTryAgain": "נסה שוב",
      "tabContext": "הקשר",
      "tabQuiz": "חידון",
      "tabVocabulary": "אוצר מילים",
      "tapWords": "הקש על מילים בכתוביות כדי להוסיף אותן כאן",
      "title": "מלווה AI",
      "loadError": "טעינת נתוני הלמידה נכשלה"
    },
    "controls": {
      "audioTrack": "רצועת שמע",
      "continueWatching": "המשך צפייה",
      "dismiss": "סגור",
      "goBack": "חזרה",
      "navigateBack": "חזור אחורה",
      "on": "פעיל",
      "pause": "השהה",
      "play": "נגן",
      "preview": "תצוגה מקדימה",
      "selected": "נבחר",
      "send": "שלח",
      "skip": "דלג",
      "close": "סגור",
      "exitFullscreen": "צא ממסך מלא",
      "fullscreen": "מסך מלא",
      "restart": "התחל מחדש",
      "skipBackward": "דלג אחורה",
      "skipForward": "דלג קדימה",
      "volume": "עוצמת שמע"
    },
    "dubbing": {
      "notNow": "לא עכשיו",
      "premiumMessage": "דיבוב חי דורש מנוי פרימיום או בטא 500",
      "premiumTitle": "תכונת פרימיום",
      "upgrade": "שדרג",
      "voiceTitle": "קול דיבוב",
      "settings_title": "הגדרות דיבוב חי",
      "target_language": "שפת יעד"
    },
    "errors": {
      "streamLimitMessage": "הגעת למקסימום {{maxStreams}} שידורים בו-זמנית. אנא הפסק שידור אחר או שדרג את התוכנית שלך.",
      "streamLimitTitle": "הגבלת שידורים",
      "upgradePlan": "שדרג תוכנית"
    },
    "audio_description": "תיאור שמע",
    "dismiss": "סגור",
    "scene_search": "חיפוש סצנה",
    "search_placeholder": "חפש סצנה...",
    "language_ratio": "יחס למידת שפה",
    "go_back": "חזור",
    "sleepTimer": {
      "title": "טיימר שינה",
      "subtitle": "השהה ניגון אוטומטית לאחר זמן מוגדר",
      "minutes": "{{count}} דק'",
      "customPlaceholder": "דקות מותאמות אישית",
      "set": "הגדר טיימר",
      "remaining": "שינה בעוד {{time}}",
      "extend": "+15 דק'",
      "cancel": "בטל טיימר",
      "off": "כבוי",
      "setTimer": "הגדר טיימר שינה"
    },
    "openSubs": {
      "title": "חיפוש כתוביות",
      "searchPlaceholder": "חפש לפי כותרת...",
      "search": "חפש",
      "searchFailed": "החיפוש נכשל. נסה שוב.",
      "downloads": "{{count}} הורדות",
      "noResults": "לא נמצאו כתוביות"
    },
    "dialogue": {
      "cancel": "ביטול",
      "close": "סגור",
      "placeholder": "הקלד את ההודעה שלך...",
      "selectCharacter": "בחר דמות",
      "send": "שלח",
      "sharedSession": "מפגש משותף",
      "waitingForTurn": "ממתין לתורך...",
      "yourAvatar": "האווטאר שלך"
    },
    "interaction": {
      "next": "הבא",
      "previous": "הקודם",
      "skip": "דלג",
      "start": "התחל אינטראקציה",
      "window": "חלון אינטראקציה: {{duration}} שניות"
    },
    "pauseAsk": {
      "askAgain": "שאל שוב",
      "placeholder": "שאל על הסצנה הזו...",
      "resume": "המשך",
      "resumeMovie": "המשך סרט",
      "selectCharacter": "בחר דמות",
      "title": "השהה ושאל"
    },
    "phraseBreakdown": {
      "literal": "תרגום מילולי",
      "meaning": "משמעות",
      "origin": "מקור",
      "funFact": "עובדה מעניינת",
      "usage": "שימוש: {{level}}"
    },
    "translation": {
      "example": "דוגמה:",
      "arrow": "←"
    },
    "subtitleMode": {
      "title": "מצב כתוביות",
      "modes": {
        "regular": {
          "name": "רגיל",
          "description": "כתוביות עבריות סטנדרטיות ללא ניקוד"
        },
        "nikud": {
          "name": "ניקוד",
          "description": "עברית עם ניקוד לקריאה קלה יותר"
        },
        "shoresh": {
          "name": "שורש",
          "description": "לימוד מבוסס שורשים עם הדגשת מקורות מילים"
        },
        "engrew": {
          "name": "אנגרו",
          "description": "תעתיק אנגלי עם הקשר עברי"
        },
        "heblish": {
          "name": "עברלית",
          "description": "אנגלית עם מונחים עבריים והקשר תרבותי"
        },
        "grammarFlip": {
          "name": "היפוך דקדוקי",
          "description": "מבנה משפט עברי עם מילים אנגליות"
        },
        "slangSynthesis": {
          "name": "סלנג ותרבות",
          "description": "ביטויי סלנג ואידיומים עם הסבר"
        }
      }
    }
  },
  "empty": {
    "noContent": "אין תוכן זמין",
    "tryAnotherCategory": "נסה לבחור קטגוריה אחרת",
    "noPodcasts": "אין פודקאסטים זמינים",
    "tryLater": "נסה שוב מאוחר יותר",
    "noResults": "לא נמצאו תוצאות"
  },
  "content": {
    "play": "נגן",
    "addToList": "הוסף לרשימה",
    "inList": "ברשימה",
    "details": "פרטים",
    "synopsis": "תקציר",
    "genre": "ז'אנר",
    "genres": "ז'אנרים",
    "runtime": "משך",
    "released": "יצא לאור",
    "director": "במאי",
    "starring": "בכיכוב",
    "cast": "שחקנים",
    "season": "עונה",
    "seasons": "עונות",
    "episode": "פרק",
    "episodes": "פרקים",
    "ep": "פרק",
    "selectSeason": "בחר עונה",
    "noEpisodes": "אין פרקים זמינים",
    "noEpisodesAvailable": "אין פרקים זמינים לצפייה",
    "loadingSeries": "טוען מידע על הסדרה...",
    "votes": "הצבעות",
    "rating": "דירוג",
    "imdbRating": "דירוג IMDB",
    "preview": "תצוגה מקדימה",
    "previewPlaying": "תצוגה מקדימה מתנגנת",
    "trailerPlaying": "טריילר מתנגן",
    "watchTrailer": "צפה בטריילר",
    "youMayAlsoLike": "אולי יעניין אותך גם",
    "relatedContent": "תוכן קשור",
    "notFound": "התוכן לא נמצא",
    "availableSubtitles": "כתוביות זמינות",
    "subtitleSelected": "נבחר: {{language}}"
  },
  "breadcrumbs": {
    "series": "סדרה",
    "movie": "סרט",
    "watching": "צופה",
    "channel": "ערוץ",
    "station": "תחנה",
    "podcast": "פודקאסט",
    "watchlist": "רשימת צפייה",
    "downloads": "הורדות"
  },
  "favorites": {
    "title": "מועדפים",
    "items": "פריטים",
    "empty": "אין מועדפים עדיין",
    "emptyHint": "הוסף פריטים למועדפים שלך"
  },
  "downloads": {
    "title": "הורדות",
    "items": "פריטים",
    "storage": "אחסון",
    "empty": "אין הורדות",
    "emptyHint": "הורד תוכן לצפייה במצב לא מקוון",
    "paused": "מושהה"
  },
  "watchlist": {
    "filters": {
      "all": "הכל",
      "continue": "המשך צפייה",
      "movies": "סרטים",
      "series": "סדרות",
      "kids": "ילדים",
      "judaism": "יהדות",
      "podcasts": "פודקאסטים",
      "radio": "רדיו"
    },
    "title": "רשימת הצפייה",
    "items": "פריטים",
    "watched": "נצפה",
    "empty": "רשימת הצפייה שלך ריקה",
    "emptyHint": "התחל לצפות והפריטים יופיעו כאן"
  },
  "widgets": {
    "empty": "אין וידג'טים עדיין",
    "emptyHint": "הוידג'טים שלך יופיעו כאן",
    "emptyPersonal": "אין וידג'טים אישיים עדיין",
    "emptyPersonalHint": "צור את הוידג'ט האישי הראשון שלך או הוסף וידג'טים מהמערכת למעלה",
    "itemsTotal": "וידג'טים בסך הכל",
    "systemWidgets": "וידג'טים של מערכת",
    "systemWidgetsHint": "עיין והוסף וידג'טים לאוסף שלך",
    "myWidgets": "הוידג'טים האישיים שלי",
    "myWidgetsHint": "וידג'טים שיצרת",
    "personalWidgets": "הוידג'טים שלי",
    "noSystemWidgets": "אין וידג'טים של מערכת זמינים",
    "added": "נוסף",
    "add": "הוסף",
    "remove": "הסר",
    "show": "הצג",
    "hidden": "מוסתר",
    "addToCollection": "הוסף לוידג'טים שלי",
    "removeFromCollection": "הסר מהוידג'טים שלי",
    "contentTypes": {
      "liveChannel": "ערוץ חי",
      "iframe": "תוכן אינטרנט",
      "podcast": "פודקאסט",
      "radio": "רדיו",
      "vod": "וידאו",
      "custom": "מותאם אישית",
      "widget": "וידג'ט"
    },
    "form": {
      "title": "יצירת וידג'ט",
      "basicInfo": "מידע בסיסי",
      "titlePlaceholder": "כותרת וידג'ט",
      "titleRequired": "כותרת וידג'ט נדרשת",
      "descriptionPlaceholder": "תיאור (אופציונלי)",
      "iconPlaceholder": "אימוג'י של סמל (לדוגמה, 📺)",
      "content": "תוכן",
      "fromLibrary": "מהספרייה",
      "iframe": "iFrame",
      "selectContent": "בחר תוכן (ערוצים, פודקסטים, תוכניות וכו')",
      "iframeUrl": "כתובת ה-URL של ה-iFrame",
      "iframeUrlRequired": "כתובת ה-URL של ה-iFrame נדרשת",
      "iframeTitle": "כותרת ה-iFrame",
      "positionSize": "עמדה וגודל",
      "behavior": "התנהגות",
      "mutedByDefault": "שקט כברירת מחדל",
      "closable": "ניתן לסגור",
      "draggable": "ניתן לגרור",
      "widgetOrder": "ترتیب וידג'ט",
      "orderPlaceholder": "ترتیب (0 = ראשון)",
      "saveWidget": "שמור וידג'ט",
      "saving": "שומר...",
      "cancel": "ביטול",
      "change": "שנה"
    }
  },
  "trending": {
    "title": "מה חם בישראל",
    "noTopics": "אין נושאים חמים כרגע",
    "topStory": "הכותרת הראשית",
    "sources": "מקורות",
    "categories": {
      "security": "ביטחון",
      "politics": "פוליטיקה",
      "tech": "טכנולוגיה",
      "culture": "תרבות",
      "sports": "ספורט",
      "economy": "כלכלה",
      "entertainment": "בידור",
      "weather": "מזג אוויר",
      "health": "בריאות",
      "general": "כללי"
    }
  },
  "cultures": {
    "title": "בחר את התרבות שלך",
    "select": "בחר תרבות",
    "selectCulture": "בחר את הקהילה שלך",
    "selectCultureDescription": "בחר את הקהילה התרבותית שלך כדי להתאים אישית את החוויה",
    "changeCulture": "שנה תרבות",
    "israeli": {
      "name": "ישראלי",
      "description": "תוכן לקהילת היוצאים הישראלית"
    },
    "chinese": {
      "name": "סיני",
      "description": "תוכן לקהילה הסינית"
    },
    "japanese": {
      "name": "יפני",
      "description": "תוכן לקהילה היפנית"
    },
    "korean": {
      "name": "קוריאני",
      "description": "תוכן לקהילה הקוריאנית"
    },
    "indian": {
      "name": "הודי",
      "description": "תוכן לקהילה ההודית"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "מה חם ב{{location}}",
    "noTopics": "אין נושאים חמים כרגע",
    "sources": "מקורות",
    "categories": {
      "security": "ביטחון",
      "politics": "פוליטיקה",
      "tech": "טכנולוגיה",
      "technology": "טכנולוגיה",
      "culture": "תרבות",
      "sports": "ספורט",
      "economy": "כלכלה",
      "finance": "פיננסים",
      "entertainment": "בידור",
      "weather": "מזג אוויר",
      "health": "בריאות",
      "food": "אוכל",
      "fashion": "אופנה",
      "travel": "טיולים",
      "history": "היסטוריה",
      "expat": "חיי גולים",
      "general": "כללי"
    }
  },
  "cultureClock": {
    "timeIn": "השעה ב{{location}}",
    "shabbat": "שבת",
    "weekend": "סוף שבוע"
  },
  "cultureCities": {
    "connectionTo": "חיבור ל{{city}}",
    "explore": "גלה את {{city}}",
    "noContent": "אין תוכן זמין לעיר זו",
    "categories": {
      "all": "הכל",
      "history": "היסטוריה",
      "culture": "תרבות",
      "finance": "פיננסים",
      "tech": "טכנולוגיה",
      "food": "אוכל",
      "expat": "חיי גולים",
      "news": "חדשות",
      "entertainment": "בידור"
    }
  },
  "clock": {
    "israel": "ישראל",
    "local": "מקומי",
    "shabbatShalom": "שבת שלום!",
    "erevShabbat": "ערב שבת",
    "candleLighting": "הדלקת נרות",
    "parasha": "פרשת"
  },
  "ritual": {
    "title": "☀️ טקס הבוקר",
    "greeting": "בוקר טוב!",
    "israelUpdate": "בישראל עכשיו אחר הצהריים, והחדשות מדווחות על התקדמות במשא ומתן",
    "recommendation": "מומלץ להתחיל עם חדשות הבוקר ואז לעבור לרדיו",
    "preparingRitual": "מכין את טקס הבוקר שלך...",
    "israelTime": "שעה בישראל",
    "day": "יום",
    "letsStart": "בואו נתחיל",
    "skipToday": "דלג להיום",
    "finish": "סיום",
    "noContentNow": "אין תוכן זמין כרגע",
    "typeLive": "שידור חי",
    "typeRadio": "רדיו",
    "typeVideo": "וידאו"
  },
  "watchParty": {
    "title": "מסיבת צפייה",
    "create": "צור מסיבה",
    "join": "הצטרף למסיבה",
    "active": "מסיבה פעילה",
    "createTitle": "יצירת מסיבת צפייה",
    "joinTitle": "הצטרפות למסיבה",
    "enterCode": "הזן קוד חדר",
    "roomCode": "קוד החדר",
    "copyCode": "העתק קוד",
    "codeCopied": "הקוד הועתק!",
    "participants": "משתתפים",
    "host": "מארח",
    "you": "אתה",
    "leave": "עזוב מסיבה",
    "end": "סיים מסיבה",
    "chat": "צ'אט",
    "sendMessage": "שלח הודעה",
    "typeMessage": "הקלד הודעה...",
    "synced": "מסונכרן",
    "syncing": "מסנכרן...",
    "hostPaused": "המארח השהה",
    "userJoined": "{{name}} הצטרף/ה",
    "userLeft": "{{name}} עזב/ה",
    "partyEnded": "המסיבה הסתיימה",
    "connecting": "מתחבר...",
    "options": {
      "chatEnabled": "אפשר צ'אט",
      "syncPlayback": "סנכרן ניגון"
    },
    "errors": {
      "invalidCode": "קוד לא תקין",
      "partyFull": "המסיבה מלאה",
      "partyEnded": "המסיבה הסתיימה",
      "connectionError": "שגיאת חיבור",
      "createFailed": "שגיאה ביצירת מסיבה",
      "joinFailed": "שגיאה בהצטרפות"
    },
    "audio": {
      "mute": "השתק",
      "unmute": "בטל השתקה",
      "speaking": "מדבר",
      "connecting": "מתחבר לשמע...",
      "noAudio": "שמע לא זמין"
    },
    "textOnlyMode": "צ'אט טקסט בלבד",
    "endParty": "סיים מסיבה"
  },
  "footer": {
    "brandDescription": "הבית שלך בארה״ב. שידורי טלוויזיה, VOD, רדיו ופודקאסטים בעברית.",
    "browse": "עיון",
    "account": "חשבון",
    "support": "תמיכה",
    "legal": "משפטי",
    "location": "ניו יורק, ארה״ב",
    "links": {
      "home": "דף הבית",
      "liveTV": "שידור חי",
      "vod": "סרטים וסדרות",
      "radio": "רדיו",
      "podcasts": "פודקאסטים",
      "judaism": "יהדות",
      "profile": "הפרופיל שלי",
      "favorites": "מועדפים",
      "watchlist": "רשימת צפייה",
      "subscribe": "הרשמה",
      "downloads": "הורדות",
      "help": "מרכז עזרה",
      "faq": "שאלות נפוצות",
      "contact": "צור קשר",
      "feedback": "משוב",
      "terms": "תנאי שימוש",
      "privacy": "מדיניות פרטיות",
      "cookies": "מדיניות עוגיות",
      "licenses": "רישיונות"
    },
    "newsletter": {
      "title": "הישאר מעודכן",
      "description": "הירשם לניוזלטר שלנו לקבלת עדכונים ותוכן בלעדי.",
      "placeholder": "הזן את האימייל שלך",
      "success": "תודה על ההרשמה!"
    },
    "apps": {
      "title": "הורד את האפליקציה",
      "downloadOn": "הורד מ",
      "getItOn": "קבל ב",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "social": {
      "facebook": "Facebook",
      "twitter": "Twitter",
      "instagram": "Instagram",
      "youtube": "YouTube"
    },
    "copyright": "© {{year}} בית+. כל הזכויות שמורות.",
    "poweredBy": "מופעל על ידי",
    "sitemap": "מפת אתר",
    "accessibility": "נגישות",
    "navigation": "ניווט",
    "liveTV": "שידור חי",
    "moviesAndSeries": "סרטים וסדרות",
    "radioStations": "תחנות רדיו",
    "myProfile": "הפרופיל שלי",
    "subscriptions": "מנויים",
    "helpAndSupport": "עזרה ותמיכה",
    "termsOfUse": "תנאי שימוש",
    "privacyPolicy": "מדיניות פרטיות",
    "contactUs": "צור קשר"
  },
  "chapters": {
    "title": "פרקים",
    "noChapters": "אין פרקים זמינים",
    "generating": "יוצר פרקים...",
    "jumpTo": "קפוץ אל",
    "current": "עכשיו",
    "categories": {
      "intro": "פתיחה",
      "news": "חדשות",
      "security": "ביטחון",
      "politics": "פוליטיקה",
      "economy": "כלכלה",
      "sports": "ספורט",
      "weather": "מזג אוויר",
      "culture": "תרבות",
      "conclusion": "סיום"
    },
    "chapterLabel": "פרק {{number}}",
    "chapter_number": "פרק {{number}}"
  },
  "admin": {
    "brand": {
      "title": "ביית+ ניהול",
      "subtitle": "ניהול מערכת"
    },
    "backToApp": "חזרה לאפליקציה",
    "refunds": {
      "subtitle": "ניהול בקשות להחזר",
      "approveModal": {
        "title": "אישור החזר",
        "message": "לאשר החזר של {{amount}}?"
      },
      "confirmApprove": "לאשר החזר של {{amount}}?",
      "confirmDelete": "למחוק בקשת החזר?",
      "rejectModal": {
        "title": "דחיית בקשת החזר",
        "message": "דחיית החזר של {{amount}}",
        "reasonLabel": "סיבת הדחייה",
        "reasonPlaceholder": "נא להזין סיבת דחייה...",
        "submitButton": "דחה בקשה"
      },
      "status": {
        "pending": "ממתין",
        "approved": "אושר",
        "rejected": "נדחה"
      },
      "columns": {
        "id": "מזהה",
        "user": "משתמש",
        "amount": "סכום",
        "reason": "סיבה",
        "status": "סטטוס",
        "requestDate": "תאריך בקשה"
      },
      "stats": {
        "pendingTitle": "ממתינים לאישור",
        "approvedTitle": "אושרו",
        "rejectedTitle": "נדחו",
        "totalRefunded": "סה״כ הוחזר"
      },
      "emptyMessage": "לא נמצאו בקשות להחזר",
      "errors": {
        "rejectReasonRequired": "נא להזין סיבת דחייה"
      },
      "title": "החזרים"
    },
    "plans": {
      "title": "ניהול תוכניות",
      "subtitle": "הגדר ונהל את תוכניות המנוי",
      "createButton": "תוכנית חדשה",
      "inactive": "לא פעיל",
      "subscribersLabel": "מנויים:",
      "intervals": {
        "monthly": "חודש",
        "yearly": "שנה"
      },
      "trialDays": "{{days}} ימי נסיון",
      "modal": {
        "editTitle": "עריכת תוכנית",
        "createTitle": "תוכנית חדשה"
      },
      "form": {
        "nameEn": "שם (אנגלית)",
        "nameHe": "שם (עברית)",
        "price": "מחיר ($)",
        "interval": "תקופה",
        "trialDays": "ימי נסיון",
        "features": "תכונות (אחת בכל שורה)",
        "active": "תוכנית פעילה"
      },
      "errors": {
        "requiredFields": "שם ומחיר הם חובה"
      },
      "confirmDelete": "מחק את התוכנית \"{{name}}\"?"
    },
    "emailCampaigns": {
      "subtitle": "יצירה וניהול קמפייני דוא״ל",
      "createButton": "קמפיין חדש",
      "searchPlaceholder": "חפש קמפיין...",
      "emptyMessage": "לא נמצאו קמפיינים",
      "status": {
        "draft": "טיוטה",
        "active": "פעיל",
        "scheduled": "מתוזמן",
        "completed": "הושלם"
      },
      "columns": {
        "name": "שם הקמפיין",
        "status": "סטטוס",
        "sent": "נשלחו",
        "opened": "נפתחו",
        "clicked": "לחיצות",
        "created": "נוצר",
        "actions": "פעולות"
      },
      "editModal": {
        "title": "עריכת קמפיין"
      },
      "sendTestEmail": "שלח בדיקה",
      "confirmSend": "לשלוח את הקמפיין \"{{name}}\"?",
      "confirmDelete": "למחוק את הקמפיין \"{{name}}\"?",
      "testEmailSent": "אימייל בדיקה נשלח!",
      "createModal": {
        "title": "קמפיין דוא״ל חדש"
      },
      "form": {
        "name": "שם הקמפיין",
        "namePlaceholder": "לדוגמה: מבצע סוף שנה",
        "subject": "נושא האימייל",
        "subjectPlaceholder": "נושא שיופיע לנמענים",
        "body": "תוכן",
        "bodyPlaceholder": "תוכן האימייל...",
        "submitButton": "צור קמפיין",
        "requiredFields": "שם ונושא נדרשים"
      },
      "testModal": {
        "title": "שלח אימייל בדיקה",
        "emailLabel": "כתובת אימייל",
        "emailPlaceholder": "test@example.com",
        "submitButton": "שלח בדיקה"
      },
      "errors": {
        "requiredFields": "שם ונושא הם חובה"
      }
    },
    "dashboard": {
      "subtitle": "סקירה כללית של המערכת",
      "refresh": "רענן",
      "timeAgo": {
        "minutes": "לפני {{count}} דקות",
        "hours": "לפני {{count}} שעות"
      },
      "title": "לוח בקרה",
      "users": "משתמשים",
      "revenue": "הכנסות",
      "subscriptions": "מנויים",
      "recentActivity": "פעילות אחרונה",
      "quickActions": "פעולות מהירות"
    },
    "common": {
      "all": "הכל",
      "cancel": "ביטול",
      "save": "שמור",
      "active": "פעיל",
      "back": "חזרה",
      "filterAction": "פעולה",
      "filterResource": "משאב",
      "filterUser": "משתמש",
      "filterDateRange": "טווח תאריכים"
    },
    "stats": {
      "totalUsers": "סה״כ משתמשים",
      "activeUsers": "משתמשים פעילים",
      "newToday": "חדשים היום",
      "newThisWeek": "חדשים השבוע",
      "totalRevenue": "סה״כ הכנסות",
      "revenueToday": "הכנסות היום",
      "revenueMonth": "הכנסות החודש",
      "arpu": "הכנסה ממוצעת למשתמש",
      "activeSubscriptions": "מנויים פעילים",
      "churnRate": "שיעור נטישה"
    },
    "actions": {
      "new": "חדש",
      "addUser": "הוסף משתמש",
      "newCampaign": "קמפיין חדש",
      "sendEmail": "שלח אימייל",
      "viewReports": "צפה בדוחות"
    },
    "auditActions": {
      "user_created": "משתמש נוצר",
      "user_updated": "משתמש עודכן",
      "user_deleted": "משתמש נמחק",
      "user_role_changed": "תפקיד משתמש שונה",
      "campaign_created": "קמפיין נוצר",
      "campaign_updated": "קמפיין עודכן",
      "campaign_deleted": "קמפיין נמחק",
      "campaign_activated": "קמפיין הופעל",
      "subscription_created": "מנוי נוצר",
      "subscription_updated": "מנוי עודכן",
      "subscription_canceled": "מנוי בוטל",
      "subscription_deleted": "מנוי נמחק",
      "refund_processed": "החזר עובד",
      "payment_received": "תשלום התקבל",
      "settings_updated": "הגדרות עודכנו",
      "login": "התחברות",
      "logout": "התנתקות",
      "content_created": "תוכן נוצר",
      "content_updated": "תוכן עודכן",
      "content_deleted": "תוכן נמחק",
      "content_published": "תוכן פורסם",
      "content_unpublished": "תוכן בוטל פרסומו",
      "category_created": "קטגוריה נוצרה",
      "category_updated": "קטגוריה עודכנה",
      "category_deleted": "קטגוריה נמחקה",
      "live_channel_created": "ערוץ חי נוצר",
      "live_channel_updated": "ערוץ חי עודכן",
      "live_channel_deleted": "ערוץ חי נמחק",
      "radio_station_created": "תחנת רדיו נוצרה",
      "radio_station_updated": "תחנת רדיו עודכנה",
      "radio_station_deleted": "תחנת רדיו נמחקה",
      "podcast_created": "פודקאסט נוצר",
      "podcast_updated": "פודקאסט עודכן",
      "podcast_deleted": "פודקאסט נמחק",
      "podcast_episode_created": "פרק פודקאסט נוצר",
      "podcast_episode_updated": "פרק פודקאסט עודכן",
      "podcast_episode_deleted": "פרק פודקאסט נמחק",
      "content_imported": "תוכן יובא",
      "widget_created": "ווידג'ט נוצר",
      "widget_updated": "ווידג'ט עודכן",
      "widget_deleted": "ווידג'ט נמחק",
      "widget_published": "ווידג'ט פורסם",
      "widget_unpublished": "ווידג'ט בוטל פרסומו"
    },
    "placeholder": {
      "userId": "הזן מזהה משתמש",
      "discount": "0"
    },
    "titles": {
      "users": "משתמשים",
      "transactions": "עסקאות",
      "subscriptions": "מנויים",
      "refunds": "החזרים",
      "plans": "תוכניות",
      "campaigns": "קמפיינים",
      "auditLogs": "יומני ביקורת",
      "pushNotifications": "הודעות דחיפה",
      "billing": "חיוב",
      "marketing": "שיווק",
      "content": "ספריית תוכן",
      "categories": "קטגוריות",
      "liveChannels": "ערוצים חיים",
      "radioStations": "תחנות רדיו",
      "podcasts": "פודקאסטים",
      "settings": "הגדרות"
    },
    "nav": {
      "dashboard": "לוח בקרה",
      "users": "משתמשים",
      "campaigns": "קמפיינים",
      "billing": "חיוב",
      "billingOverview": "סקירה",
      "transactions": "עסקאות",
      "refunds": "החזרים",
      "subscriptions": "מנויים",
      "subscriptionsList": "רשימת מנויים",
      "plans": "תוכניות",
      "marketing": "שיווק",
      "marketingDashboard": "סקירה",
      "emailCampaigns": "קמפייני דוא״ל",
      "pushNotifications": "התראות פוש",
      "content": "תוכן",
      "contentLibrary": "ספריית תוכן",
      "categories": "קטגוריות",
      "liveChannels": "ערוצים חיים",
      "radioStations": "תחנות רדיו",
      "podcasts": "פודקאסטים",
      "widgets": "ווידג'טים",
      "recordings": "הקלטות",
      "uploads": "העלאות",
      "settings": "הגדרות",
      "auditLogs": "יומן פעילות",
      "librarian": "סוכן הספרן",
      "featured": "מובחר"
    },
    "featured": {
      "title": "תוכן מובחר",
      "subtitle": "נהל תוכן מובחר לקרוסלות בעמוד הבית",
      "empty": "אין תוכן מובחר",
      "emptyHint": "פריטים מובחרים יופיעו בקרוסלות שלהם בעמוד הבית",
      "count": "{{count}} פריטים",
      "confirmUnfeature": "להסיר מהמובחר?",
      "remove": "הסר",
      "unsavedChanges": "יש לך שינויים שלא נשמרו",
      "section": {
        "title": "{{name}}",
        "itemCount": "פריט {{count}}",
        "itemCount_plural": "{{count}} פריטים",
        "empty": "אין פריטים מובחרים",
        "emptyHint": "פריטים מובחרים יופיעו בקרוסלה {{name}} בעמוד הבית"
      },
      "saveButton": "שמור {{count}} סעיף",
      "saveButton_plural": "שמור {{count}} סעיפים",
      "saving": "שומר...",
      "saveSuccess": "תוכן מובחר עודכן בהצלחה",
      "saveFailed": "נכשל שמירת תוכן מובחר",
      "removeConfirm": "הסר מ-{{section}}?",
      "removeSuccess": "הוסר מ-{{section}}"
    },
    "recordings": {
      "title": "ניהול הקלטות",
      "subtitle": "נהל הקלטות משתמשים בפלטפורמה",
      "totalRecordings": "סה״כ הקלטות",
      "totalStorage": "סה״כ אחסון",
      "totalUsers": "משתמשים עם הקלטות",
      "activeSessions": "הפעלות פעילות",
      "searchPlaceholder": "חפש לפי כותרת, משתמש או ערוץ...",
      "user": "משתמש",
      "confirmDelete": "מחק הקלטה '{{title}}'? פעולה זו אינה ניתנת לביטול.",
      "deleteRecording": "מחק הקלטה",
      "deleteSuccess": "ההקלטה נמחקה בהצלחה",
      "deleteFailed": "מחיקת ההקלטה נכשלה",
      "loadFailed": "טעינת ההקלטות נכשלה",
      "noRecordings": "לא נמצאו הקלטות",
      "noRecordingsHint": "אין עדיין הקלטות משתמשים במערכת."
    },
    "uploads": {
      "title": "ניהול העלאות",
      "subtitle": "נהל העלאות תוכן וניטור תיקיות אוטומטי",
      "activeUploads": "העלאות פעילות",
      "noActiveUploads": "אין העלאות פעילות",
      "queuedUploads": "העלאות בתור",
      "queued": "בתור",
      "andMore": "ועוד {{count}} נוספים",
      "monitoredFolders": "תיקיות מנוטרות",
      "noMonitoredFolders": "לא הוגדרו תיקיות מנוטרות",
      "configureFoldersHelp": "לחץ על 'הוסף תיקייה' להגדרת תיקיות מנוטרות להעלאות אוטומטיות",
      "addFolder": "הוסף תיקייה",
      "editFolder": "ערוך תיקייה",
      "deleteFolder": "מחק תיקייה",
      "confirmDelete": "למחוק תיקייה זו?",
      "triggerUpload": "הפעל העלאה",
      "triggerUploadSuccess": "נמצאו {{files_found}} קבצים חדשים להעלאה",
      "triggerUploadFailed": "הפעלת סריקת העלאה נכשלה",
      "noFilesFound": "לא נמצאו קבצים חדשים בתיקיות המנוטרות",
      "sessionIssue": "בעיית סשן",
      "sessionIssueHelp": "הסשן שלך אולי פג. אנא רענן את הדף כדי לשחזר את החיבור.",
      "sessionExpired": "הסשן פג. אנא רענן את הדף או התחבר שוב.",
      "unauthorized": "הסשן לא תקף. אנא רענן את הדף.",
      "endpointNotFound": "שירות ההעלאות לא זמין. בדוק את תצורת השרת.",
      "timeout": "סריקת ההעלאה תמה. נסה שוב או בדוק את התיקיות המנוטרות.",
      "wsDisconnected": "עדכונים בזמן אמת מושבתים",
      "wsDisconnectedHelp": "חיבור WebSocket נכשל. מצב התור עשוי להיות לא מעודכן. הדף ינסה שוב אוטומטית.",
      "wsReconnecting": "מתחבר מחדש לעדכונים בזמן אמת...",
      "uploadAlreadyRunning": "סריקת העלאה כבר בתהליך. אנא המתן להשלמת ההעלאות הנוכחיות.",
      "uploadsActiveNotice": "העלאות מתבצעות ({{processing}} פעילות, {{queued}} בתור). סריקה חדשה מושבתת עד להשלמת האצווה הנוכחית.",
      "clearQueue": "נקה תור",
      "clearQueueConfirmTitle": "לנקות את תור ההעלאות?",
      "clearQueueConfirmMessage": "פעולה זו תבטל {{count}} משימות פעילות. לא ניתן לבטל פעולה זו.",
      "clearQueueSuccess": "התור נוקה בהצלחה",
      "clearQueueFailed": "ניקוי התור נכשל",
      "cancelUpload": "ביטול",
      "cancelUploadConfirm": "לבטל העלאה זו?",
      "cancelUploadSuccess": "ההעלאה בוטלה",
      "cancelUploadFailed": "ביטול ההעלאה נכשל",
      "resetCache": "אפס מטמון",
      "cacheResetSuccess": "המטמון נוקה: {{count}} קבצים יסרקו מחדש בסריקה הבאה",
      "cacheResetFailed": "איפוס המטמון נכשל",
      "contentTypeFilters": "סינון לפי סוג תוכן",
      "contentTypeFiltersHelp": "אופציונלי - השאר הכל לא מסומן כדי לעבד את כל סוגי התוכן",
      "moviesOnly": "סרטים בלבד",
      "seriesOnly": "סדרות בלבד",
      "audiobooksOnly": "ספרי שמע בלבד",
      "type": "סוג",
      "lastScan": "סריקה אחרונה",
      "systemInfo": "מידע על מערכת ההעלאות",
      "systemInfoText": "מחלצת כתוביות אוטומטית מקבצי וידאו מקומיים במהלך ההעלאה לעיבוד מהיר יותר",
      "languagesInfo": "שפות כתוביות נתמכות: אנגלית (en), עברית (he), ספרדית (es)",
      "queueStatus": "תור העלאות",
      "totalJobs": "סה״כ",
      "processing": "פעיל",
      "completed": "הושלמו",
      "skipped": "דולגו",
      "failed": "נכשלו",
      "queuePaused": "התור הושהה",
      "resumeQueue": "המשך",
      "activeUpload": "העלאה פעילה",
      "queuedItems": "בתור",
      "noQueuedItems": "אין פריטים בתור",
      "addedAt": "נוסף",
      "recentCompleted": "הושלמו לאחרונה",
      "stages": {
        "browserUpload": "מעלה לשרת",
        "hashCalculation": "מחשב גיבוב",
        "duplicateCheck": "בודק כפילויות",
        "metadataExtraction": "מחלץ מטאדאטה",
        "gcsUpload": "מעלה לענן",
        "databaseInsert": "שומר למסד נתונים",
        "imdbLookup": "מביא מידע מ-IMDB",
        "subtitleExtraction": "מחלץ כתוביות",
        "completed": "הושלם",
        "failed": "נכשל",
        "skipped": "דולג"
      },
      "form": {
        "name": "שם תיקייה",
        "namePlaceholder": "תיקיית הסרטים שלי",
        "path": "נתיב תיקייה",
        "pathHelp": "הזן את נתיב השרת לתיקייה (למשל, /Volumes/USB Drive/Movies)",
        "contentType": "סוג תוכן",
        "enabled": "מופעל",
        "autoUpload": "העלאה אוטומטית"
      },
      "contentTypes": {
        "movie": "סרטים",
        "series": "סדרות",
        "audiobook": "ספרי אודיו"
      },
      "errors": {
        "pathRequired": "נתיב תיקייה נדרש"
      },
      "manualUpload": {
        "title": "העלאה ידנית",
        "subtitle": "גרור ושחרר קבצים או בחר תיקייה",
        "dropHere": "גרור קבצים לכאן או לחץ לעיון",
        "dropHereActive": "שחרר קבצים להוספה",
        "selectFolder": "בחר תיקייה",
        "supportedFormats": "תומך בקבצי וידאו (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "קבצים נבחרים",
        "noFilesSelected": "לא נבחרו קבצים",
        "clearAll": "נקה הכל",
        "uploadSelected": "העלה נבחרים",
        "selectContentType": "בחר סוג תוכן להעלאה",
        "uploadingFiles": "מוסיף {{count}} קבצים לתור...",
        "uploadSuccess": "נוספו {{count}} קבצים לתור בהצלחה",
        "uploadFailed": "הוספת קבצים לתור נכשלה",
        "fileSize": "גודל",
        "removeFile": "הסר",
        "invalidFileType": "סוג קובץ לא חוקי. רק קבצי וידאו נתמכים.",
        "filesCount": "{{count}} קבצים נבחרו",
        "pendingRestore": "{{count}} קבצים ממתינים מהפעלה קודמת",
        "pendingRestoreHint": "גרור או בחר את אותם קבצים לשחזור תור ההעלאות"
      }
    },
    "librarian": {
      "title": "סוכן הספרן",
      "subtitle": "ניהול אוטונומי של ספריית תוכן מבוסס בינה מלאכותית",
      "loading": "טוען סוכן ספרן...",
      "loadingConfig": "טוען תצורה...",
      "refresh": "רענן",
      "errors": {
        "configError": "שגיאת תצורה",
        "configNotLoaded": "התצורה לא נטענה",
        "failedToLoad": "נכשל בטעינת נתוני הספרן",
        "failedToLoadConfig": "נכשל בטעינת תצורת הספרן",
        "failedToTrigger": "נכשל בהפעלת ביקורת. אנא נסה שוב.",
        "failedToLoadDetails": "נכשל בטעינת פרטי הדוח.",
        "failedToRollback": "נכשל בביטול הפעולה.",
        "failedToClearReports": "נכשל בניקוי דוחות הביקורת. אנא נסה שוב.",
        "failedToPause": "נכשל בהשהיית הביקורת",
        "failedToResume": "נכשל בחידוש הביקורת",
        "failedToCancel": "נכשל בביטול הביקורת",
        "failedToInterject": "נכשל בשליחת הודעה לסוכן AI",
        "auditAlreadyRunning": "ביקורת כבר רצה כעת. אנא המתן לסיומה או בטל אותה לפני שתתחיל ביקורת חדשה.",
        "budgetExceeded": "חרגת ממגבלת התקציב החודשית. לא ניתן להריץ ביקורת.",
        "contactAdmin": "דף הספרן לא יכול להיטען ללא תצורה נכונה.\nאנא צור קשר עם המנהל שלך."
      },
      "stats": {
        "systemHealth": "תקינות המערכת",
        "totalAudits": "סה״כ ביקורות (30 יום)",
        "last30Days": "30 הימים האחרונים",
        "issuesFixed": "בעיות שתוקנו",
        "lastAudit": "ביקורת אחרונה",
        "never": "אף פעם",
        "unknown": "לא ידוע"
      },
      "health": {
        "excellent": "מצוין",
        "good": "טוב",
        "fair": "סביר",
        "poor": "גרוע",
        "unknown": "לא ידוע"
      },
      "quickActions": {
        "title": "הגדרות הרצה",
        "subtitle": "הגדר והפעל ביקורות",
        "auditMode": "מצב ביקורת",
        "auditModeHelp": "בחר מה לבדוק",
        "dryRun": "מצב תצוגה מקדימה",
        "dryRunHelp": "הצג מה ישתנה ללא ביצוע שינויים בפועל",
        "scopeFilters": "יכולות ביקורת",
        "scopeFiltersHelp": "בחר יכולות להפעלה (ניתן לשלב מספר יכולות)",
        "last24Hours": "תוכן אחרון בלבד",
        "last24HoursHelp": "הגבל ביקורת לתוכן שנוסף ב-24 השעות האחרונות",
        "cybTitlesOnly": "נקה כותרות מלוכלכות",
        "cybTitlesOnlyHelp": "הסר סיומות קבצים, סימני איכות ותגיות שחרור מכותרות",
        "tmdbPostersOnly": "פוסטרים ומטא-דאטה מ-TMDB",
        "tmdbPostersOnlyHelp": "הבא פוסטרים, תיאורים ומטא-דאטה חסרים מ-TMDB",
        "openSubtitlesEnabled": "השג כתוביות",
        "openSubtitlesEnabledHelp": "הורד כתוביות חסרות מ-OpenSubtitles (עברית/אנגלית/ספרדית)",
        "classifyOnly": "אמת סיווג",
        "classifyOnlyHelp": "בדוק ותקן שגיאות סיווג סרט מול סדרה",
        "purgeDuplicates": "הסר כפילויות",
        "purgeDuplicatesHelp": "מצא והסר פריטי תוכן כפולים",
        "auditType": "סוג ביקורת",
        "auditTypeHelp": "בחר בין ביקורת מבוססת-כללים או מונעת-AI",
        "dailyAudit": "ביקורת יומית",
        "dailyBadge": "מבוססת כללים • מהירה • חינם",
        "dailyDescription": "מריצה בדיקות מוגדרות מראש על תוכן ששונה ב-7 הימים האחרונים. מהירה וצפויה, ללא עלויות AI.",
        "aiAgentAudit": "ביקורת סוכן AI",
        "aiAgentBadge": "מונעת-AI • אינטליגנטית • משתמשת בתקציב",
        "aiAgentDescription": "סוכן AI אוטונומי (Claude) מקבל החלטות אינטליגנטיות לגבי מה לבדוק ולתקן. מקיף יותר אך משתמש בתקציב API.",
        "triggerDaily": "הרץ ביקורת יומית",
        "triggerAI": "הרץ ביקורת סוכן AI",
        "auditRunningNotice": "ביקורת כבר רצה כעת. הכפתורים יופעלו כשהיא תסתיים.",
        "budgetLabel": "מגבלת תקציב לסוכן AI: ${{budget}}",
        "budgetPerAudit": "תקציב לביקורת",
        "monthlyBudgetUsed": "תקציב בשימוש (30י)",
        "monthlyBudgetLimit": "/ ${{limit}} חודשי",
        "budgetWarning": "הרצת ביקורת זו תחרוג ממגבלת התקציב החודשית",
        "aiAuditSuccess": "ביקורת סוכן AI הופעלה בהצלחה. {{dryRun}}",
        "dailyAuditSuccess": "ביקורת יומית הופעלה בהצלחה. {{dryRun}}",
        "dryRunMode": "(מצב ריצת ניסיון)",
        "rollbackSuccess": "הפעולה בוטלה בהצלחה."
      },
      "voice": {
        "title": "שליטה קולית",
        "description": "השתמש בקול שלך כדי לתת פקודות לספרן. פשוט לחץ על הכפתור ודבר באופן טבעי.",
        "pressToSpeak": "לחץ לדיבור",
        "listening": "מאזין...",
        "transcript": "תמלול",
        "processing": "מעבד את הפקודה שלך...",
        "speaking": "הספרן מגיב...",
        "examples": "פקודות לדוגמה",
        "example1": "בדוק פוסטרים חסרים ב-24 השעות האחרונות",
        "example2": "תקן מטא-דאטה עבור כותרות CYB",
        "example3": "סרוק כתובות סטרימינג שבורות",
        "example4": "חלץ כתוביות מסרטים",
        "notSupported": "זיהוי קולי אינו נתמך בדפדפן שלך. אנא השתמש ב-Chrome, Edge או Safari.",
        "notAvailable": "שליטה קולית אינה זמינה",
        "noSpeech": "לא זוהה דיבור. אנא נסה שוב.",
        "noMicrophone": "לא זוהה מיקרופון. אנא בדוק את המכשיר שלך.",
        "microphoneBlocked": "גישה למיקרופון נחסמה. אנא אפשר אותה בהגדרות הדפדפן שלך.",
        "error": "שגיאת זיהוי קולי: {{error}}",
        "startFailed": "הפעלת זיהוי קולי נכשלה. אנא נסה שוב.",
        "commandFailed": "ביצוע הפקודה נכשל. אנא נסה שוב."
      },
      "schedules": {
        "title": "ביקורות מתוזמנות",
        "subtitle": "הגדר לוחות זמנים יומיים ושבועיים לביקורות",
        "dailyTitle": "ביקורת יומית",
        "weeklyTitle": "ביקורת AI שבועית",
        "schedule": "לוח זמנים",
        "time": "זמן",
        "mode": "מצב",
        "cost": "עלות משוערת",
        "status": "סטטוס",
        "description": "תיאור",
        "viewInConsole": "צפה ב-Cloud Console",
        "modifyNote": "לשינוי לוחות זמנים, השתמש ב-Google Cloud Console",
        "editTitle": "ערוך לוח זמנים",
        "editNotAvailable": "עריכת לוח זמנים לא זמינה",
        "editNotAvailableMessage": "שינויים בלוח הזמנים דורשים אינטגרציה עם Cloud Scheduler API. אנא השתמש בכפתור 'צפה ב-Cloud Console' כדי לשנות לוחות זמנים ישירות ב-Google Cloud Console.",
        "cronExpression": "ביטוי Cron",
        "cronHint": "פורמט: דקה שעה יום חודש יום_בשבוע (לדוגמה: 0 2 * * * = יומי ב-2:00 בבוקר)",
        "patterns": {
          "daily": "יומי ב-{{hour}}:{{minute}}",
          "weekly": "כל {{day}} ב-{{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "ראשון",
          "monday": "שני",
          "tuesday": "שלישי",
          "wednesday": "רביעי",
          "thursday": "חמישי",
          "friday": "שישי",
          "saturday": "שבת"
        }
      },
      "reports": {
        "title": "דוחות ביקורת אחרונים",
        "emptyMessage": "עדיין אין דוחות ביקורת",
        "totalReports": "{{count}} דוח(ות)",
        "clearAll": "נקה הכל",
        "confirmClearAll": "האם אתה בטוח שברצונך לנקות את כל דוחות הביקורת? פעולה זו לא ניתנת לביטול.",
        "clearedSuccessfully": "כל דוחות הביקורת נוקו בהצלחה",
        "viewLogs": "הצג לוגים",
        "viewDetails": "הצג פרטים",
        "columns": {
          "date": "תאריך",
          "type": "סוג",
          "duration": "משך",
          "status": "סטטוס",
          "issues": "בעיות",
          "fixes": "תיקונים",
          "actions": "פעולות"
        },
        "detailModal": {
          "title": "דוח ביקורת: {{id}}",
          "summary": "סיכום",
          "status": "סטטוס",
          "executionTime": "זמן ביצוע",
          "totalItems": "סה״כ פריטים",
          "healthyItems": "פריטים תקינים",
          "issuesFound": "בעיות שנמצאו",
          "totalIssues": "סה״כ בעיות שנמצאו",
          "seeInsightsBelow": "ראה תובנות AI למטה לפרטים נוספים",
          "brokenStreams": "סטרימים שבורים",
          "missingMetadata": "מטא-דאטה חסרה",
          "misclassifications": "סיווגים שגויים",
          "orphanedItems": "פריטים נטושים",
          "fixesApplied": "תיקונים שבוצעו",
          "totalFixes": "{{count}} תיקונים בסך הכל",
          "aiInsights": "תובנות AI"
        }
      },
      "logs": {
        "title": "לוגים של ביצוע",
        "liveAuditLog": "לוג ביקורת חי",
        "executionLog": "לוג ביצוע ביקורת",
        "searchPlaceholder": "חפש לוגים...",
        "noLogs": "אין לוגים להצגה",
        "noActiveAudit": "אין ביקורת פעילה",
        "triggerAuditToSee": "הפעל ביקורת כדי לראות לוגי ביצוע חיים כאן",
        "auditType": "סוג ביקורת",
        "started": "התחיל",
        "completed": "הושלם",
        "lastLog": "לוג אחרון",
        "staleWarning": "אין לוגים חדשים כבר {{seconds}} שניות - העבודה עשויה להיות תקועה",
        "pollingStatus": "פעיל • נבדק לאחרונה",
        "connecting": "מתחבר ללוג ביקורת חי...",
        "aiInsightPrefix": "תובנת AI",
        "source": {
          "librarian": "ספרן",
          "aiAgent": "סוכן AI"
        },
        "levels": {
          "debug": "ניפוי",
          "info": "מידע",
          "warn": "אזהרה",
          "error": "שגיאה",
          "success": "הצלחה",
          "trace": "מעקב"
        },
        "auditStarted": "הביקורת החלה",
        "brokenStreamsFound": "נמצאו {{count}} סטרימ(ים) שבור(ים)",
        "missingMetadataFound": "נמצאו {{count}} פריט(ים) עם מטא-דאטה חסרה",
        "misclassificationsFound": "נמצאו {{count}} פריט(ים) מסווג(ים) באופן שגוי",
        "orphanedItemsFound": "נמצאו {{count}} פריט(ים) נטוש(ים)",
        "fixesApplied": "בוצעו {{count}} תיקון(ים)",
        "auditCompleted": "הביקורת {{status}} ב-{{duration}}s",
        "auditInitializing": "🚀 מאתחל ביקורת {{auditType}}...",
        "dryRunMode": "⚠️ רץ במצב ניסיון - לא ייעשו שינויים",
        "liveMode": "✅ רץ במצב חי - שינויים יבוצעו",
        "budgetSet": "💰 מגבלת תקציב: ${{budget}}",
        "connectingToAgent": "🔗 מתחבר לסוכן Claude AI..."
      },
      "audit": {
        "types": {
          "aiAgent": "סוכן AI",
          "dailyIncremental": "יומי מצטבר"
        },
        "pause": "השהה",
        "resume": "המשך",
        "cancel": "בטל",
        "interject": "התערב",
        "interjectTitle": "שלח הודעה לסוכן AI",
        "interjectHint": "הודעה זו תוזרק לשיחת סוכן ה-AI באיטרציה הבאה. השתמש בה כדי לספק הקשר נוסף, להפנות מיקוד או לתת הוראות ספציפיות.",
        "interjectPlaceholder": "לדוגמה, התמקד רק בסרטים, דלג על סדרות לעת עתה...",
        "sendInterject": "שלח",
        "interjectSuccess": "ההודעה נשלחה לסוכן AI בהצלחה",
        "pauseSuccess": "הביקורת הושהתה בהצלחה",
        "resumeSuccess": "הביקורת חודשה בהצלחה",
        "cancelSuccess": "הביקורת בוטלה בהצלחה"
      },
      "progress": {
        "batch": "אצווה {{current}} מתוך {{total}}",
        "items": "{{processed}} מתוך {{total}} פריטים",
        "finishing": "מסיים...",
        "finalizing": "יוצר דוח ומיישם תיקונים"
      },
      "activityLog": {
        "title": "יומן פעילות",
        "subtitle": "{{count}} פעולות תועדו",
        "filterByType": "סנן לפי סוג",
        "allActions": "כל הפעולות",
        "content": "תוכן",
        "noDescription": "אין תיאור זמין",
        "updatedFields": "עודכן: {{fields}}",
        "pagination": "עמוד {{page}} מתוך {{totalPages}}",
        "issueType": "סוג בעיה",
        "confidence": "רמת ביטחון",
        "autoApproved": "אושר אוטומטית",
        "changes": "שינויים",
        "actionTypes": {
          "addPoster": "הוסף פוסטר",
          "updateMetadata": "עדכן מטא-דאטה",
          "recategorize": "סווג מחדש",
          "fixUrl": "תקן URL",
          "cleanTitle": "נקה כותרת",
          "classify": "סווג"
        },
        "rollback": "בטל",
        "rolledBack": "בוטל",
        "confirmRollback": {
          "title": "אשר ביטול",
          "message": "האם אתה בטוח שברצונך לבטל פעולה זו? פעולה זו תשחזר את המצב הקודם."
        },
        "emptyMessage": "לא נמצאו פעולות"
      },
      "modal": {
        "confirmAI": {
          "title": "להפעיל ביקורת סוכן AI?",
          "message": "פעולה זו תפעיל ביקורת אוטונומית של סוכן AI עם מגבלת תקציב של ${{budget}}. הסוכן יקבל החלטות לגבי מה לבדוק ולתקן. {{dryRun}}",
          "dryRunNote": "רץ במצב ניסיון (לא יתבצעו שינויים)."
        },
        "cancel": "בטל",
        "confirm": "אשר",
        "close": "סגור",
        "retry": "נסה שוב"
      },
      "status": {
        "enabled": "מופעל",
        "disabled": "מושבת",
        "completed": "ביקורת הושלמה",
        "failed": "ביקורת נכשלה",
        "in_progress": "בתהליך",
        "partial": "הושלם חלקית",
        "pending": "ממתין",
        "running": "פועל"
      },
      "auditTypes": {
        "daily_incremental": "יומי הדרגתי",
        "ai_agent": "סוכן AI"
      }
    },
    "widgets": {
      "title": "ווידג'טים",
      "subtitle": "ניהול ווידג'טים צפים לשידורים חיים ותוכן מוטמע",
      "newWidget": "ווידג'ט חדש",
      "editWidget": "עריכת ווידג'ט",
      "columns": {
        "title": "כותרת",
        "contentType": "סוג תוכן",
        "targetRoles": "תפקידי יעד",
        "targetPages": "דפי יעד",
        "status": "סטטוס",
        "order": "סדר"
      },
      "contentTypes": {
        "liveChannel": "ערוץ חי",
        "live": "שידור חי",
        "vod": "וידאו לפי דרישה",
        "podcast": "פודקאסט",
        "radio": "רדיו",
        "iframe": "תוכן מוטמע"
      },
      "status": {
        "active": "פעיל",
        "inactive": "לא פעיל"
      },
      "form": {
        "title": "כותרת הווידג'ט",
        "description": "תיאור (אופציונלי)",
        "icon": "אימוג'י (אופציונלי)",
        "contentType": "סוג תוכן",
        "selectChannel": "בחר ערוץ חי",
        "channelPlaceholder": "-- בחר ערוץ --",
        "iframeUrl": "כתובת URL",
        "iframeTitle": "כותרת (לנגישות)",
        "position": "מיקום ברירת מחדל",
        "behavior": "התנהגות",
        "mutedByDefault": "מושתק כברירת מחדל",
        "closable": "ניתן לסגירה",
        "draggable": "ניתן לגרירה",
        "targetPages": "דפי יעד (מופרדים בפסיק, ריק = כולם)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "סדר"
      },
      "actions": {
        "save": "שמור",
        "cancel": "ביטול"
      },
      "confirmDelete": "האם אתה בטוח שברצונך למחוק ווידג'ט זה?",
      "emptyMessage": "לא נמצאו ווידג'טים. צור אחד כדי להתחיל.",
      "allPages": "כל הדפים",
      "allRoles": "הכל",
      "errors": {
        "titleRequired": "כותרת נדרשת",
        "selectChannel": "יש לבחור ערוץ חי",
        "iframeUrlRequired": "כתובת URL נדרשת"
      }
    },
    "billing": {
      "subtitle": "מעקב אחר הכנסות ותשלומים",
      "revenue": "הכנסות",
      "today": "היום",
      "thisWeek": "השבוע",
      "thisMonth": "החודש הזה",
      "thisYear": "השנה הזו",
      "metrics": "מדדים עיקריים",
      "totalTransactions": "סך הכל עסקאות",
      "avgTransaction": "ממוצע עסקה",
      "pendingRefunds": "החזרים ממתינים",
      "refundRate": "שיעור החזר",
      "retention": "שימור",
      "retentionRate": "שיעור שימור",
      "churnRate": "שיעור הפירוק",
      "atRiskUsers": "משתמשים בסיכון",
      "churnedUsers": "משתמשים שעזבו",
      "quickLinks": "קישורים מהירים"
    },
    "marketing": {
      "recentCampaigns": "קמפיינים אחרונים",
      "audienceSegments": "קטעי קהל",
      "emailMetrics": "מדדי דוא״ל",
      "pushMetrics": "מדדי דחיפה",
      "quickActions": "פעולות מהירות"
    },
    "push": {
      "titlePlaceholder": "כותרת הודעה",
      "bodyPlaceholder": "תוכן ההודעה"
    },
    "auditLogs": {
      "subtitle": "מעקב אחר כל הפעולות במערכת",
      "filter": "סנן",
      "export": "ייצא",
      "all": "הכל",
      "advancedFiltering": "סינון מתקדם",
      "actionType": "סוג פעולה",
      "clear": "נקה",
      "apply": "החל",
      "noRecords": "לא נמצאו רשומות",
      "columns": {
        "action": "פעולה",
        "user": "משתמש",
        "resource": "משאב",
        "details": "פרטים",
        "date": "תאריך",
        "ip": "IP"
      },
      "changed": "שונה",
      "actionFilters": {
        "user": "משתמש",
        "subscription": "מנוי",
        "payment": "תשלום",
        "settings": "הגדרות",
        "campaign": "קמפיין",
        "content": "תוכן"
      }
    },
    "settings": {
      "subtitle": "הגדר את פרמטרי המערכת",
      "saveChanges": "שמור שינויים",
      "generalSettings": "הגדרות כלליות",
      "supportEmail": "אימייל תמיכה",
      "defaultPlan": "תוכנית ברירת מחדל",
      "termsUrl": "קישור לתנאי שימוש",
      "privacyUrl": "קישור למדיניות פרטיות",
      "userSettings": "הגדרות משתמשים",
      "maxDevices": "מקסימום מכשירים לחשבון",
      "trialDays": "ימי תקופת ניסיון",
      "maintenanceMode": "מצב תחזוקה",
      "maintenanceModeDesc": "כאשר פעיל, המערכת תהיה לא נגישה למשתמשים",
      "featureFlags": "דגלי תכונות",
      "systemActions": "פעולות מערכת",
      "clearCache": "נקה קאש",
      "resetAnalytics": "אפס אנליטיקס",
      "actionsWarning": "פעולות אלו עשויות להשפיע על תפקוד המערכת. השתמש בזהירות.",
      "savingSuccess": "ההגדרות נשמרו בהצלחה",
      "confirmClearCache": "לנקות את הקאש? זה עשוי להשפיע על הביצועים באופן זמני.",
      "cacheCleared": "הקאש נוקה בהצלחה",
      "confirmResetAnalytics": "לאפס את נתוני האנליטיקס? פעולה זו אינה הפיכה!",
      "analyticsReset": "נתוני האנליטיקס אופסו",
      "featureFlagLabels": {
        "new_player": "נגן חדש",
        "live_chat": "צ׳אט חי",
        "downloads": "הורדות",
        "watch_party": "צפייה משותפת",
        "voice_search": "חיפוש קולי",
        "ai_recommendations": "המלצות AI"
      }
    },
    "content": {
      "title": "ספריית תוכן",
      "subtitle": "ניהול סרטונים וסדרות",
      "importFree": "ייבא תוכן חינמי",
      "searchPlaceholder": "חפש תוכן...",
      "emptyMessage": "לא נמצא תוכן",
      "confirmDelete": "למחוק תוכן זה?",
      "confirmBatchDelete": "האם אתה בטוח שברצונך למחוק {{count}} פריטים?",
      "selectedItems": "{{count}} פריטים נבחרו",
      "batchFeature": "הוסף למובחרים",
      "batchUnfeature": "הסר ממובחרים",
      "import": {
        "pageTitle": "ייבא תוכן חינמי",
        "subtitle": "עיין והיבא תוכן ציבורי ממקורות חינמיים",
        "selectCategory": "בחר קטגוריה לסרטונים שייובאו:",
        "categoryPlaceholder": "בחר קטגוריה...",
        "loading": "טוען מקורות...",
        "sourceTypes": {
          "vod": "סרטונים וVOD",
          "live_tv": "טלוויזיה חיה",
          "radio": "רדיו",
          "podcasts": "פודקאסטים"
        },
        "items": "פריט",
        "itemsPlural": "פריטים",
        "selectItems": "אנא בחר לפחות פריט אחד לייבוא",
        "selectCategory_vod": "אנא בחר קטגוריה לייבוא VOD",
        "importing": "מייבא {{count}}... {{percent}}%",
        "importButton": "ייבא {{count}} {{item}}",
        "noSources": "אין מקורות זמינים",
        "noSourcesDescription": "אין מקורות תוכן חינמיים זמינים כרגע עבור {{type}}"
      },
      "filters": {
        "title": "פילטרים",
        "contentType": "סוג תוכן",
        "all": "הכל",
        "allContent": "הכל",
        "series": "סדרות",
        "movies": "סרטים",
        "podcasts": "פודקאסטים",
        "radioStations": "תחנות רדיו",
        "status": "סטטוס",
        "allStatus": "כל הסטטוסים",
        "subtitles": "כתוביות"
      },
      "podcastsComingSoon": "ניהול פודקאסטים בקרוב. השתמש בסעיף הפודקאסטים.",
      "radioComingSoon": "ניהול תחנות רדיו בקרוב. השתמש בסעיף תחנות הרדיו.",
      "showOnlyWithSubtitles": "הצג רק עם כתוביות",
      "status": {
        "published": "פורסם",
        "draft": "טיוטה"
      },
      "columns": {
        "title": "כותרת",
        "category": "קטגוריה",
        "year": "שנה",
        "status": "סטטוס",
        "views": "צפיות",
        "rating": "דירוג",
        "streamUrl": "כתובת Stream",
        "epgSource": "מקור EPG",
        "genre": "ז'אנר",
        "episodeNumber": "מספר פרק",
        "description": "תיאור",
        "duration": "משך",
        "publishedDate": "פורסם",
        "episodes": "פרקים",
        "order": "סדר",
        "name": "שם",
        "slug": "מזהה",
        "subtitles": "כתוביות"
      },
      "validation": {
        "titleRequired": "כותרת נדרשת",
        "nameRequired": "שם נדרש",
        "streamUrlRequired": "כתובת Stream נדרשת",
        "audioUrlRequired": "כתובת Audio נדרשת"
      },
      "episodes_one": "פרק",
      "episodes_other": "פרקים",
      "noEpisodes": "לא נמצאו פרקים",
      "type": {
        "series": "סדרה",
        "movie": "סרט"
      },
      "toggleCarousel": "הוסף/הסר מהקרוסלה",
      "editor": {
        "pageTitle": "ערוך תוכן",
        "pageTitleNew": "הוסף תוכן",
        "sections": {
          "basicInfo": "מידע בסיסי",
          "media": "מדיה",
          "streaming": "סטרימינג",
          "details": "פרטי תוכן",
          "publishing": "פרסום",
          "accessControl": "בקרת גישה",
          "podcastDetails": "פרטי פודקאסט",
          "episodeDetails": "פרטי פרק",
          "stationDetails": "פרטי תחנה",
          "channelDetails": "פרטי ערוץ"
        },
        "fields": {
          "title": "כותרת",
          "titlePlaceholder": "כותרת התוכן",
          "titleRequired": "נדרשת כותרת",
          "year": "שנה",
          "yearPlaceholder": "2024",
          "description": "תיאור",
          "descriptionPlaceholder": "תיאור התוכן",
          "thumbnail": "תמונה ממוזערת (יחס 3:4)",
          "thumbnailUrl": "כתובת URL לתמונה ממוזערת",
          "thumbnailUrlPlaceholder": "https://example.com/thumbnail.jpg",
          "backdrop": "תמונת רקע (יחס 16:9)",
          "backdropUrl": "כתובת URL לתמונת רקע",
          "posterCover": "עטיפת פודקאסט",
          "logo": "לוגו",
          "channelLogo": "לוגו ערוץ",
          "stationLogo": "לוגו תחנה",
          "streamUrl": "כתובת סטרימינג",
          "streamUrlRequired": "נדרשת כתובת סטרימינג",
          "streamType": "סוג סטרים",
          "drmProtected": "מוגן DRM",
          "drmProtectedLabel": "תוכן זה דורש הגנת DRM",
          "category": "קטגוריה",
          "categoryRequired": "נדרשת קטגוריה",
          "duration": "משך",
          "durationPlaceholder": "1:30:00",
          "rating": "דירוג",
          "ratingPlaceholder": "PG-13",
          "genre": "ז'אנר",
          "genrePlaceholder": "דרמה",
          "director": "במאי",
          "directorPlaceholder": "שם הבמאי",
          "isSeries": "סדרה",
          "isSeriesLabel": "זהו תוכן סדרתי/רב חלקים",
          "season": "עונה",
          "episode": "פרק",
          "seriesId": "מזהה סדרה",
          "seriesIdPlaceholder": "series-identifier",
          "isPublished": "פרסום",
          "isPublishedLabel": "פרסם תוכן זה מיידית",
          "isFeatured": "מומלץ",
          "isFeaturedLabel": "הצג תוכן זה בדף הבית",
          "requiresSubscription": "מנוי נדרש",
          "isKidsContent": "תוכן ילדים",
          "isKidsContentLabel": "זהו תוכן ידידותי לילדים",
          "author": "מחבר",
          "authorPlaceholder": "מחבר הפודקאסט",
          "podcastCategory": "קטגוריה",
          "podcastCategoryPlaceholder": "חדשות, מדע, וכו'",
          "rssFeed": "כתובת RSS Feed",
          "rssFeedPlaceholder": "https://example.com/feed.xml",
          "website": "כתובת אתר",
          "websitePlaceholder": "https://example.com",
          "episodeNumber": "מספר פרק",
          "seasonNumber": "מספר עונה",
          "audioUrl": "כתובת אודיו",
          "audioUrlRequired": "נדרשת כתובת אודיו",
          "audioUrlPlaceholder": "https://example.com/episode.mp3",
          "publishedAt": "תאריך פרסום",
          "epgSource": "מקור EPG",
          "epgSourcePlaceholder": "https://example.com/epg.xml",
          "currentShow": "תוכנית נוכחית",
          "currentShowPlaceholder": "שם התוכנית",
          "nextShow": "תוכנית הבאה",
          "nextShowPlaceholder": "שם התוכנית",
          "currentSong": "שיר נוכחי",
          "currentSongPlaceholder": "שם השיר",
          "isActive": "פעיל",
          "isActiveLabel": "הערוץ פעיל",
          "requiredSubscription": "מנוי נדרש",
          "publishedDate": "תאריך פרסום"
        },
        "subscriptionTiers": {
          "basic": "בסיסי",
          "premium": "פרימיום",
          "family": "משפחתי"
        },
        "actions": {
          "save": "שמור",
          "saving": "שומר...",
          "cancel": "ביטול"
        },
        "imageUpload": {
          "dropHere": "גרור תמונה לכאן או לחץ להעלאה",
          "formats": "PNG, JPG, WebP עד {{maxSize}}MB",
          "uploading": "מעלה...",
          "success": "התמונה הועלתה בהצלחה",
          "orPasteUrl": "או הדבק כתובת URL לתמונה",
          "urlPlaceholder": "https://example.com/image.jpg",
          "validateButton": "הוסף",
          "validating": "מאמת...",
          "clear": "הסר תמונה",
          "errors": {
            "imageOnly": "נא לבחור קובץ תמונה",
            "tooLarge": "גודל הקובץ חייב להיות פחות מ-{{maxSize}}MB",
            "uploadFailed": "העלאה נכשלה",
            "invalidUrl": "כתובת URL לא תקינה"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "בחר קטגוריה...",
        "searchPlaceholder": "חפש קטגוריות...",
        "loading": "טוען קטגוריות...",
        "noResults": "לא נמצאו קטגוריות",
        "noCategories": "אין קטגוריות זמינות",
        "createNew": "צור קטגוריה חדשה",
        "errors": {
          "loadFailed": "טעינת הקטגוריות נכשלה",
          "createFailed": "יצירת הקטגוריה נכשלה"
        },
        "modal": {
          "title": "צור קטגוריה חדשה",
          "placeholder": "שם קטגוריה (לדוגמה: סרטים, סדרות)",
          "creating": "יוצר...",
          "create": "צור"
        }
      },
      "streamUrlInput": {
        "copyUrl": "העתק URL",
        "copied": "URL הועתק ללוח",
        "streamType": "סוג סטרים",
        "validUrl": "URL תקין - זוהה כ-{{type}}",
        "errors": {
          "required": "נדרש URL של סטרים",
          "invalidFormat": "פורמט URL לא תקין"
        },
        "supportedFormats": {
          "title": "פורמטים נתמכים:",
          "hls": "HLS: סטרימים .m3u8",
          "dash": "DASH: סטרימים .mpd",
          "audio": "אודיו: סטרימים .mp3, .aac או אודיו"
        }
      }
    },
    "categories": {
      "subtitle": "ניהול קטגוריות תוכן",
      "emptyMessage": "לא נמצאו קטגוריות",
      "status": {
        "active": "פעיל",
        "inactive": "לא פעיל"
      },
      "form": {
        "nameHebrew": "שם הקטגוריה (עברית)",
        "nameEnglish": "שם הקטגוריה (אנגלית)",
        "slug": "כתובת ידידותית"
      }
    },
    "liveChannels": {
      "subtitle": "ניהול ערוצי טלוויזיה חיים",
      "emptyMessage": "לא נמצאו ערוצים חיים",
      "subtitleSettings": "הגדרות כתוביות חיות",
      "form": {
        "name": "שם הערוץ",
        "streamUrl": "כתובת הזרמה",
        "epgSource": "כתובת מקור EPG (אופציונלי)",
        "currentShow": "תוכנית נוכחית",
        "order": "מיקום",
        "supportsSubtitles": "הפעל כתוביות חיות",
        "primaryLanguage": "שפה ראשית (מקור)",
        "targetLanguages": "שפות תרגום זמינות",
        "targetLanguagesHelp": "בחר לאילו שפות משתמשים יכולים לתרגם בזמן אמת"
      }
    },
    "radioStations": {
      "subtitle": "ניהול תחנות רדיו",
      "emptyMessage": "לא נמצאו תחנות רדיו",
      "form": {
        "name": "שם התחנה",
        "genre": "ז'אנר",
        "streamUrl": "כתובת הזרמה",
        "currentShow": "תוכנית נוכחית (אופציונלי)",
        "currentSong": "שיר נוכחי (אופציונלי)",
        "order": "מיקום"
      }
    },
    "podcasts": {
      "subtitle": "ניהול פודקאסטים ופרקים",
      "episodesSubtitle": "ניהול פרקים",
      "emptyMessage": "לא נמצאו פודקאסטים",
      "noEpisodes": "לא נמצאו פרקים",
      "form": {
        "title": "שם הפודקאסט",
        "author": "כותב",
        "description": "תיאור",
        "category": "קטגוריה",
        "rssFeed": "כתובת RSS",
        "website": "כתובת אתר (אופציונלי)"
      },
      "episodes": {
        "form": {
          "title": "שם הפרק",
          "description": "תיאור",
          "episodeNumber": "מספר פרק",
          "seasonNumber": "מספר עונה (אופציונלי)",
          "duration": "משך",
          "audioUrl": "כתובת אודיו (נדרש)",
          "publishedDate": "תאריך פרסום (YYYY-MM-DD)"
        }
      }
    },
    "users": {
      "subtitle": "ניהול משתמשים וחשבונות",
      "addUser": "הוסף משתמש",
      "status": {
        "active": "פעיל",
        "inactive": "לא פעיל",
        "blocked": "חסום"
      },
      "filters": {
        "all": "הכל",
        "active": "פעילים",
        "inactive": "לא פעילים",
        "blocked": "חסומים"
      },
      "columns": {
        "name": "שם",
        "role": "תפקיד",
        "subscription": "מנוי",
        "noSubscription": "ללא מנוי",
        "status": "סטטוס",
        "created": "נוצר",
        "actions": "פעולות"
      },
      "confirmDelete": "מחיקת משתמש",
      "confirmDeleteMessage": "האם אתה בטוח שברצונך למחוק את {{name}}? פעולה זו לא ניתנת לביטול.",
      "resetPassword": "איפוס סיסמה",
      "block": "חסום",
      "unban": "בטל חסימה",
      "confirmResetPassword": "לשלוח אימייל לאיפוס סיסמה ל-{{email}}?",
      "resetPasswordSent": "אימייל לאיפוס סיסמה נשלח",
      "recentActivity": "פעילות אחרונה",
      "noActivity": "אין פעילות",
      "notFound": "משתמש לא נמצא",
      "backToList": "חזרה לרשימה",
      "banReason": "סיבת חסימה",
      "banReasonPrompt": "סיבת החסימה:",
      "confirmUnban": "בטל חסימת משתמש?",
      "userDetails": "פרטי משתמש",
      "id": "מזהה",
      "registered": "נרשם",
      "billingHistory": "היסטוריית תשלומים",
      "noPayments": "אין תשלומים"
    },
    "campaigns": {
      "subtitle": "נהל קודי קופון והנחות",
      "expired": "פג תוקף",
      "status": {
        "active": "פעיל",
        "inactive": "לא פעיל"
      },
      "columns": {
        "name": "שם",
        "discount": "הנחה",
        "usage": "שימושים",
        "validUntil": "תוקף",
        "status": "סטטוס",
        "actions": "פעולות"
      },
      "confirmDelete": "מחיקת קמפיין",
      "confirmDeleteMessage": "האם אתה בטוח שברצונך למחוק את \"{{name}}\"? פעולה זו לא ניתנת לביטול.",
      "searchPlaceholder": "חיפוש קמפיינים...",
      "emptyMessage": "לא נמצאו קמפיינים",
      "deactivate": "השבתה",
      "activate": "הפעלה",
      "createTitle": "קמפיין חדש",
      "editTitle": "עריכת קמפיין",
      "formSubtitle": "הגדר קוד קופון או הנחה",
      "form": {
        "name": "שם הקמפיין",
        "namePlaceholder": "לדוגמה: מבצע קיץ 2024",
        "code": "קוד קופון",
        "generate": "צור קוד",
        "discountType": "סוג הנחה",
        "discountValue": "ערך ההנחה",
        "maxUses": "מקסימום שימושים",
        "unlimited": "ללא הגבלה",
        "validUntil": "בתוקף עד",
        "active": "קמפיין פעיל"
      }
    },
    "subscriptions": {
      "subtitle": "צפה ונהל מנויי המערכת",
      "status": {
        "active": "פעיל",
        "paused": "מושהה",
        "cancelled": "בוטל",
        "expired": "פג תוקף"
      },
      "columns": {
        "user": "משתמש",
        "plan": "תוכנית",
        "price": "מחיר",
        "nextBilling": "חיוב הבא",
        "status": "סטטוס"
      },
      "perMonth": "/חודש",
      "searchPlaceholder": "חפש מנוי...",
      "emptyMessage": "לא נמצאו מנויים",
      "actions": {
        "changePlan": "שנה מסלול",
        "pause": "השהה",
        "resume": "המשך",
        "cancel": "ביטול",
        "delete": "מחק"
      },
      "editPlan": {
        "title": "שינוי תוכנית מנוי",
        "user": "משתמש",
        "currentPlan": "תוכנית נוכחית",
        "newPlan": "בחר תוכנית חדשה"
      },
      "addSubscription": {
        "title": "הוסף מנוי",
        "userEmail": "אימייל משתמש",
        "emailPlaceholder": "הזן אימייל משתמש",
        "duration": "משך (ימים)",
        "selectPlan": "בחר תוכנית"
      },
      "fillAllFields": "אנא מלא את כל השדות",
      "userNotFound": "משתמש לא נמצא",
      "selectOneToEdit": "אנא בחר מנוי אחד לעריכה",
      "selectToDelete": "אנא בחר מנויים למחיקה",
      "confirmDeleteMultiple": "למחוק {{count}} מנויים?",
      "selected": "נבחרו",
      "confirmDelete": "האם אתה בטוח שברצונך למחוק את המנוי עבור {{user}}? פעולה זו אינה ניתנת לביטול."
    },
    "marketingDashboard": {
      "subtitle": "סקירת שיווק",
      "refresh": "רענן",
      "totalSubscribers": "סה״כ מנויים",
      "emailOpenRate": "שיעור פתיחת אימיילים",
      "pushClickRate": "שיעור לחיצה על התראות",
      "activeSegments": "סגמנטים פעילים",
      "campaignStatus": {
        "active": "פעיל",
        "completed": "הושלם",
        "scheduled": "מתוזמן",
        "draft": "טיוטה"
      }
    },
    "transactions": {
      "subtitle": "צפה בהיסטוריית התשלומים",
      "exportCsv": "ייצא CSV",
      "status": {
        "completed": "הושלם",
        "pending": "ממתין",
        "failed": "נכשל",
        "refunded": "הוחזר"
      },
      "columns": {
        "id": "מזהה",
        "user": "משתמש",
        "amount": "סכום",
        "type": "סוג",
        "status": "סטטוס",
        "date": "תאריך"
      },
      "filters": {
        "all": "הכל"
      },
      "searchPlaceholder": "חפש עסקה...",
      "emptyMessage": "לא נמצאו עסקאות",
      "details": "פרטי עסקה",
      "email": "אימייל"
    },
    "pushNotifications": {
      "subtitle": "צור ושלח התראות למשתמשים",
      "newNotification": "התראה חדשה",
      "status": {
        "draft": "טיוטה",
        "sent": "נשלח",
        "scheduled": "מתוזמן"
      },
      "columns": {
        "title": "כותרת",
        "status": "סטטוס",
        "sent": "נשלחו",
        "opened": "נפתחו",
        "scheduledAt": "מתוזמן ל",
        "created": "נוצר",
        "actions": "פעולות"
      },
      "filters": {
        "all": "הכל"
      },
      "searchPlaceholder": "חפש התראה...",
      "emptyMessage": "לא נמצאו התראות",
      "createModal": "התראת פוש חדשה",
      "editModal": "עריכת התראה",
      "scheduleModal": "תזמון התראה",
      "titleLabel": "כותרת",
      "bodyLabel": "תוכן",
      "dateTimeLabel": "תאריך ושעה",
      "cancel": "ביטול",
      "create": "צור התראה",
      "schedule": "תזמן",
      "send": "שלח עכשיו",
      "confirmSend": "שלח את ההתראה \"{{title}}\"?",
      "confirmDelete": "מחק את ההתראה \"{{title}}\"?",
      "fillRequired": "נא למלא כותרת ותוכן"
    }
  },
  "placeholder": {
    "email": "your@email.com",
    "password": "••••••••",
    "pin": "••••",
    "dateRange": {
      "from": "מ- (YYYY-MM-DD)",
      "to": "עד (YYYY-MM-DD)"
    },
    "amount": {
      "min": "מינימום",
      "max": "מקסימום",
      "price": "0.00"
    },
    "chatMessage": "או הקלד כאן...",
    "deepLink": "bayitplus://content/123",
    "scheduleDateTime": "YYYY-MM-DDTHH:mm",
    "roomCode": "ABCD1234",
    "time": {
      "start": "08:00",
      "end": "10:00"
    },
    "filter": {
      "userId": "הזן ID משתמש"
    },
    "datetime": "YYYY-MM-DDTHH:mm",
    "number": "0",
    "chat": "הקלד הודעה..."
  },
  "components": {
    "select": {
      "default": "בחר..."
    }
  },
  "plans": {
    "basic": {
      "name": "בסיסי",
      "features": [
        "כל תוכן ה-VOD",
        "רדיו ופודקאסטים",
        "צפייה על מכשיר אחד",
        "איכות SD"
      ],
      "notIncluded": [
        "ערוצי שידור חי",
        "עוזר AI",
        "צפייה אופליין"
      ]
    },
    "premium": {
      "name": "פרימיום",
      "features": [
        "כל תוכן ה-VOD",
        "ערוצי שידור חי",
        "רדיו ופודקאסטים",
        "עוזר AI חכם",
        "צפייה על 2 מכשירים",
        "איכות HD"
      ],
      "notIncluded": [
        "צפייה אופליין",
        "פרופילים משפחתיים"
      ]
    },
    "family": {
      "name": "משפחתי",
      "features": [
        "כל תוכן ה-VOD",
        "ערוצי שידור חי",
        "רדיו ופודקאסטים",
        "עוזר AI חכם",
        "צפייה על 4 מכשירים",
        "איכות 4K",
        "5 פרופילים משפחתיים",
        "הורדה לצפייה אופליין"
      ],
      "notIncluded": []
    },
    "batchActions": {
      "selectedCount": "{{count}} נבחרו",
      "selectedCount_one": "{{count}} נבחר",
      "selectedCount_other": "{{count}} נבחרו",
      "clear": "נקה"
    },
    "costDashboard": {
      "title": "לוח עלויות",
      "costBreakdown": "פירוט עלויות",
      "loadingBreakdown": "טוען פירוט...",
      "aiCosts": "עלויות AI",
      "infrastructure": "תשתית",
      "thirdParty": "צד שלישי",
      "thirdPartyApis": "ממשקי API של צד שלישי",
      "translation": "תרגום",
      "search": "חיפוש",
      "percentOfTotal": "% מהסה״כ",
      "components": "רכיבים",
      "topSpenders": {
        "title": "20 המשתמשים המובילים (חודשי)",
        "loading": "טוען משתמשים מובילים...",
        "rank": "דירוג",
        "userId": "מזהה משתמש",
        "costRange": "טווח עלויות",
        "privacyNote": "מזהי המשתמשים מוצפנים והעלויות מוצגות בטווחים להגנת הפרטיות."
      },
      "categories": {
        "permanent": "קבוע",
        "transient": "משתנה",
        "permanentVsTransient": "קבוע מול משתנה",
        "permanentFixed": "קבוע (תשתית)",
        "transientVariable": "משתנה (שימוש)",
        "permanentDesc": "עלויות תשתית שמתרחשות מדי חודש ללא קשר לשימוש",
        "transientDesc": "עלויות תלויות שימוש שמשתנות עם פעילות הפלטפורמה",
        "detailedBreakdown": "פירוט מפורט",
        "costItem": "פריט עלות",
        "category": "קטגוריה",
        "amount": "סכום"
      },
      "timeline": {
        "title": "ציר זמן עלויות",
        "loading": "טוען ציר זמן...",
        "amountLabel": "סכום ($)",
        "revenue": "הכנסות",
        "totalCost": "סה״כ עלויות",
        "netProfit": "רווח נקי",
        "showingData": "מציג נתונים מ-{{start}} עד {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "רווח/הפסד נקי",
        "margin": "מרווח",
        "revenue": "הכנסות",
        "totalCosts": "סה״כ עלויות"
      }
    }
  },
  "subscribe": {
    "title": "בחר את המסלול שלך",
    "subtitle": "7 ימי ניסיון חינם לכל מסלול. בטל בכל עת.",
    "monthly": "חודשי",
    "yearly": "שנתי",
    "save2Months": "חסכו 2 חודשים",
    "popular": "הכי פופולרי",
    "period": "לחודש",
    "perYear": "לשנה",
    "select": "בחר מסלול",
    "selected": "נבחר",
    "processing": "מעבד...",
    "startTrial": "התחל ניסיון חינם",
    "noCharge": "לא יחויב כרטיס האשראי במהלך תקופת הניסיון"
  },
  "notFound": {
    "title": "הדף לא נמצא",
    "description": "הדף שחיפשת לא קיים או הועבר למקום אחר.",
    "homeButton": "לדף הבית",
    "searchButton": "חיפוש",
    "orTry": "או נסה:",
    "liveChannel": "שידור חי",
    "vodLabel": "VOD",
    "podcastsLabel": "פודקאסטים"
  },
  "profiles": {
    "addProfile": "הוסף פרופיל",
    "enterPin": "הזן קוד PIN",
    "selectError": "שגיאה בבחירת פרופיל",
    "wrongPin": "קוד PIN שגוי",
    "loading": "טוען פרופילים...",
    "manage": "ניהול פרופילים",
    "whoIsWatching": "מי צופה?",
    "manageProfiles": "ניהול פרופילים",
    "kids": "ילדים",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "התוכן לא נמצא",
    "backToHome": "חזרה לדף הבית",
    "episodes": "פרקים",
    "addToList": "הוסף לרשימה",
    "like": "אהבתי",
    "share": "שתף",
    "cast": "שחקנים",
    "episodesList": "פרקים",
    "schedule": "לוח שידורים",
    "now": "עכשיו",
    "related": "תוכן דומה",
    "deleteEpisode": "מחק פרק",
    "confirmDeleteEpisode": "מחק פרק זה?"
  },
  "live": {
    "title": "שידור חי",
    "next": "הבא:",
    "noChannels": "אין ערוצים זמינים",
    "tryLater": "נסה שוב מאוחר יותר",
    "categories": {
      "all": "הכל",
      "news": "חדשות",
      "entertainment": "בידור",
      "sports": "ספורט",
      "kids": "ילדים",
      "music": "מוזיקה"
    }
  },
  "judaism": {
    "title": "יהדות",
    "items": "פריטים",
    "empty": "אין תוכן זמין",
    "emptyHint": "נסה לבחור קטגוריה אחרת",
    "dashboard": "לוח היהדות שלך",
    "categories": {
      "news": "חדשות יהודיות",
      "community": "קהילה"
    },
    "shabbat": {
      "title": "זמני שבת",
      "shabbatShalom": "שבת שלום!",
      "shabbatMode": "מצב שבת",
      "endsIn": "השבת יוצאת בעוד",
      "candleLighting": "הדלקת נרות",
      "havdalah": "הבדלה",
      "parashat": "פרשת",
      "friday": "יום שישי",
      "saturday": "שבת",
      "noData": "לא ניתן לטעון זמני שבת"
    },
    "erevShabbat": {
      "title": "ערב שבת",
      "prepareFor": "התכונן לשבת",
      "inTime": "בעוד {{time}}",
      "featuredContent": "תוכן לשבת",
      "noContent": "תוכן שבת בקרוב!",
      "shabbatShalom": "שבת שלום!",
      "timeUntil": "זמן עד שבת",
      "shabbatSongs": "שירי שבת",
      "parashaStudy": "פרשה",
      "shabbatRecipes": "מתכונים",
      "prayers": "תפילות"
    }
  },
  "children": {
    "title": "ילדים",
    "items": "פריטים",
    "empty": "אין תוכן זמין",
    "emptyHint": "נסה קטגוריה אחרת",
    "exitKidsMode": "יציאה ממצב ילדים",
    "exitDescription": "הזן את קוד ההורה כדי לצאת",
    "parentCode": "קוד הורה",
    "confirm": "אישור",
    "wrongCode": "קוד PIN שגוי",
    "noContent": "אין תוכן זמין",
    "tryAnotherCategory": "נסה לבחור קטגוריה אחרת",
    "categories": {
      "all": "הכל",
      "cartoons": "סרטים מצוירים",
      "educational": "חינוכי",
      "music": "מוזיקה",
      "hebrew": "עברית",
      "stories": "סיפורים",
      "jewish": "יהודי"
    },
    "ageRatings": {
      "3": "גילאי 3+",
      "5": "גילאי 5+",
      "7": "גילאי 7+",
      "10": "גילאי 10+",
      "12": "גילאי 12+"
    },
    "moderation": {
      "pending": "ממתין לבדיקה",
      "approved": "אושר",
      "rejected": "נדחה"
    },
    "admin": {
      "stats": "מנהל תוכן ילדים",
      "seedContent": "הזנת תוכן",
      "importArchive": "ייבוא מ-Archive.org",
      "syncPodcasts": "סנכרון פודקאסטים",
      "syncYouTube": "סנכרון יוטיוב",
      "tagVod": "תיוג VOD",
      "pendingModeration": "ממתין למודרציה"
    }
  },
  "youngsters": {
    "title": "צעירים",
    "items": "פריטים",
    "empty": "אין תוכן זמין",
    "emptyHint": "נסה קטגוריה אחרת",
    "exitYoungstersMode": "יציאה ממצב צעירים",
    "exitDescription": "הזן את קוד ההורה כדי לצאת",
    "parentCode": "קוד הורה",
    "confirm": "אישור",
    "wrongCode": "קוד PIN שגוי",
    "noContent": "אין תוכן זמין",
    "tryAnotherCategory": "נסה לבחור קטגוריה אחרת",
    "categories": {
      "all": "הכל",
      "trending": "טרנדים",
      "news": "חדשות",
      "culture": "תרבות",
      "educational": "לימודי",
      "music": "מוזיקה",
      "entertainment": "בידור",
      "sports": "ספורט",
      "tech": "טכנולוגיה",
      "judaism": "יהדות"
    },
    "ageGroups": {
      "middle-school": "חטיבת ביניים (12-14)",
      "high-school": "תיכון (15-17)"
    },
    "moderation": {
      "pending": "ממתין לבדיקה",
      "approved": "אושר",
      "rejected": "נדחה"
    },
    "admin": {
      "stats": "מנהל תוכן צעירים",
      "seedContent": "הזנת תוכן",
      "importArchive": "ייבוא מ-Archive.org",
      "syncPodcasts": "סנכרון פודקאסטים",
      "syncYouTube": "סנכרון יוטיוב",
      "tagVod": "תיוג VOD",
      "pendingModeration": "ממתין למודרציה"
    }
  },
  "chatbot": {
    "title": "עוזר בית+",
    "greeting": "שלום! אני העוזר החכם של בית+. איך אוכל לעזור לך היום? לחץ על המיקרופון ודבר אליי, או הקלד הודעה.",
    "openChat": "פתח צ'אט",
    "welcome": "שלום! אני העוזר החכם של בית+. איך אוכל לעזור לך היום? לחץ על המיקרופון ודבר אליי, או הקלד הודעה.",
    "placeholder": "או הקלד כאן...",
    "recording": "מקליט... לחץ שוב לסיום",
    "transcribing": "מתמלל...",
    "stopRecording": "עצור הקלטה",
    "startRecording": "התחל הקלטה קולית",
    "recommendations": "הנה כמה המלצות:",
    "showMultipleSuccess": "מציג {{count}} פריטי תוכן בווידג'טים",
    "showMultipleNotFound": "לא מצאתי את התוכן המבוקש. נסה שמות אחרים.",
    "resolvingContent": "מחפש את התוכן שלך...",
    "errors": {
      "micPermission": "לא הצלחתי לגשת למיקרופון. אנא בדוק את הרשאות המיקרופון בדפדפן.",
      "transcribeFailed": "לא הצלחתי לתמלל את ההקלטה. אנא נסה שוב.",
      "general": "מצטער, משהו השתבש. אנא נסה שוב."
    },
    "suggestions": {
      "whatToWatch": "מה לראות היום?",
      "israeliMovies": "סרטים ישראליים מומלצים",
      "whatsOnNow": "מה משודר עכשיו?",
      "popularPodcasts": "פודקאסטים פופולריים"
    },
    "voiceCommands": {
      "showChannels": "הראה לי את הערוצים...",
      "playChess": "התחל משחק שחמט עם...",
      "multiContent": "הצג זה לצד זה..."
    }
  },
  "chat": {
    "title": "עוזר בית+",
    "greeting": "שלום! אני העוזר החכם של בית+. איך אוכל לעזור לך היום? לחץ על המיקרופון ודבר אליי, או הקלד הודעה."
  },
  "subtitles": {
    "nikud": "ניקוד",
    "selection": "בחירה",
    "translation": "תרגום",
    "translating": "מתרגם...",
    "close": "סגור",
    "unavailable": "תרגום לא זמין",
    "off": "כבוי",
    "none": "אין",
    "autoGenerated": "נוצרו אוטומטית",
    "selectLanguage": "בחר שפת כתוביות",
    "liveTranslate": "תרגום חי",
    "translateTo": "תרגם לשפה",
    "downloadMore": "הורד כתוביות נוספות...",
    "downloading": "מחפש ב-OpenSubtitles...",
    "opensubtitlesSource": "מ-OpenSubtitles.com",
    "downloadSuccess": "הורדו {{count}} כתוביות",
    "noSubtitlesFound": "לא נמצאו כתוביות לתוכן זה",
    "smartSubs": "כתוביות חכמות",
    "smartSubsDescription": "תצוגה כפולה: עברית פשוטה + אנגלית עם הדגשת שורשים",
    "smartSubsDualView": "תצוגה כפולה",
    "shoreshToggle": "הדגשת שורשים",
    "shoreshOn": "הדגשת שורשים מופעלת",
    "shoreshOff": "הדגשת שורשים כבויה",
    "nikudLive": "עברית עם ניקוד",
    "nikudLiveDescription": "כתוביות עבריות מנוקדות לקריאה קלה יותר",
    "nikudEnabled": "כתוביות עם ניקוד מופעלות",
    "nikudDisabled": "כתוביות עם ניקוד כבויות",
    "nikudSubtitleLabel": "עברית עם ניקוד: {{text}}",
    "available": "כתוביות",
    "clickToEnable": "לחץ להפעלת תרגום חי",
    "connectionError": "שגיאת תרגום חי",
    "inputLanguageTooltip": "בדוק שפת קלט",
    "premiumRequired": "נדרש מנוי פרימיום",
    "selectInputLanguage": "בחר שפת קלט",
    "translateActive": "תרגום חי פעיל",
    "noEnglishSubtitles": "אין כתוביות באנגלית לתוכן זה.",
    "hebrewMode": {
      "title": "מצב תצוגה עברית",
      "unavailable": "לא זמין",
      "generate": "צור",
      "regular": {
        "title": "עברית רגילה",
        "description": "טקסט עברי סטנדרטי ללא סימני ניקוד"
      },
      "nikud": {
        "title": "עברית עם ניקוד",
        "description": "עברית מנוקדת לקריאה קלה יותר",
        "unavailableReason": "עיבוד AI לא זמין לתוכן זה"
      },
      "shoresh": {
        "title": "שורש (מילות שורש)",
        "description": "מילים עבריות עם ניתוח שורשים: מילה [שורש]",
        "unavailableReason": "ניתוח שורשים לא זמין לתוכן זה"
      }
    },
    "englishMode": {
      "title": "מצב תצוגה אנגלית",
      "unavailable": "לא זמין",
      "generate": "צור",
      "firstTimeHint": "מצבים אלה מונעי AI עוזרים לשמור על עברית תוך לימוד מבנה משפטים באנגלית. כל מצב מציע חוויית לימוד ייחודית.",
      "regular": {
        "title": "אנגלית רגילה",
        "description": "כתוביות אנגלית סטנדרטיות"
      },
      "heblish": {
        "title": "עברנגלית",
        "description": "אנגלית עם הזרקות מילים עבריות ללמידה אימרסיבית",
        "unavailableReason": "עיבוד Heblish לא זמין לתוכן זה"
      },
      "grammarFlip": {
        "title": "היפוך דקדוק",
        "description": "מילים עבריות עם מבנה משפט אנגלי (נושא-פועל-מושא)",
        "unavailableReason": "עיבוד היפוך דקדוק לא זמין לתוכן זה"
      },
      "slangSynthesis": {
        "title": "סינתזת סלנג",
        "description": "שילוב סלנג ישראלי ואמריקאי מודרני לתוכן מעניין",
        "unavailableReason": "עיבוד סינתזת סלנג לא זמין לתוכן זה"
      }
    },
    "loading": "טוען כתוביות...",
    "error": {
      "title": "שגיאת כתוביות",
      "retry": "נסה שוב",
      "loadFailed": "טעינת כתוביות נכשלה",
      "cuesFailed": "טעינת טקסט כתוביות נכשלה",
      "networkError": "שגיאת רשת - בדוק את החיבור שלך",
      "serverError": "שגיאת שרת - נסה שוב מאוחר יותר"
    },
    "aiModesAvailable": "מצבי AI זמינים",
    "aiModesTitle": "מצבי כתוביות AI",
    "fetchSubtitles": "הבא כתוביות",
    "fontSize": "גודל גופן",
    "mode": {
      "engrew": "אנגרו",
      "heblish": "עברלי",
      "shoresh": "שורש",
      "standard": "רגיל"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "חפש כתוביות חיצוניות",
    "settingsTitle": "הגדרות כתוביות",
    "showBackground": "הצג רקע",
    "singleMode": "מצב יחיד",
    "splitMode": "מצב מפוצל",
    "primary_language": "שפה ראשית",
    "secondary_language": "שפה משנית",
    "layout_mode": "מצב פריסה",
    "interactive_title": "כתוביות אינטראקטיביות"
  },
  "video": {
    "watchTrailer": "צפה בטריילר",
    "closeTrailer": "סגור טריילר",
    "deleteConfirm": "מחק פרק זה?"
  },
  "recordings": {
    "title": "ההקלטות שלי",
    "subtitle": "צפה ונהל את שידורי החי שהקלטת",
    "record": "הקלט",
    "recording": "מקליט",
    "storageUsed": "אחסון בשימוש",
    "totalRecordings": "סה״כ הקלטות",
    "maxDuration": "משך מקסימלי",
    "noRecordings": "אין הקלטות עדיין",
    "noRecordingsHint": "התחל להקליט מכל ערוץ חי!",
    "confirmDelete": "האם אתה בטוח שברצונך למחוק הקלטה זו? לא ניתן לבטל פעולה זו.",
    "deleteRecording": "מחק הקלטה",
    "deleteFailed": "מחיקת ההקלטה נכשלה",
    "expires": "פג תוקף",
    "subtitlesAvailable": "כתוביות זמינות",
    "recordingSaved": "ההקלטה נשמרה!",
    "savedSuccess": "ההקלטה נשמרה בהצלחה! משך: {{duration}}",
    "viewInMyRecordings": "צפה בהקלטות שלי",
    "error": "שגיאת הקלטה",
    "startFailed": "התחלת ההקלטה נכשלה. אנא נסה שוב.",
    "stopFailed": "עצירת ההקלטה נכשלה. אנא נסה שוב.",
    "page": "עמוד"
  },
  "chess": {
    "title": "שחמט",
    "welcome": "ברוך הבא למשחק השחמט",
    "subtitle": "שחק שחמט עם חברים ומשפחה ברחבי העולם",
    "createGame": "צור משחק חדש",
    "joinGame": "הצטרף למשחק",
    "gameCode": "קוד משחק",
    "enterGameCode": "הכנס קוד משחק",
    "invalidGameCode": "קוד משחק לא תקין. חייב להיות 6 תווים.",
    "joinFailed": "ההצטרפות למשחק נכשלה",
    "join": "הצטרף",
    "create": "צור",
    "chooseColor": "בחר את הצבע שלך",
    "white": "לבן",
    "black": "שחור",
    "chatPlaceholder": "הקלד הודעה... (@bot לייעוץ)",
    "botHint": "תייג @bot בהודעה שלך כדי לקבל ייעוץ שחמט מעוזר ה-AI שלנו",
    "bot": "עוזר השחמט",
    "mute": "השתק",
    "unmute": "בטל השתקה",
    "speaking": "משתתפים",
    "resign": "הפסד",
    "offerDraw": "הצע תיקו",
    "newGame": "משחק חדש",
    "checkmate": "מט!",
    "stalemate": "פט",
    "draw": "תיקו",
    "resigned": "המשחק הסתיים בהפסד",
    "reconnecting": "מתחבר מחדש...",
    "moveHistory": "היסטוריית מהלכים",
    "noMoves": "אין מהלכים עדיין",
    "showHints": "הצג רמזים מנחים",
    "yourTurn": "התור שלך",
    "opponentTurn": "התור של היריב",
    "waitingForOpponent": "ממתין ליריב...",
    "gameOver": "המשחק נגמר",
    "sendingInvite": "שולח הזמנה ל{{name}}...",
    "inviteSent": "הזמנה נשלחה ל{{name}}! קוד משחק: {{code}}",
    "inviteFailed": "לא מצאתי את המשתמש הזה. בדוק את השם ונסה שוב.",
    "inviteReceived": "{{name}} הזמין אותך למשחק שחמט!",
    "joinInvite": "הצטרף למשחק",
    "challenge": "אתגר",
    "playedAsWhite": "שיחק כלבן",
    "playedAsBlack": "שיחק כשחור",
    "gameMode": "מצב משחק",
    "playVsFriend": "שחק נגד חבר",
    "playVsBot": "שחק נגד בוט",
    "difficulty": "רמת קושי",
    "easy": "קל",
    "medium": "בינוני",
    "hard": "קשה",
    "chessBot": "בוט שחמט",
    "chat": {
      "title": "צ'אט",
      "inputPlaceholder": "הקלד הודעה..."
    },
    "acceptDraw": "קבל תיקו",
    "acceptInvite": "קבל הזמנה",
    "blackCaptured": "שחור נלכד",
    "blackTurn": "תור השחור",
    "challengeFriend": "אתגר חבר",
    "challengeViaWhatsApp": "אתגר דרך WhatsApp",
    "copyCode": "העתק קוד",
    "declineDraw": "סרב לתיקו",
    "declineInvite": "סרב להזמנה",
    "drawOffered": "הוצע תיקו",
    "joinByGameCode": "הצטרף עם קוד משחק",
    "noFriendsYet": "אין חברים עדיין",
    "offline": "לא מקוון",
    "online": "מקוון",
    "opponent": "יריב",
    "whiteCaptured": "לבן נלכד",
    "whiteTurn": "תור הלבן",
    "you": "You"
  },
  "friends": {
    "title": "חברים ויריבים",
    "subtitle": "התחבר עם שחקנים ואתגר חברים",
    "myFriends": "החברים שלי",
    "requests": "בקשות",
    "findPlayers": "מצא שחקנים",
    "friendsLabel": "חברים",
    "pendingLabel": "ממתין",
    "add": "הוסף חבר",
    "remove": "הסר",
    "accept": "קבל",
    "reject": "דחה",
    "cancel": "בטל",
    "noFriends": "עדיין אין חברים",
    "noFriendsDesc": "חפש שחקנים ושלח בקשות חברות",
    "lastGame": "משחק אחרון: {{time}}",
    "friendsSince": "חברים מאז {{date}}",
    "incomingRequests": "בקשות נכנסות",
    "outgoingRequests": "בקשות יוצאות",
    "noIncoming": "אין בקשות נכנסות",
    "noOutgoing": "אין בקשות יוצאות",
    "sentAt": "נשלח {{time}}",
    "searchPlaceholder": "חפש לפי שם...",
    "noResults": "לא נמצאו שחקנים",
    "noResultsDesc": "נסה לחפש בשם אחר",
    "requestSent": "בקשת חברות נשלחה!",
    "requestAccepted": "בקשת חברות התקבלה!",
    "requestRejected": "בקשת חברות נדחתה",
    "requestCancelled": "בקשת חברות בוטלה",
    "friendRemoved": "החבר הוסר",
    "searchFailed": "החיפוש נכשל",
    "requestFailed": "שליחת הבקשה נכשלה",
    "acceptFailed": "קבלת הבקשה נכשלה",
    "rejectFailed": "דחיית הבקשה נכשלה",
    "cancelFailed": "ביטול הבקשה נכשל",
    "removeFailed": "הסרת החבר נכשלה",
    "friendsCount": "{{count}} חברים",
    "gamesCount": "{{count}} משחקים",
    "alreadyFriends": "חברים"
  },
  "stats": {
    "statistics": "סטטיסטיקות",
    "matchHistory": "היסטוריית משחקים",
    "headToHead": "עימות ישיר",
    "gamesPlayed": "משחקים ששוחקו",
    "wins": "ניצחונות",
    "losses": "הפסדים",
    "draws": "תיקו",
    "winRate": "אחוז ניצחונות",
    "rating": "דירוג",
    "peakRating": "דירוג שיא",
    "peak": "שיא",
    "winStreak": "רצף ניצחונות",
    "currentStreak": "רצף נוכחי",
    "bestStreak": "הרצף הטוב ביותר",
    "performance": "ביצועים",
    "achievements": "הישגים",
    "currentRating": "דירוג נוכחי",
    "totalGames": "סה״כ משחקים",
    "noGames": "עדיין לא שוחקו משחקים",
    "moves": "מהלכים",
    "won": "ניצח",
    "lost": "הפסיד",
    "draw": "תיקו",
    "overall": "תיעוד כללי",
    "yourWins": "הניצחונות שלך",
    "theirWins": "הניצחונות שלהם",
    "totalGamesPlayed": "סה״כ: {{count}} משחקים",
    "recentGames": "משחקים אחרונים"
  },
  "support": {
    "title": "מרכז תמיכה",
    "subtitle": "איך נוכל לעזור לך היום?",
    "tabs": {
      "docs": "תיעוד",
      "faq": "שאלות נפוצות",
      "contact": "צור קשר",
      "tickets": "הפניות שלי"
    },
    "categories": {
      "title": "עיין בתיעוד",
      "loading": "טוען תיעוד...",
      "loadError": "טעינת קטגוריות נכשלה",
      "articleCount": "{{count}} מאמרים",
      "gettingStarted": "מתחילים",
      "features": "תכונות",
      "troubleshooting": "פתרון בעיות",
      "account": "חשבון"
    },
    "docs": {
      "loading": "טוען מסמך...",
      "loadError": "טעינת מסמך נכשלה",
      "backToList": "חזרה לתיעוד"
    },
    "search": {
      "placeholder": "חפש בתיעוד...",
      "noResults": "לא נמצאו תוצאות"
    },
    "faq": {
      "title": "שאלות נפוצות",
      "loading": "טוען שאלות נפוצות...",
      "loadError": "טעינת שאלות נפוצות נכשלה",
      "empty": "אין פריטים בקטגוריה זו",
      "categories": {
        "all": "כל הנושאים",
        "general": "כללי",
        "billing": "חיוב",
        "technical": "טכני",
        "features": "תכונות"
      }
    },
    "contact": {
      "voiceTitle": "תמיכה קולית",
      "voiceDescription": "לחץ על כפתור האווטאר או אמור \"ג'רביס\" כדי להתחיל שיחה קולית עם העוזר שלנו.",
      "ticketTitle": "צור פנייה",
      "ticketDescription": "צריך עזרה אנושית? צור פנייה והצוות שלנו יגיב תוך 24 שעות.",
      "createTicket": "צור פנייה",
      "emailTitle": "תמיכה באימייל",
      "emailDescription": "מעדיף אימייל? פנה אלינו ב-support@bayit.tv לכל שאלה."
    },
    "ticket": {
      "title": "צור פנייה חדשה",
      "subject": "נושא",
      "subjectPlaceholder": "תיאור קצר של הבעיה",
      "message": "הודעה",
      "messagePlaceholder": "תאר את הבעיה בפירוט...",
      "categoryLabel": "קטגוריה",
      "priorityLabel": "עדיפות",
      "submit": "שלח פנייה",
      "category": {
        "billing": "חיוב",
        "technical": "טכני",
        "feature": "בקשת תכונה",
        "general": "כללי"
      },
      "priority": {
        "low": "נמוכה",
        "medium": "בינונית",
        "high": "גבוהה",
        "urgent": "דחופה"
      },
      "status": {
        "open": "פתוח",
        "in_progress": "בטיפול",
        "resolved": "נפתר",
        "closed": "סגור"
      },
      "created": "נוצר",
      "error": {
        "required": "נא למלא את כל השדות הנדרשים",
        "submit": "יצירת הפנייה נכשלה. נסה שוב."
      }
    },
    "tickets": {
      "title": "הפניות שלי",
      "loading": "טוען פניות...",
      "loadError": "טעינת פניות נכשלה",
      "empty": "אין פניות עדיין",
      "emptyFilter": "אין פניות בסטטוס זה",
      "create": "פנייה חדשה",
      "createFirst": "צור את הפנייה הראשונה שלך",
      "filter": {
        "all": "הכל",
        "open": "פתוח",
        "inProgress": "בטיפול",
        "resolved": "נפתר"
      }
    },
    "voice": {
      "title": "עוזר קולי",
      "listening": "אני מקשיב...",
      "thinking": "תן לי לחשוב על זה...",
      "speaking": "מדבר...",
      "error": "סליחה, לא שמעתי. נסה שוב?",
      "ready": "מה תרצה לדעת?",
      "listeningNow": "מקשיב...",
      "wakeWordHint": "אמור \"ג'רביס\" כדי לדבר"
    },
    "wizard": {
      "role": "המדריך שלך"
    }
  },
  "jerusalem": {
    "title": "חיבור לירושלים",
    "subtitle": "הישארו מחוברים ללב של ישראל",
    "noContent": "אין תוכן ירושלים זמין",
    "sources": "מקורות",
    "kotelLive": "הכותל בשידור חי",
    "categories": {
      "kotel": "הכותל המערבי",
      "idf-ceremony": "טקסי צה\"ל",
      "diaspora-connection": "קשר התפוצות",
      "holy-sites": "אתרים קדושים",
      "jerusalem-events": "אירועים בירושלים",
      "general": "ירושלים"
    }
  },
  "telAviv": {
    "title": "חיבור לתל אביב",
    "subtitle": "העיר שלא נחה לרגע",
    "noContent": "אין תוכן תל אביב זמין",
    "sources": "מקורות",
    "beachLive": "מצלמת חוף",
    "categories": {
      "beaches": "חופים",
      "nightlife": "חיי לילה",
      "culture": "תרבות ואמנות",
      "music": "מוזיקה",
      "food": "אוכל ומסעדות",
      "tech": "סטארטאפים והייטק",
      "events": "אירועים",
      "general": "תל אביב"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "ברוכים הבאים לשליטה קולית",
      "description": "שלוט בבית פלוס עם הקול שלך לחוויה ללא ידיים."
    },
    "features": {
      "voiceCommands": "פקודות קוליות",
      "voiceCommandsDesc": "נווט, חפש ושלוט בהפעלה בעזרת דיבור טבעי",
      "tts": "טקסט לדיבור",
      "ttsDesc": "שמע תגובות ותיאורי תוכן מושמעים בקול",
      "wakeWord": "מילת הפעלה",
      "wakeWordDesc": "אמור 'בית' כדי להפעיל שליטה קולית בכל עת"
    },
    "getStarted": "התחל",
    "permissions": {
      "title": "גישה למיקרופון",
      "description": "שליטה קולית דורשת גישה למיקרופון כדי לשמוע את הפקודות שלך",
      "privacy": "נתוני הקול שלך מעובדים בצורה מאובטחת ולא נשמרים"
    },
    "permissionsGranted": "גישה למיקרופון אושרה",
    "permissionRequired": {
      "title": "נדרשת הרשאה",
      "message": "אנא הפעל גישה למיקרופון בהגדרות המכשיר שלך כדי להשתמש בשליטה קולית"
    },
    "grantPermissions": "אשר הרשאות",
    "testWakeWord": {
      "title": "בדוק מילת הפעלה",
      "description": "אמור 'בית' כדי לבדוק הפעלה קולית",
      "success": "מעולה! הפעלה קולית עובדת"
    },
    "startTest": "התחל בדיקה",
    "complete": {
      "title": "הכל מוכן!",
      "description": "שליטה קולית מופעלת כעת. נסה את הפקודות האלה:",
      "tryCommands": "נסה את הפקודות האלה",
      "examples": {
        "search": "\"חפש פאודה\"",
        "play": "\"נגן חדשות\"",
        "navigate": "\"לך לטלוויזיה חיה\"",
        "control": "\"השהה\" או \"הגבר עוצמה\""
      },
      "startUsing": "התחל להשתמש בשליטה קולית"
    },
    "skip": "דלג לעת עתה",
    "buttons": {
      "back": "חזרה"
    },
    "completion": {
      "message": "תכונות הקול מוכנות לשימוש.",
      "title": "הגדרת הקול הושלמה"
    },
    "title": "הגדרת קול",
    "training": {
      "message": "קרא את המשפטים בקול רם כדי לאמן את זיהוי הקול.",
      "title": "אימון קולי"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "סרטים",
      "series": "סדרות",
      "kids": "ילדים",
      "youngsters": "צעירים",
      "music": "מוזיקה",
      "documentaries": "תיעודיים",
      "podcasts": "פודקאסטים",
      "live": "שידור חי"
    },
    "subcategories": {
      "learning-hebrew": "לימוד עברית",
      "learning-hebrew.description": "לימוד קריאה, כתיבה ואוצר מילים בעברית לילדים",
      "young-science": "מדע צעיר",
      "young-science.description": "ניסויים והסברים מדעיים מותאמים לילדים",
      "math-fun": "מתמטיקה מהנה",
      "math-fun.description": "לימוד מספרים וחשבון בצורה מהנה ומשחקית",
      "nature-animals": "טבע וחיות",
      "nature-animals.description": "עולם החיות והטבע לילדים סקרניים",
      "interactive": "אינטראקטיבי",
      "interactive.description": "תוכן אינטראקטיבי ומשתתף לילדים",
      "hebrew-songs": "שירים בעברית",
      "hebrew-songs.description": "שירי ילדים ישראליים קלאסיים וחדשים",
      "nursery-rhymes": "שירי פעוטות",
      "nursery-rhymes.description": "שירים ומנגינות לפעוטות ותינוקות",
      "kids-movies": "סרטי ילדים",
      "kids-movies.description": "סרטים מלאים מותאמים לילדים",
      "kids-series": "סדרות לילדים",
      "kids-series.description": "סדרות מצוירות ותוכניות טלוויזיה לילדים",
      "jewish-holidays": "חגי ישראל",
      "jewish-holidays.description": "תוכן על חגי ישראל ומסורת יהודית לילדים",
      "torah-stories": "סיפורי תורה",
      "torah-stories.description": "סיפורים מהתנ״ך ומהמסורת היהודית",
      "bedtime-stories": "סיפורי ערב טוב",
      "bedtime-stories.description": "סיפורים מרגיעים לקראת השינה",
      "tiktok-trends": "טרנדים TikTok",
      "tiktok-trends.description": "טרנדים חמים ואתגרים ב-TikTok",
      "viral-videos": "וידאו ויראלי",
      "viral-videos.description": "וידאו ויראלי פופולרי ברשתות החברתיות",
      "memes": "ממים",
      "memes.description": "ממים מצחיקים ותרבות אינטרנט",
      "israel-news": "חדשות ישראל",
      "israel-news.description": "חדשות ישראל מותאמות לבני נוער",
      "world-news": "חדשות העולם",
      "world-news.description": "חדשות בינלאומיות לנוער",
      "science-news": "חדשות מדע",
      "science-news.description": "גילויים מדעיים וחדשנות טכנולוגית",
      "sports-news": "חדשות ספורט",
      "sports-news.description": "עדכוני ספורט ותוצאות משחקים",
      "music-culture": "תרבות מוזיקלית",
      "music-culture.description": "סצנת המוזיקה, אומנים ופסטיבלים",
      "film-culture": "תרבות קולנוע",
      "film-culture.description": "קולנוע, סדרות וביקורות",
      "art-culture": "אמנות",
      "art-culture.description": "אמנות, גלריות ויצירתיות",
      "food-culture": "תרבות אוכל",
      "food-culture.description": "בישול, מתכונים ותרבות אוכל",
      "study-help": "עזרה בלימודים",
      "study-help.description": "עזרה בבגרויות, סיכומים והכנה למבחנים",
      "career-prep": "הכנה לקריירה",
      "career-prep.description": "הכנה לאוניברסיטה וקריירה",
      "life-skills": "מיומנויות חיים",
      "life-skills.description": "מיומנויות חיים, ניהול כסף וחיים עצמאיים",
      "teen-movies": "סרטי נוער",
      "teen-movies.description": "סרטים מומלצים לבני נוער",
      "teen-series": "סדרות נוער",
      "teen-series.description": "סדרות פופולריות לבני נוער",
      "gaming": "גיימינג",
      "gaming.description": "משחקי וידאו, e-sports וגיימינג",
      "coding": "קודינג",
      "coding.description": "תכנות, קודינג ופיתוח תוכנה",
      "gadgets": "גאדג'טים",
      "gadgets.description": "גאדג'טים, טכנולוגיה וביקורות",
      "bar-bat-mitzvah": "בר/בת מצווה",
      "bar-bat-mitzvah.description": "הכנה וחגיגות בר ובת מצווה",
      "teen-torah": "תורה לנוער",
      "teen-torah.description": "שיעורי תורה ופרשת השבוע לנוער",
      "jewish-history": "היסטוריה יהודית",
      "jewish-history.description": "תולדות עם ישראל והיסטוריה יהודית"
    }
  },
  "passkey": {
    "manager": {
      "title": "מפתחות גישה",
      "subtitle": "נהל את מפתחות הגישה שלך לתוכן מוגן"
    },
    "unsupported": "מפתחות גישה אינם נתמכים במכשיר זה",
    "fetchError": "שגיאה בטעינת מפתחות גישה",
    "registerError": "שגיאה ברישום מפתח גישה",
    "deleteError": "שגיאה במחיקת מפתח גישה",
    "cancelled": "פעולת מפתח הגישה בוטלה",
    "noPasskeys": "עדיין אין מפתחות גישה רשומים. הוסף אחד כדי לפתוח תוכן פרטי.",
    "unknownDevice": "מכשיר לא ידוע",
    "created": "נוצר",
    "lastUsed": "שימוש אחרון",
    "never": "אף פעם",
    "addPasskey": "הוסף מפתח גישה",
    "deleteConfirmTitle": "למחוק מפתח גישה?",
    "deleteConfirmText": "מפתח גישה זה לא יוכל יותר לפתוח תוכן. תמיד תוכל להוסיף אותו שוב מאוחר יותר.",
    "unlock": "פתח נעילה",
    "unlockContent": "פתח תוכן פרטי",
    "unlockDescription": "השתמש במפתח הגישה שלך כדי לגשת לסרטים וסדרות פרטיות",
    "auth": {
      "title": "פתיחת תוכן",
      "description": "השתמש בטביעת אצבע, זיהוי פנים או PIN של המכשיר כדי לפתוח סרטים וסדרות פרטיות.",
      "unlock": "פתח עם מפתח גישה",
      "authenticating": "מאמת...",
      "success": "התוכן נפתח!",
      "cancelled": "האימות בוטל",
      "error": "האימות נכשל. נסה שוב."
    },
    "qr": {
      "useQR": "השתמש בטלפון לפתיחה",
      "scanWithPhone": "סרוק עם הטלפון שלך",
      "instruction": "פתח את המצלמה בטלפון וסרוק את קוד ה-QR כדי להתחבר",
      "error": "שגיאה ביצירת קוד QR",
      "expired": "קוד ה-QR פג תוקף. נסה שוב."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "הפעילות לא נמצאה",
      "session_different_partner": "הפעילות שייכת לשותף אחר",
      "session_invalid_status": "הפעילות במצב {status}, לא ניתן להוסיף תמלול",
      "max_sessions_reached": "הגעת למספר המקסימלי של פעילויות מקבילות ({limit})",
      "invalid_api_key": "מפתח API לא תקין",
      "missing_api_key": "חסר כותרת {header}",
      "capability_disabled": "היכולת '{capability}' כרגע מושבתת",
      "capability_not_enabled": "היכולת '{capability}' לא מופעלת עבור שותף זה",
      "source_language_not_supported": "שפת המקור '{language}' לא נתמכת. נתמכות: {supported}",
      "target_language_not_supported": "שפת היעד '{language}' לא נתמכת. נתמכות: {supported}",
      "partner_not_found": "השותף לא נמצא",
      "partner_registration_failed": "ההרשמה כשותף נכשלה",
      "no_updates_provided": "לא סופקו עדכונים",
      "webhook_config_failed": "הגדרת ה-webhook נכשלה",
      "webhook_url_not_configured": "כתובת ה-webhook לא הוגדרה",
      "webhook_secret_not_configured": "סוד ה-webhook לא הוגדר",
      "search_failed": "החיפוש נכשל",
      "indexing_failed": "האינדוקס נכשל",
      "detection_failed": "הזיהוי נכשל",
      "explanation_failed": "קבלת ההסבר נכשלה",
      "reference_not_found": "ההפניה '{reference_id}' לא נמצאה",
      "enrichment_failed": "ההעשרה נכשלה",
      "get_references_failed": "קבלת ההפניות נכשלה",
      "create_session_failed": "יצירת הפעילות נכשלה",
      "add_transcript_failed": "הוספת התמלול נכשלה",
      "generate_recap_failed": "יצירת הסיכום נכשלה"
    }
  },
  "portal": {
    "nav": {
      "home": "בית",
      "features": "תכונות",
      "solutions": "פתרונות",
      "pricing": "תמחור",
      "demo": "הדגמה חיה",
      "contact": "צור קשר",
      "getStarted": "התחל"
    },
    "hero": {
      "ctaExplore": "גלה תכונות",
      "ctaDemo": "בקש הדגמה"
    },
    "cta": {
      "title": "מוכן להתחיל?",
      "subtitle": "בוא נדבר איך אנחנו יכולים לעזור לשנות את העסק שלך",
      "button": "צור קשר"
    },
    "contactPage": {
      "title": "צור קשר",
      "subtitle": "מעוניין בפתרונות שלנו? בוא נדבר",
      "formTitle": "שלח לנו הודעה",
      "infoTitle": "פרטי התקשרות",
      "form": {
        "name": "שם מלא",
        "email": "כתובת דוא\"ל",
        "company": "שם החברה",
        "phone": "מספר טלפון",
        "message": "ההודעה שלך",
        "messagePlaceholder": "ספר לנו על הצרכים שלך..."
      },
      "submit": "שלח הודעה",
      "sending": "שולח...",
      "success": "ההודעה נשלחה בהצלחה! נחזור אליך בקרוב.",
      "error": "שליחת ההודעה נכשלה. נסה שוב.",
      "scheduleTitle": "מעדיף לתזמן שיחה?",
      "scheduleSubtitle": "הזמן הדגמה אישית עם הצוות שלנו",
      "scheduleCta": "תזמן שיחת הדגמה"
    },
    "pricingPage": {
      "title": "משתלם",
      "titleHighlight": "תוכניות תמחור",
      "subtitle": "בחר את התוכנית המתאימה לצרכים שלך",
      "comparisonTitle": "השוואת תכונות",
      "faqTitle": "שאלות נפוצות",
      "faq": {
        "q1": "איך מחושב התמחור?",
        "a1": "התמחור מבוסס על הצרכים והשימוש הספציפיים שלך. צור קשר לקבלת הצעת מחיר מותאמת.",
        "q2": "האם אוכל לשדרג את התוכנית שלי מאוחר יותר?",
        "a2": "כן, אתה יכול לשדרג בכל עת. נעזור להעביר את הנתונים שלך בצורה חלקה.",
        "q3": "איזה תמיכה כלולה?",
        "a3": "כל התוכניות כוללות תמיכה בדוא\"ל. תוכניות Professional ו-Enterprise כוללות תמיכה עדיפה עם מנהלי חשבונות ייעודיים."
      },
      "professional": {
        "name": "מקצועי",
        "price": "צור קשר לקבלת הצעת מחיר",
        "priceNote": "תמחור מותאם",
        "description": "לעסקים צומחים עם צרכים מתקדמים",
        "cta": "קבל הצעת מחיר"
      },
      "enterprise": {
        "name": "ארגוני",
        "price": "מותאם אישית",
        "priceNote": "מבוסס נפח",
        "description": "לארגונים גדולים ופריסות ארגוניות",
        "cta": "צור קשר עם המכירות"
      },
      "ctaTitle": "מוכן להתחיל?",
      "ctaSubtitle": "בוא נדבר על הצרכים שלך ונמצא את התוכנית המושלמת",
      "ctaButton": "צור קשר עם המכירות"
    },
    "featuresPage": {
      "title": "עוצמתי",
      "titleHighlight": "תכונות",
      "subtitle": "כל מה שאתה צריך להצליח",
      "techSpecsTitle": "מפרטים טכניים",
      "workflowTitle": "איך זה עובד",
      "workflow": {
        "s1": {
          "title": "ייבוא",
          "description": "העלה וארגן את התוכן שלך"
        },
        "s2": {
          "title": "הגדר",
          "description": "קבע את ההעדפות וההגדרות שלך"
        },
        "s3": {
          "title": "פרוס",
          "description": "עלה לאוויר עם הפתרון שלך"
        },
        "s4": {
          "title": "עקוב",
          "description": "עקוב אחר ביצועים ובצע אופטימיזציה"
        }
      },
      "ctaTitle": "מוכן לגלות תכונות?",
      "ctaSubtitle": "ראה את כל התכונות בפעולה עם הדגמה אישית",
      "ctaButton": "תזמן הדגמה"
    },
    "demoPage": {
      "title": "ראה את",
      "titleHighlight": "הפלטפורמה שלנו",
      "subtitle": "חווה את העוצמה של הפתרון שלנו",
      "scheduleCta": "תזמן הדגמה חיה",
      "stepsTitle": "איך זה עובד",
      "steps": {
        "analyze": {
          "title": "נתח",
          "description": "עקוב ושפר ביצועים"
        }
      },
      "featuresTitle": "נקודות בולטות של הפלטפורמה",
      "platformsTitle": "זמין ב",
      "ctaTitle": "מוכן להדגמה מותאמת אישית?",
      "ctaSubtitle": "תזמן הדגמה אישית המותאמת לצרכים שלך",
      "ctaButton": "תזמן הדגמה"
    },
    "workflow": {
      "sectionTitle": "זרימת עבודה חכמה",
      "sectionSubtitle": "תהליך מייעל ב-4 שלבים",
      "step1": {
        "title": "הגדר",
        "description": "הגדר את החשבון וההעדפות שלך"
      },
      "step2": {
        "title": "התאם אישית",
        "description": "התאם הגדרות לצרכים שלך"
      },
      "step3": {
        "title": "השק",
        "description": "השק את הפתרון שלך"
      },
      "step4": {
        "title": "עקוב",
        "description": "עקוב אחר ביצועים ובצע אופטימיזציה"
      }
    }
  },
  "trivia": {
    "didYouKnow": "?האם ידעת",
    "dismissHint": "סגור עובדה מעניינת",
    "settings": {
      "displayLanguages": "שפות תצוגה",
      "languageHint": "בחר 1-3 שפות להצגה עבור כל עובדה",
      "language": "שפה",
      "selectLanguage": "בחר שפה זו",
      "deselectLanguage": "בטל בחירת שפה זו",
      "enableDescription": "הצג שאלות טריוויה בזמן צפייה בתוכן.",
      "enableTrivia": "הפעל טריוויה",
      "title": "הגדרות טריוויה"
    },
    "aiTrivia": "טריוויה AI",
    "tellMeMore": "ספר לי עוד",
    "more": "עוד",
    "follow_up": "המשך"
  },
  "auth": {
    "loginRequired": "נדרשת התחברות",
    "loginToWatch": "אנא התחבר כדי לצפות ב{{title}}",
    "login": "התחבר",
    "signUp": "הרשם",
    "biometricEnrollEnable": "הפעל",
    "biometricEnrollMessage": "השתמש בזיהוי פנים או טביעת אצבע להתחברות מהירה.",
    "biometricEnrollSkip": "דלג",
    "biometricEnrollTitle": "הפעל התחברות ביומטרית",
    "biometricSignIn": "התחבר עם ביומטריה",
    "signOut": "התנתק",
    "register": {
      "createAccount": "יצירת חשבון",
      "email": "אימייל",
      "password": "סיסמה",
      "confirmPassword": "אימות סיסמה",
      "register": "הרשמה",
      "alreadyHaveAccount": "כבר יש לך חשבון? התחבר",
      "passwordStrength": {
        "weak": "חלשה",
        "medium": "בינונית",
        "strong": "חזקה"
      }
    }
  },
  "recording": {
    "stop": "עצור הקלטה",
    "start": "התחל הקלטה"
  },
  "discover": {
    "title": "גלה",
    "subtitle": "גלה 19 תכונות מבוססות בינה מלאכותית",
    "description": "Bayit+ משתמשת בבינה מלאכותית כדי לשפר את חוויית הצפייה, ההאזנה והלמידה שלך. גלה מה זמין בפלטפורמה שלך.",
    "featureCount": "{{count}} תכונות",
    "tryIt": "נסה עכשיו",
    "startWalkthrough": "התחל סיור",
    "availableOn": "זמין ב",
    "prerequisites": "דרישות מוקדמות",
    "setup": "הגדר",
    "error": {
      "fetchFailed": "טעינת תכונות Discover נכשלה. אנא נסה שוב.",
      "unknownFeature": "התכונה לא נמצאה.",
      "featureDisabled": "תכונה זו כרגע מושבתת."
    },
    "availability": {
      "ready": "מוכן",
      "setupNeeded": "נדרשת הגדרה",
      "premiumRequired": "נדרש מנוי פרימיום",
      "notAvailable": "לא זמין",
      "platformOnly": "פלטפורמה אחרת"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "אנדרואיד",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "צפייה בסרטים",
      "watching_live_tv": "צפייה בטלוויזיה חיה",
      "learn_hebrew": "לימוד עברית",
      "search_discovery": "חיפוש וגילוי",
      "chat_assistants": "עוזרי שיחה"
    },
    "feature": {
      "pause_ask": {
        "name": "עצור ושאל",
        "tagline": "עצור כל סצנה ושאל את חבר הבינה המלאכותית שלך עליה",
        "description": "בזמן הצפייה, עצור את הסרטון ושאל שאלות על הסצנה הנוכחית. דמות הבינה המלאכותית שלך תסביר הפניות תרבותיות, תתרגם דיאלוגים, או תדון בעלילה."
      },
      "interactive_subtitles": {
        "name": "כתוביות אינטראקטיביות",
        "tagline": "לחץ על כל מילה בכתוביות לתרגום מיידי והקשר",
        "description": "לחץ על כל מילה בכתוביות כדי לראות את תרגומה, לשמוע הגייה ולקבל דוגמאות שימוש. בנה אוצר מילים בזמן צפייה בתוכניות האהובות עליך."
      },
      "vocabulary": {
        "name": "בונה אוצר מילים",
        "tagline": "למד מילים חדשות מהתוכניות שאתה צופה בהן",
        "description": "אסוף אוטומטית מילים עבריות חדשות מכתוביות. עיין בכרטיסיות, עקוב אחר ההתקדמות, ובנה את אוצר המילים שלך דרך תוכן שאתה נהנה ממנו."
      },
      "vod_moments": {
        "name": "רגעי VOD",
        "tagline": "קטעי שיא שנבחרו על ידי בינה מלאכותית מהתוכן האהוב עליך",
        "description": "קבל קטעי שיא שנוצרו על ידי בינה מלאכותית ורגעי מפתח מסרטים ותוכניות. שתף סצנות בלתי נשכחות וחזור לרגעים הטובים ביותר."
      },
      "cultural_context": {
        "name": "הקשר תרבותי",
        "tagline": "הבן את הרקע התרבותי מאחורי כל סצנה",
        "description": "קבל הערות תרבותיות בזמן אמת המסבירות מנהגים ישראליים, חגים, הומור ונורמות חברתיות שמופיעות בתוכן שאתה צופה בו."
      },
      "bilingual_bridge": {
        "name": "גשר דו-לשוני",
        "tagline": "למידת עברית-אנגלית זה לצד זה בזמן הצפייה",
        "description": "הצג כתוביות בשתי שפות עם אוצר מילים מודגש. עבור בין עברית לשפת האם שלך כדי לבנות הבנה באופן טבעי."
      },
      "ai_companion": {
        "name": "חבר בינה מלאכותית",
        "tagline": "המדריך האישי שלך באמצעות בינה מלאכותית לתוכן ישראלי",
        "description": "דמות בינה מלאכותית שצופה איתך, מציעה פרשנות, עונה על שאלות ועוזרת לך להבין את הניואנסים של המדיה הישראלית."
      },
      "live_dubbing": {
        "name": "דיבוב חי",
        "tagline": "דיבוב בינה מלאכותית בזמן אמת לערוצי טלוויזיה ישראליים חיים",
        "description": "צפה בטלוויזיה ישראלית חיה עם דיבוב בזמן אמת מבוסס בינה מלאכותית בשפה המועדפת עליך. חווה חדשות, תוכניות שיחה ובידור ללא מחסומי שפה."
      },
      "live_subtitles": {
        "name": "כתוביות חיות",
        "tagline": "כתוביות בינה מלאכותית בזמן אמת לשידורים חיים",
        "description": "קבל כתוביות שנוצרו על ידי בינה מלאכותית בזמן אמת בזמן שאתה צופה בטלוויזיה ישראלית חיה. בחר את השפה המועדפת עליך לתרגום מיידי של תוכן חי."
      },
      "live_trivia": {
        "name": "טריוויה חיה",
        "tagline": "שחק משחקי טריוויה המבוססים על מה שמשודר כעת",
        "description": "הבינה המלאכותית מזהה נושאים משידורים חיים ומייצרת שאלות טריוויה בזמן אמת. התחרה עם חברים ולמד על התרבות הישראלית בזמן צפייה בטלוויזיה."
      },
      "catch_up": {
        "name": "התעדכן",
        "tagline": "סיכומי בינה מלאכותית של מה שפספסת בטלוויזיה חיה",
        "description": "פספסת חלק משידור חי? קבל סיכומים שנוצרו על ידי בינה מלאכותית שיעדכנו אותך במה שקרה, עם רגעי מפתח מודגשים לסקירה מהירה."
      },
      "scene_search": {
        "name": "חיפוש סצנות",
        "tagline": "חפש סצנות ספציפיות בכל התוכן",
        "description": "תאר סצנה שאתה זוכר והבינה המלאכותית תמצא אותה בכל התוכן הזמין. חפש לפי דיאלוג, אלמנטים ויזואליים, או תיאורי עלילה."
      },
      "phonetic_mirror": {
        "name": "מראה פונטית",
        "tagline": "תרגל הגיית עברית עם משוב בינה מלאכותית",
        "description": "הקלט את עצמך מדבר עברית וקבל משוב מיידי מבינה מלאכותית על ההגייה. השווה את הדיבור שלך עם דוברי שפת אם ועקוב אחר ההתקדמות לאורך זמן."
      },
      "talk_back": {
        "name": "דבר בחזרה",
        "tagline": "נהל שיחות קוליות בעברית עם דמות הבינה המלאכותית שלך",
        "description": "תרגל עברית שיחתית על ידי שיחה עם דמות הבינה המלאכותית שלך. קבל משוב בזמן אמת על דקדוק, אוצר מילים והגייה בדיאלוג טבעי."
      },
      "interactive_mission": {
        "name": "משימות אינטראקטיביות",
        "tagline": "אתגרי לימוד עברית כיפיים עם הנחיית בינה מלאכותית",
        "description": "השלם משימות בהנחיית בינה מלאכותית המשלבות צפייה בתוכן עם תרגילי לימוד עברית. הרוויח פרסים ועקוב אחר מסע השפה שלך."
      },
      "glossary": {
        "name": "מילון אישי",
        "tagline": "מילון העברית האישי שלך שנבנה מתוכן",
        "description": "כל המילים העבריות שנתקלת בהן ושמרת, מאורגנות לפי קטגוריה, תדירות ורמת שליטה. עיין ותרגל בכל עת."
      },
      "llm_search": {
        "name": "חיפוש AI",
        "tagline": "מצא תוכן עם שאילתות בשפה טבעית",
        "description": "חפש בכל ספריית Bayit+ באמצעות שפה טבעית. בקש 'קומדיות ישראליות מצחיקות על משפחה' או 'סרטים תיעודיים על תל אביב' וקבל תוצאות שנבחרו על ידי בינה מלאכותית."
      },
      "proactive_voice": {
        "name": "קול יזום",
        "tagline": "עוזר קולי מבוסס בינה מלאכותית שצופה לצרכיך",
        "description": "עוזר בינה מלאכותית שמאזין ומציע באופן יזום הצעות תוכן רלוונטיות, תרגומים והזדמנויות למידה בהתבסס על מה שאתה צופה."
      },
      "chatbot": {
        "name": "צ'אט Bayit",
        "tagline": "שוחח עם בינה מלאכותית על כל דבר הקשור לתוכן ישראלי",
        "description": "שאל שאלות על התרבות הישראלית, קבל המלצות תוכן, תרגל עברית, או דון במה שצפית. חבר הבינה המלאכותית שלך זמין תמיד."
      }
    },
    "prereq": {
      "avatar": "צור את דמות הבינה המלאכותית שלך",
      "subscription": "נדרש מנוי פרימיום",
      "microphone": "נדרשת גישה למיקרופון",
      "contentType": "בחר את העדפות התוכן שלך",
      "preference": "הגדר את העדפות השפה שלך",
      "voiceClone": "הגדר את שיבוט הקול שלך"
    },
    "walkthrough": {
      "tryItNow": "נסה עכשיו",
      "watchDemo": "צפה בהדגמה",
      "skip": "דלג",
      "next": "הבא",
      "done": "סיום",
      "complete": "ההדרכה הושלמה",
      "stepCounter": "{{current}} מתוך {{total}}",
      "pause_ask": {
        "step1": "נווט לסרט עם רגעים אינטראקטיביים",
        "step2": "השהה את הסרט במהלך סצנה",
        "step3": "לחץ על כפתור שאל דמות",
        "step4": "צפה בתגובת הדמות"
      },
      "interactive_subtitles": {
        "step1": "התחל להפעיל סרט עם כתוביות",
        "step2": "לחץ על כפתור אינטראקטיבי בסרגל הבקרה",
        "step3": "בחר את שפת הכתוביות",
        "step4": "לחץ על כל מילה בכתוביות כדי ללמוד עוד"
      },
      "vocabulary": {
        "step1": "פתח סרט עם כתוביות אינטראקטיביות",
        "step2": "לחץ על מילה שברצונך ללמוד",
        "step3": "לחץ על שמור לאוצר מילים",
        "step4": "סקור את המילים השמורות במילון"
      },
      "vod_moments": {
        "step1": "התחל לצפות בסרט עם רגעים אינטראקטיביים",
        "step2": "המתן להנחיה אינטראקטיבית",
        "step3": "צפה באינטראקציה שנוצרה על ידי AI"
      },
      "cultural_context": {
        "step1": "הפעל סרט עם דיאלוג בעברית",
        "step2": "לחץ על כתובית בעלת משמעות תרבותית",
        "step3": "קרא את ההסבר התרבותי שנוצר על ידי AI"
      },
      "bilingual_bridge": {
        "step1": "פתח סרט עם תמיכה דו-לשונית",
        "step2": "בחר מצב כתוביות דו-לשוני",
        "step3": "לחץ על ביטוי מודגש לצפייה בתרגום",
        "step4": "צפה בשתי השפות זו לצד זו"
      },
      "ai_companion": {
        "step1": "התחל לצפות בכל סרט",
        "step2": "לחץ על כפתור מלווה AI",
        "step3": "הקלד שאלה על הסרט",
        "step4": "קרא את תגובת ה-AI"
      },
      "live_dubbing": {
        "step1": "נווט לערוץ טלוויזיה חי",
        "step2": "לחץ על כפתור הדיבוב בסרגל הבקרה",
        "step3": "בחר את השפה המועדפת",
        "step4": "האזן לדיבוב AI בזמן אמת"
      },
      "live_subtitles": {
        "step1": "נווט לערוץ טלוויזיה חי",
        "step2": "לחץ על כפתור הכתוביות",
        "step3": "בחר את שפת הכתוביות",
        "step4": "צפה בכתוביות בזמן אמת"
      },
      "live_trivia": {
        "step1": "נווט לערוץ טלוויזיה חי",
        "step2": "לחץ על כפתור הטריוויה",
        "step3": "ענה על שאלות שנוצרו על ידי AI"
      },
      "catch_up": {
        "step1": "נווט לשידור חי",
        "step2": "בחר את אפשרות ההשלמה",
        "step3": "לחץ ליצירת סיכום AI",
        "step4": "קרא את סיכום מה שפספסת"
      },
      "scene_search": {
        "step1": "נווט לשידור מוקלט",
        "step2": "הקלד את מה שאתה מחפש",
        "step3": "לחץ על הסצנה המתאימה",
        "step4": "צפה בסצנה מנקודה זו"
      },
      "phonetic_mirror": {
        "step1": "פתח את המראה הפונטית בזה אני",
        "step2": "קרא את המשפט בעברית",
        "step3": "אמור את המשפט למיקרופון",
        "step4": "סקור את משוב ההגייה של AI"
      },
      "talk_back": {
        "step1": "פתח את דבר חזרה בזה אני",
        "step2": "האזן לדמות שלך מדברת עברית",
        "step3": "הגב בעברית באמצעות המיקרופון",
        "step4": "סקור את משוב ה-AI"
      },
      "interactive_mission": {
        "step1": "פתח משימות אינטראקטיביות",
        "step2": "בחר רמת משימה",
        "step3": "עקוב אחר התרגילים המונחים על ידי AI",
        "step4": "השלם את המשימה וצבור פרסים"
      },
      "glossary": {
        "step1": "פתח את המילון העברי",
        "step2": "חפש מילה בעברית",
        "step3": "האזן להגייה"
      },
      "llm_search": {
        "step1": "פתח את כרטיסיית החיפוש",
        "step2": "הקלד שאילתה בשפה טבעית",
        "step3": "עיין בתוצאות שנאספו על ידי AI"
      },
      "proactive_voice": {
        "step1": "פתח את תכונת הצעות הקול",
        "step2": "לחץ והחזק כדי לדבר",
        "step3": "שמע המלצות מותאמות אישית"
      },
      "chatbot": {
        "step1": "פתח את עוזר ה-AI",
        "step2": "הקלד את השאלה או הבקשה",
        "step3": "קרא את תגובת ה-AI"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "הביאו תוכן משלכם",
      "subtitle": "חברו את מקורות ה-IPTV, Plex או YouTube שלכם ותהנו מתכונות AI של Bayit+ על התוכן שלכם",
      "connectButton": "חבר מקורות",
      "aiFeatures": {
        "dubbing": "דיבוב AI זמין",
        "subtitles": "כתוביות חיות זמינות"
      }
    },
    "pageSubtitle": "הבא את התוכן שלך - הוסף מקורות IPTV ושידור",
    "addSource": "הוסף מקור",
    "sync": "סנכרן",
    "remove": "הסר",
    "channelCount": "{{count}} ערוצים",
    "empty": {
      "title": "לא נוספו מקורות",
      "subtitle": "הוסף את מקורות ה-IPTV, Xtream או השידור שלך כדי לצפות בתוכן שלך לצד Bayit+"
    },
    "source": {
      "iptv": "מקור IPTV",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "הוסף מקור IPTV",
      "subtitle": "הזן URL לקובץ פלייליסט M3U או M3U8",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "אמת",
      "add": "הוסף מקור"
    },
    "addXtream": {
      "title": "התחבר ל-Xtream Codes",
      "subtitle": "הזן את פרטי הגישה לשרת Xtream Codes שלך",
      "serverUrl": "כתובת שרת",
      "username": "שם משתמש",
      "password": "סיסמה",
      "connect": "התחבר"
    },
    "preview": {
      "title": "תצוגה מקדימה",
      "channelCount": "נמצאו {{count}} ערוצים"
    },
    "providers": {
      "title": "ספקים פופולריים"
    },
    "wizard": {
      "step1": "הוסף מקור",
      "step2": "עיבוד",
      "step3": "סקירה",
      "selectSource": "בחר סוג מקור"
    },
    "normalization": {
      "title": "מעבד את התוכן שלך",
      "total": "{{count}} ערוצים בסך הכל",
      "matched": "{{count}} הותאמו",
      "stage": {
        "parsing": "מנתח פלייליסט...",
        "matching": "מתאם ערוצים...",
        "enriching": "מעשיר מטאדאטה...",
        "finalizing": "מסיים..."
      }
    },
    "review": {
      "title": "סקור תוכן מיובא",
      "subtitle": "{{matched}} הותאמו, {{unmatched}} ערוצים לא הותאמו",
      "matchedChannels": "ערוצים שהותאמו",
      "unmatchedChannels": "ערוצים שלא הותאמו",
      "apply": "החל וייבא"
    },
    "error": {
      "urlRequired": "אנא הזן URL",
      "noChannels": "לא נמצאו ערוצים בפלייליסט זה",
      "invalidUrl": "לא ניתן לטעון פלייליסט מה-URL הזה",
      "allFieldsRequired": "כל השדות נדרשים",
      "enrichFailed": "נכשל לנתח את המקור",
      "syncFailed": "נכשל לסנכרן את המקור",
      "normalizationFailed": "עיבוד התוכן נכשל",
      "normalizationPollFailed": "החיבור אבד במהלך העיבוד"
    },
    "plex": {
      "connectPlex": "חיבור Plex",
      "enterCodeAt": "הזן קוד זה באתר",
      "waitingForAuth": "ממתין לאישור...",
      "selectServer": "בחר שרת Plex",
      "connecting": "מתחבר אל {{serverName}}...",
      "connected": "מחובר",
      "label": "Plex"
    },
    "settings": {
      "title": "מקורות התוכן שלך",
      "refresh": "רענון",
      "noSources": "לא חוברו מקורות תוכן",
      "noSourcesSubtitle": "חבר את Plex, YouTube, IPTV או ספק Xtream שלך",
      "removeSource": "הסר מקור",
      "plexSubtitle": "הזרם משרת המדיה Plex שלך",
      "youtubeSubtitle": "גש לספריית YouTube שלך",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "הוסף פלייליסט M3U או קודי Xtream",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "ברוכים הבאים ל-Bayit+",
      "subtitle": "השער שלך המופעל על ידי בינה מלאכותית לתוכן ישראלי, תרבות ולימוד שפה",
      "getStarted": "התחל"
    },
    "highlight": {
      "dubbing": "דיבוב AI חי",
      "subtitles": "כתוביות אינטראקטיביות",
      "ai": "עוזרי AI",
      "learning": "לימוד עברית"
    },
    "voice": {
      "title": "הגדרת קול",
      "subtitle": "הפעל את המיקרופון שלך לפקודות קוליות, תרגול הגייה בעברית וניווט חופשי ידיים",
      "enable": "הפעל מיקרופון",
      "granted": "המיקרופון הופעל בהצלחה"
    },
    "tour": {
      "done": "סיום"
    },
    "demo": {
      "dubbing": {
        "title": "דיבוב AI חי",
        "description": "צפה בטלוויזיה ישראלית עם דיבוב AI בזמן אמת בשפה המועדפת עליך",
        "hebrew": "עברית",
        "english": "אנגלית"
      },
      "subtitles": {
        "title": "כתוביות אינטראקטיביות",
        "description": "הקש על כל מילה בכתוביות לתרגום מיידי והגייה",
        "sample": "המשפחה התכנסה לארוחת Shabbat",
        "word": "שבת",
        "translation": "שבת - יום מנוחה שבועי"
      },
      "interaction": {
        "title": "אינטראקציה עם דמות AI",
        "description": "השהה כל סצנה ושאל את עוזר ה-AI שלך על הקשר תרבותי",
        "userMsg": "איזה חג הם חוגגים?",
        "aiMsg": "הם חוגגים את Sukkot, חג הסוכות. הצריף הזמני שאתה רואה נקרא סוכה."
      },
      "trivia": {
        "title": "טריוויה חיה",
        "description": "AI מייצר שאלות טריוויה ממה שמשודר כעת. התחרה ולמד!",
        "question": "מהי השפה הרשמית של ישראל?",
        "optionA": "ערבית",
        "optionB": "עברית",
        "optionC": "אנגלית"
      },
      "catchup": {
        "title": "השלמת פערים חכמה",
        "description": "פספסת חלק משידור חי? AI מסכם את מה שפספסת",
        "missed": "פוספס",
        "summary": "סיכום AI",
        "live": "שידור חי"
      },
      "byoc": {
        "title": "הבא את התוכן שלך",
        "description": "ייבא את מקורות ה-IPTV שלך וצפה בהם לצד תוכן Bayit+",
        "step1": "הוסף מקור",
        "step2": "העשרת AI",
        "step3": "צפה"
      },
      "zehAni": {
        "title": "צור את דמות ה-AI שלך",
        "description": "צור אווטאר AI מותאם אישית שלומד איתך",
        "generated": "אווטאר AI"
      }
    }
  },
  "dm": {
    "title": "הודעות",
    "conversations": "שיחות",
    "conversation": "שיחה",
    "empty": {
      "title": "אין הודעות עדיין",
      "subtitle": "התחל שיחה עם חבר"
    },
    "input": {
      "placeholder": "הקלד הודעה...",
      "send": "שלח"
    },
    "translate": "תרגם",
    "react": "הגב",
    "read": "נקרא",
    "sent": "נשלח",
    "loadMore": "טען הודעות קודמות",
    "startConversation": "שלח הודעה כדי להתחיל את השיחה",
    "reaction": {
      "like": "אהבתי",
      "love": "אהבה",
      "laugh": "מצחיק",
      "surprise": "וואו",
      "sad": "עצוב"
    },
    "error": {
      "fetchFailed": "טעינת ההודעות נכשלה",
      "sendFailed": "שליחת ההודעה נכשלה"
    }
  },
  "household": {
    "empty": {
      "title": "אין משק בית עדיין",
      "subtitle": "צור משק בית כדי לנהל את המשפחה שלך"
    },
    "create": {
      "namePlaceholder": "שם משק הבית",
      "button": "צור משק בית"
    },
    "members": "חברים",
    "role": {
      "owner": "בעלים",
      "guardian": "אפוטרופוס",
      "child": "ילד"
    },
    "invite": {
      "title": "הזמן חברים",
      "emailPlaceholder": "כתובת אימייל",
      "send": "שלח הזמנה",
      "pending": "הזמנות ממתינות"
    },
    "removeMember": "הסר",
    "error": {
      "fetchFailed": "טעינת משק הבית נכשלה",
      "createFailed": "יצירת משק הבית נכשלה",
      "updateFailed": "עדכון משק הבית נכשל",
      "deleteFailed": "מחיקת משק הבית נכשלה",
      "inviteFailed": "שליחת ההזמנה נכשלה",
      "removeFailed": "הסרת החבר נכשלה"
    }
  },
  "aiChat": {
    "retryButton": "נסה שוב",
    "sendButton": "שלח",
    "title": "צ'אט AI",
    "voiceButton": "קול"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "חזרה"
    },
    "completion": {
      "message": "הכל מוכן! התחל לחקור תכונות AI.",
      "title": "ההגדרה הושלמה"
    },
    "permissions": {
      "description": "אשר הרשאות כדי להפעיל תכונות AI כמו קול ומצלמה.",
      "title": "הרשאות"
    },
    "personalization": {
      "description": "ספר לנו על ההעדפות שלך כדי להתאים אישית את חוויית ה-AI.",
      "title": "התאמה אישית"
    },
    "title": "הגדרת AI",
    "welcome": {
      "description": "בית פלוס משתמש ב-AI כדי לשפר את חוויית הצפייה עם דיבוב, כתוביות ועוד.",
      "title": "ברוכים הבאים ל-AI של בית פלוס"
    }
  },
  "auth_device_authorized": "המכשיר אושר",
  "auth_device_code_expired": "הקוד פג תוקף",
  "auth_device_get_new_code": "קבל קוד חדש",
  "auth_device_manual_login": "התחבר ידנית",
  "auth_device_visit_uri": "בקר בכתובת המוצגת בטלוויזיה",
  "avatar": {
    "tapToSpeak": "הקש כדי לדבר",
    "title": "אווטאר"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "שמע מדובב",
      "originalAudio": "שמע מקורי",
      "title": "מיקסר שמע"
    },
    "settings_title": "הגדרות דיבוב",
    "target_language": "שפת יעד",
    "voiceSelector": {
      "selected": "נבחר",
      "subtitle": "בחר קול לדיבוב",
      "title": "בחירת קול"
    }
  },
  "go_back": "חזרה",
  "miniPlayer": {
    "closePlayer": "סגור נגן",
    "skipBackward": "דלג אחורה",
    "skipForward": "דלג קדימה"
  },
  "retry": "נסה שוב",
  "search_hint": "חפש ערוצים, סרטים, תוכניות...",
  "search_no_results": "לא נמצאו תוצאות",
  "search_prompt": "מה אתה מחפש?",
  "subscription_required": "נדרש מנוי",
  "subscription_upsell_tv": "שדרג כדי לצפות בטלוויזיה",
  "talkback": {
    "title": "טוקבק"
  },
  "voiceAssistant": {
    "fabLabel": "עוזר קולי",
    "modal": {
      "cancel": "ביטול",
      "setupMessage": "הגדר זיהוי קולי כדי להשתמש בעוזר הקולי.",
      "setupRequired": "נדרשת הגדרה",
      "startSetup": "התחל הגדרה",
      "title": "עוזר קולי"
    }
  },
  "voiceCommand": {
    "executing": "מבצע...",
    "listening": "מאזין...",
    "noMatch": "לא נמצאה התאמה",
    "recognized": "זוהה"
  },
  "voiceDecision": {
    "cancel": "ביטול",
    "confirm": "אישור",
    "matched": "הותאם"
  },
  "voiceSearch": {
    "listening": "מאזין...",
    "noResults": "לא נמצאו תוצאות",
    "tapToSpeak": "הקש כדי לדבר",
    "title": "חיפוש קולי"
  },
  "voiceSettings": {
    "language": "שפה",
    "speechRate": "מהירות דיבור",
    "title": "הגדרות קול",
    "ttsProvider": "ספק TTS",
    "voiceMode": "מצב קול",
    "voiceSelection": "בחירת קול",
    "wakeWord": "מילת הפעלה"
  },
  "voiceWizard": {
    "buttons": {
      "back": "חזרה"
    },
    "calibration": {
      "description": "דבר כרגיל כדי לכייל את המיקרופון.",
      "listening": "מאזין...",
      "micButton": "התחל הקלטה",
      "resultTitle": "תוצאת כיול",
      "stopButton": "עצור הקלטה",
      "tapToStart": "הקש כדי להתחיל כיול",
      "title": "כיול מיקרופון"
    },
    "complete": {
      "message": "הגדרת אשף הקול הושלמה. כעת ניתן להשתמש בתכונות קול.",
      "title": "ההגדרה הושלמה"
    },
    "language": {
      "description": "בחר את השפה המועדפת עליך לפקודות קוליות.",
      "title": "שפת קול"
    },
    "permission": {
      "description": "נדרשת גישה למיקרופון לתכונות קול.",
      "granted": "ההרשאה אושרה",
      "requestButton": "אשר הרשאה",
      "title": "הרשאת מיקרופון"
    },
    "title": "אשף קול"
  },
  "watch_now": "צפה עכשיו",
  "culture": {
    "title": "תרבות ישראלית",
    "description": "ירושלים, תל אביב ומורשת ישראלית",
    "shabbat": {
      "title": "מצב שבת",
      "enableShabbatMode": "הפעל מצב שבת",
      "shabbatTimes": "זמני שבת",
      "timesDescription": "זמני הדלקת נרות והבדלה יוצגו כאן",
      "aboutTitle": "אודות מצב שבת",
      "aboutDescription": "כאשר מופעל, מצב שבת ישהה התראות, יפחית בהירות מסך ויפעיל ממשק מפושט בשעות השבת."
    },
    "judaism": {
      "holidaysAndTorah": "חגים ותורה",
      "parashaOfTheWeek": "פרשת השבוע",
      "parashaDescription": "קריאת תורה שבועית ופרשנות"
    },
    "morning": {
      "title": "טקס בוקר",
      "description": "התחל את היום שלך בכוונה ובהכרת תודה",
      "dailyInspiration": "השראה יומית",
      "dailyInspirationDescription": "תוכן מותאם לשגרת הבוקר שלך",
      "modehAni": "מודה אני",
      "modehAniDescription": "תפילת הודיה של הבוקר",
      "netilatYadayim": "נטילת ידיים",
      "netilatYadayimDescription": "נטילת ידיים",
      "shacharit": "שחרית",
      "shacharitDescription": "תפילת שחרית"
    },
    "glossary": {
      "termDetail": "פרטי מונח",
      "definition": "הגדרה",
      "pronunciation": "הגייה",
      "examples": "דוגמאות"
    },
    "jerusalem": {
      "title": "ירושלים"
    },
    "telaviv": {
      "title": "תל אביב"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "זה אני",
      "biometricConsent": "הסכמה ביומטרית",
      "activeConsents": "{{count}} הסכמות פעילות",
      "magicMirror": "מראה קסומה",
      "magicMirrorDescription": "ברכות יומיות וזיהוי פנים",
      "v2vPractice": "תרגול קול-לקול",
      "v2vPracticeDescription": "הגייה קול-לקול",
      "avatar3d": "אווטאר תלת-ממדי",
      "avatar3dDescription": "רשת האווטאר המותאמת שלך",
      "movieInteractions": "אינטראקציות עם סרטים",
      "movieInteractionsDescription": "דפדף ושוחח עם דמויות מסרטים",
      "contacts": "אנשי קשר",
      "contactsDescription": "שיתוף אנשי קשר ב-WhatsApp",
      "feedback": "משוב",
      "feedbackDescription": "שתף את החוויה שלך",
      "consent": "הסכמה",
      "consentDescription": "ניהול הסכמה ביומטרית",
      "chess": "שחמט",
      "chessDescription": "שחק שחמט עם חברים ומשפחה"
    },
    "mirror": {
      "title": "מראה קסומה",
      "avatarContentDescription": "אווטאר",
      "wordOfTheDay": "מילת היום",
      "playLipsync": "הפעל סנכרון שפתיים",
      "noAvatarYet": "אין אווטאר עדיין",
      "noAvatarDescription": "צור אווטאר תלת-ממדי כדי לראות את עצמך בסיפור",
      "createAvatar": "צור אווטאר"
    },
    "mode": {
      "title": "מצב אווטאר",
      "enableAvatarMode": "הפעל מצב אווטאר",
      "enableDescription": "הצג את האווטאר שלך מגיב לתוכן",
      "avatarPreview": "תצוגה מקדימה של אווטאר",
      "avatarPreviewContentDescription": "תצוגה מקדימה של אווטאר",
      "noAvatarConfigured": "לא הוגדר אווטאר",
      "reactionStyle": "סגנון תגובה"
    },
    "wardrobe": {
      "title": "מלתחה",
      "equippedContentDescription": "מצויד"
    },
    "settings": {
      "title": "הגדרות אווטאר",
      "privacy": "פרטיות",
      "privateAvatarMode": "מצב אווטאר פרטי",
      "privateAvatarDescription": "הסתר את האווטאר שלך ממשתמשים אחרים",
      "appearance": "מראה",
      "enableAnimations": "הפעל אנימציות",
      "animationsDescription": "הנפש תנועות והבעות של האווטאר",
      "availableOutfits": "תלבושות זמינות"
    },
    "selfie": {
      "title": "סלפי וידאו",
      "camera": "מצלמה",
      "cameraPreview": "תצוגה מקדימה של מצלמה",
      "startRecording": "התחל הקלטה",
      "stopRecording": "הפסק הקלטה",
      "rec": "REC",
      "enterPin": "הזן את הקוד שלך ליצירת אווטאר",
      "pinLabel": "PIN",
      "retake": "צלם מחדש",
      "creatingAvatar": "יוצר את האווטאר שלך...",
      "avatarCreated": "האווטאר נוצר בהצלחה",
      "avatarPreviewContentDescription": "תצוגה מקדימה של אווטאר",
      "createAnother": "צור נוסף"
    },
    "mesh": {
      "title": "אווטאר תלת-ממדי",
      "meshViewer": "מציג רשת תלת-ממדית",
      "meshViewerDescription": "מציג רשת תלת-ממדית דורש שילוב WebView או GLSurfaceView",
      "skinTone": "גוון עור",
      "hairStyle": "תסרוקת",
      "accessories": "אביזרים",
      "saveChanges": "שמור שינויים"
    },
    "v2v": {
      "title": "תרגול קולי",
      "nextPhrase": "ביטוי הבא",
      "stop": "עצור",
      "record": "הקלט",
      "mic": "MIC",
      "viewProgress": "הצג התקדמות",
      "analyzingPronunciation": "מנתח הגייה...",
      "pronunciationFeedback": "משוב על הגייה",
      "similarity": "דמיון: {{score}}%",
      "yourProgress": "ההתקדמות שלך",
      "transforms": "טרנספורמציות: {{count}}",
      "improvement": "שיפור: {{score}}%",
      "continuePracticing": "המשך לתרגל"
    },
    "characters": {
      "title": "דמויות",
      "noCharactersFound": "לא נמצאו דמויות לסרט זה",
      "characterCount": "{{count}} דמויות"
    },
    "interactions": {
      "title": "אינטראקציות עם סרטים",
      "noInteractableMovies": "אין סרטים אינטראקטיביים זמינים"
    },
    "feedbackInbox": {
      "title": "תיבת משוב",
      "refreshContentDescription": "רענן",
      "noFeedbackYet": "אין משוב עדיין",
      "feedbackAppearHere": "משוב מאנשי הקשר שלך יופיע כאן",
      "playVoiceMessage": "הפעל הודעה קולית"
    },
    "addContact": {
      "title": "הוסף איש קשר",
      "nameLabel": "שם",
      "phoneLabel": "טלפון",
      "relationship": "קשר",
      "language": "שפה"
    },
    "avatar3d": {
      "title": "אווטאר תלת-ממדי",
      "glbMeshViewer": "מציג רשת GLB",
      "controls": "פקדים",
      "animate": "הנפשה",
      "vertices": "קודקודים",
      "bones": "עצמות",
      "blendShapes": "צורות מיזוג",
      "hasGlb": "כולל GLB",
      "status": "סטטוס: {{value}}"
    }
  }
}
